import { g as mn } from "../_commonjsHelpers-C6fGbg64.js";
import { jsx as gn } from "react/jsx-runtime";
import yn, { useContext as vn, useState as bn } from "react";
class Ot extends Error {
  constructor(t) {
    super(t), this.name = "LocalLogicTracking/RequestError";
  }
}
const Sn = (e) => {
  const t = "https://analytics.locallogic.co/track-v2";
  async function r(i, n) {
    const s = await fetch(`${t}${i}`, {
      body: JSON.stringify(n),
      headers: {
        Accept: "application/json",
        Authorization: `${e.substring(0, 3) !== "V3 " ? "V3 " : ""}${e}`,
        "Content-type": "application/json"
      },
      method: "POST"
    });
    if (!s.ok) {
      let o;
      try {
        o = await s.json();
      } catch {
      }
      const c = o != null && o.message ? o.message : "";
      if (c.toLowerCase() !== "unauthorized")
        throw new Ot(`Could not post tracking event: ${c}`);
    }
  }
  return {
    post: r
  };
};
var Jt, Pr;
function wn() {
  if (Pr) return Jt;
  Pr = 1;
  function e(v) {
    this._maxSize = v, this.clear();
  }
  e.prototype.clear = function() {
    this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
  }, e.prototype.get = function(v) {
    return this._values[v];
  }, e.prototype.set = function(v, S) {
    return this._size >= this._maxSize && this.clear(), v in this._values || this._size++, this._values[v] = S;
  };
  var t = /[^.^\]^[]+|(?=\[\]|\.\.)/g, r = /^\d+$/, i = /^\d/, n = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, s = /^\s*(['"]?)(.*?)(\1)\s*$/, o = 512, c = new e(o), a = new e(o), f = new e(o);
  Jt = {
    Cache: e,
    split: d,
    normalizePath: l,
    setter: function(v) {
      var S = l(v);
      return a.get(v) || a.set(v, function(w, x) {
        for (var C = 0, $ = S.length, D = w; C < $ - 1; ) {
          var N = S[C];
          if (N === "__proto__" || N === "constructor" || N === "prototype")
            return w;
          D = D[S[C++]];
        }
        D[S[C]] = x;
      });
    },
    getter: function(v, S) {
      var b = l(v);
      return f.get(v) || f.set(v, function(x) {
        for (var C = 0, $ = b.length; C < $; )
          if (x != null || !S) x = x[b[C++]];
          else return;
        return x;
      });
    },
    join: function(v) {
      return v.reduce(function(S, b) {
        return S + (h(b) || r.test(b) ? "[" + b + "]" : (S ? "." : "") + b);
      }, "");
    },
    forEach: function(v, S, b) {
      p(Array.isArray(v) ? v : d(v), S, b);
    }
  };
  function l(v) {
    return c.get(v) || c.set(
      v,
      d(v).map(function(S) {
        return S.replace(s, "$2");
      })
    );
  }
  function d(v) {
    return v.match(t) || [""];
  }
  function p(v, S, b) {
    var w = v.length, x, C, $, D;
    for (C = 0; C < w; C++)
      x = v[C], x && (y(x) && (x = '"' + x + '"'), D = h(x), $ = !D && /^\d+$/.test(x), S.call(b, x, D, $, C, v));
  }
  function h(v) {
    return typeof v == "string" && v && ["'", '"'].indexOf(v.charAt(0)) !== -1;
  }
  function m(v) {
    return v.match(i) && !v.match(r);
  }
  function _(v) {
    return n.test(v);
  }
  function y(v) {
    return !h(v) && (m(v) || _(v));
  }
  return Jt;
}
var Le = wn(), Zt, qr;
function xn() {
  if (qr) return Zt;
  qr = 1;
  const e = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, t = (l) => l.match(e) || [], r = (l) => l[0].toUpperCase() + l.slice(1), i = (l, d) => t(l).join(d).toLowerCase(), n = (l) => t(l).reduce(
    (d, p) => `${d}${d ? p[0].toUpperCase() + p.slice(1).toLowerCase() : p.toLowerCase()}`,
    ""
  );
  return Zt = {
    words: t,
    upperFirst: r,
    camelCase: n,
    pascalCase: (l) => r(n(l)),
    snakeCase: (l) => i(l, "_"),
    kebabCase: (l) => i(l, "-"),
    sentenceCase: (l) => r(i(l, " ")),
    titleCase: (l) => t(l).map(r).join(" ")
  }, Zt;
}
var Qt = xn(), mt = { exports: {} }, Ur;
function kn() {
  if (Ur) return mt.exports;
  Ur = 1, mt.exports = function(n) {
    return e(t(n), n);
  }, mt.exports.array = e;
  function e(n, s) {
    var o = n.length, c = new Array(o), a = {}, f = o, l = r(s), d = i(n);
    for (s.forEach(function(h) {
      if (!d.has(h[0]) || !d.has(h[1]))
        throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }); f--; )
      a[f] || p(n[f], f, /* @__PURE__ */ new Set());
    return c;
    function p(h, m, _) {
      if (_.has(h)) {
        var y;
        try {
          y = ", node was:" + JSON.stringify(h);
        } catch {
          y = "";
        }
        throw new Error("Cyclic dependency" + y);
      }
      if (!d.has(h))
        throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(h));
      if (!a[m]) {
        a[m] = !0;
        var v = l.get(h) || /* @__PURE__ */ new Set();
        if (v = Array.from(v), m = v.length) {
          _.add(h);
          do {
            var S = v[--m];
            p(S, d.get(S), _);
          } while (m);
          _.delete(h);
        }
        c[--o] = h;
      }
    }
  }
  function t(n) {
    for (var s = /* @__PURE__ */ new Set(), o = 0, c = n.length; o < c; o++) {
      var a = n[o];
      s.add(a[0]), s.add(a[1]);
    }
    return Array.from(s);
  }
  function r(n) {
    for (var s = /* @__PURE__ */ new Map(), o = 0, c = n.length; o < c; o++) {
      var a = n[o];
      s.has(a[0]) || s.set(a[0], /* @__PURE__ */ new Set()), s.has(a[1]) || s.set(a[1], /* @__PURE__ */ new Set()), s.get(a[0]).add(a[1]);
    }
    return s;
  }
  function i(n) {
    for (var s = /* @__PURE__ */ new Map(), o = 0, c = n.length; o < c; o++)
      s.set(n[o], o);
    return s;
  }
  return mt.exports;
}
var En = kn();
const On = /* @__PURE__ */ mn(En), In = Object.prototype.toString, Mn = Error.prototype.toString, Cn = RegExp.prototype.toString, Tn = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", Dn = /^Symbol\((.*)\)(.*)$/;
function Nn(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function jr(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return Nn(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return Tn.call(e).replace(Dn, "Symbol($1)");
  const i = In.call(e).slice(8, -1);
  return i === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : i === "Error" || e instanceof Error ? "[" + Mn.call(e) + "]" : i === "RegExp" ? Cn.call(e) : null;
}
function Oe(e, t) {
  let r = jr(e, t);
  return r !== null ? r : JSON.stringify(e, function(i, n) {
    let s = jr(this[i], t);
    return s !== null ? s : n;
  }, 2);
}
function _i(e) {
  return e == null ? [] : [].concat(e);
}
let mi, gi, yi, Rn = /\$\{\s*(\w+)\s*\}/g;
mi = Symbol.toStringTag;
class Br {
  constructor(t, r, i, n) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[mi] = "Error", this.name = "ValidationError", this.value = r, this.path = i, this.type = n, this.errors = [], this.inner = [], _i(t).forEach((s) => {
      if (te.isError(s)) {
        this.errors.push(...s.errors);
        const o = s.inner.length ? s.inner : [s];
        this.inner.push(...o);
      } else
        this.errors.push(s);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
gi = Symbol.hasInstance;
yi = Symbol.toStringTag;
let te = class vi extends Error {
  static formatError(t, r) {
    const i = r.label || r.path || "this";
    return i !== r.path && (r = Object.assign({}, r, {
      path: i
    })), typeof t == "string" ? t.replace(Rn, (n, s) => Oe(r[s])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, i, n, s) {
    const o = new Br(t, r, i, n);
    if (s)
      return o;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[yi] = "Error", this.name = o.name, this.message = o.message, this.type = o.type, this.value = o.value, this.path = o.path, this.errors = o.errors, this.inner = o.inner, Error.captureStackTrace && Error.captureStackTrace(this, vi);
  }
  static [gi](t) {
    return Br[Symbol.hasInstance](t) || super[Symbol.hasInstance](t);
  }
}, de = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: i
  }) => {
    const n = i != null && i !== r ? ` (cast from the value \`${Oe(i, !0)}\`).` : ".";
    return t !== "mixed" ? `${e} must be a \`${t}\` type, but the final value was: \`${Oe(r, !0)}\`` + n : `${e} must match the configured type. The validated value was: \`${Oe(r, !0)}\`` + n;
  }
}, Q = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, An = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, or = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, ar = {
  isValue: "${path} field must be ${value}"
}, ur = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, Fn = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, Ln = {
  notType: (e) => {
    const {
      path: t,
      value: r,
      spec: i
    } = e, n = i.types.length;
    if (Array.isArray(r)) {
      if (r.length < n) return `${t} tuple value has too few items, expected a length of ${n} but got ${r.length} for value: \`${Oe(r, !0)}\``;
      if (r.length > n) return `${t} tuple value has too many items, expected a length of ${n} but got ${r.length} for value: \`${Oe(r, !0)}\``;
    }
    return te.formatError(de.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: de,
  string: Q,
  number: An,
  date: or,
  object: ur,
  array: Fn,
  boolean: ar,
  tuple: Ln
});
const _r = (e) => e && e.__isYupSchema__;
class It {
  static fromOptions(t, r) {
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: n,
      otherwise: s
    } = r, o = typeof i == "function" ? i : (...c) => c.every((a) => a === i);
    return new It(t, (c, a) => {
      var f;
      let l = o(...c) ? n : s;
      return (f = l == null ? void 0 : l(a)) != null ? f : a;
    });
  }
  constructor(t, r) {
    this.fn = void 0, this.refs = t, this.refs = t, this.fn = r;
  }
  resolve(t, r) {
    let i = this.refs.map((s) => (
      // TODO: ? operator here?
      s.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)
    )), n = this.fn(i, t, r);
    if (n === void 0 || // @ts-ignore this can be base
    n === t)
      return t;
    if (!_r(n)) throw new TypeError("conditions must return a schema object");
    return n.resolve(r);
  }
}
const gt = {
  context: "$",
  value: "."
};
class Ue {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === gt.context, this.isValue = this.key[0] === gt.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? gt.context : this.isValue ? gt.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && Le.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, i) {
    let n = this.isContext ? i : this.isValue ? t : r;
    return this.getter && (n = this.getter(n || {})), this.map && (n = this.map(n)), n;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
Ue.prototype.__isYupRef = !0;
const ye = (e) => e == null;
function je(e) {
  function t({
    value: r,
    path: i = "",
    options: n,
    originalValue: s,
    schema: o
  }, c, a) {
    const {
      name: f,
      test: l,
      params: d,
      message: p,
      skipAbsent: h
    } = e;
    let {
      parent: m,
      context: _,
      abortEarly: y = o.spec.abortEarly,
      disableStackTrace: v = o.spec.disableStackTrace
    } = n;
    function S(F) {
      return Ue.isRef(F) ? F.getValue(r, m, _) : F;
    }
    function b(F = {}) {
      const I = Object.assign({
        value: r,
        originalValue: s,
        label: o.spec.label,
        path: F.path || i,
        spec: o.spec,
        disableStackTrace: F.disableStackTrace || v
      }, d, F.params);
      for (const G of Object.keys(I)) I[G] = S(I[G]);
      const ce = new te(te.formatError(F.message || p, I), r, I.path, F.type || f, I.disableStackTrace);
      return ce.params = I, ce;
    }
    const w = y ? c : a;
    let x = {
      path: i,
      parent: m,
      type: f,
      from: n.from,
      createError: b,
      resolve: S,
      options: n,
      originalValue: s,
      schema: o
    };
    const C = (F) => {
      te.isError(F) ? w(F) : F ? a(null) : w(b());
    }, $ = (F) => {
      te.isError(F) ? w(F) : c(F);
    };
    if (h && ye(r))
      return C(!0);
    let N;
    try {
      var X;
      if (N = l.call(x, r, x), typeof ((X = N) == null ? void 0 : X.then) == "function") {
        if (n.sync)
          throw new Error(`Validation test of type: "${x.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(N).then(C, $);
      }
    } catch (F) {
      $(F);
      return;
    }
    C(N);
  }
  return t.OPTIONS = e, t;
}
function $n(e, t, r, i = r) {
  let n, s, o;
  return t ? (Le.forEach(t, (c, a, f) => {
    let l = a ? c.slice(1, c.length - 1) : c;
    e = e.resolve({
      context: i,
      parent: n,
      value: r
    });
    let d = e.type === "tuple", p = f ? parseInt(l, 10) : 0;
    if (e.innerType || d) {
      if (d && !f) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${o}" must contain an index to the tuple element, e.g. "${o}[0]"`);
      if (r && p >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${c}, in the path: ${t}. because there is no value at that index. `);
      n = r, r = r && r[p], e = d ? e.spec.types[p] : e.innerType;
    }
    if (!f) {
      if (!e.fields || !e.fields[l]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${o} which is a type: "${e.type}")`);
      n = r, r = r && r[l], e = e.fields[l];
    }
    s = l, o = a ? "[" + c + "]" : "." + c;
  }), {
    schema: e,
    parent: n,
    parentPath: s
  }) : {
    parent: n,
    parentPath: t,
    schema: e
  };
}
class Mt extends Set {
  describe() {
    const t = [];
    for (const r of this.values())
      t.push(Ue.isRef(r) ? r.describe() : r);
    return t;
  }
  resolveAll(t) {
    let r = [];
    for (const i of this.values())
      r.push(t(i));
    return r;
  }
  clone() {
    return new Mt(this.values());
  }
  merge(t, r) {
    const i = this.clone();
    return t.forEach((n) => i.add(n)), r.forEach((n) => i.delete(n)), i;
  }
}
function We(e, t = /* @__PURE__ */ new Map()) {
  if (_r(e) || !e || typeof e != "object") return e;
  if (t.has(e)) return t.get(e);
  let r;
  if (e instanceof Date)
    r = new Date(e.getTime()), t.set(e, r);
  else if (e instanceof RegExp)
    r = new RegExp(e), t.set(e, r);
  else if (Array.isArray(e)) {
    r = new Array(e.length), t.set(e, r);
    for (let i = 0; i < e.length; i++) r[i] = We(e[i], t);
  } else if (e instanceof Map) {
    r = /* @__PURE__ */ new Map(), t.set(e, r);
    for (const [i, n] of e.entries()) r.set(i, We(n, t));
  } else if (e instanceof Set) {
    r = /* @__PURE__ */ new Set(), t.set(e, r);
    for (const i of e) r.add(We(i, t));
  } else if (e instanceof Object) {
    r = {}, t.set(e, r);
    for (const [i, n] of Object.entries(e)) r[i] = We(n, t);
  } else
    throw Error(`Unable to clone ${e}`);
  return r;
}
class oe {
  constructor(t) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new Mt(), this._blacklist = new Mt(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(de.notType);
    }), this.type = t.type, this._typeCheck = t.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, t == null ? void 0 : t.spec), this.withMutation((r) => {
      r.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeCheck = this._typeCheck, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.internalTests = Object.assign({}, this.internalTests), r.exclusiveTests = Object.assign({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = We(Object.assign({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = r, i;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, i = t.clone();
    const n = Object.assign({}, r.spec, i.spec);
    return i.spec = n, i.internalTests = Object.assign({}, r.internalTests, i.internalTests), i._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), i.tests = r.tests, i.exclusiveTests = r.exclusiveTests, i.withMutation((s) => {
      t.tests.forEach((o) => {
        s.test(o.OPTIONS);
      });
    }), i.transforms = [...r.transforms, ...i.transforms], i;
  }
  isType(t) {
    return t == null ? !!(this.spec.nullable && t === null || this.spec.optional && t === void 0) : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let i = r.conditions;
      r = r.clone(), r.conditions = [], r = i.reduce((n, s) => s.resolve(n, t), r), r = r.resolve(t);
    }
    return r;
  }
  resolveOptions(t) {
    var r, i, n, s;
    return Object.assign({}, t, {
      from: t.from || [],
      strict: (r = t.strict) != null ? r : this.spec.strict,
      abortEarly: (i = t.abortEarly) != null ? i : this.spec.abortEarly,
      recursive: (n = t.recursive) != null ? n : this.spec.recursive,
      disableStackTrace: (s = t.disableStackTrace) != null ? s : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(t, r = {}) {
    let i = this.resolve(Object.assign({
      value: t
    }, r)), n = r.assert === "ignore-optionality", s = i._cast(t, r);
    if (r.assert !== !1 && !i.isType(s)) {
      if (n && ye(s))
        return s;
      let o = Oe(t), c = Oe(s);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${i.type}". 

attempted value: ${o} 
` + (c !== o ? `result of cast: ${c}` : ""));
    }
    return s;
  }
  _cast(t, r) {
    let i = t === void 0 ? t : this.transforms.reduce((n, s) => s.call(this, n, t, this), t);
    return i === void 0 && (i = this.getDefault(r)), i;
  }
  _validate(t, r = {}, i, n) {
    let {
      path: s,
      originalValue: o = t,
      strict: c = this.spec.strict
    } = r, a = t;
    c || (a = this._cast(a, Object.assign({
      assert: !1
    }, r)));
    let f = [];
    for (let l of Object.values(this.internalTests))
      l && f.push(l);
    this.runTests({
      path: s,
      value: a,
      originalValue: o,
      options: r,
      tests: f
    }, i, (l) => {
      if (l.length)
        return n(l, a);
      this.runTests({
        path: s,
        value: a,
        originalValue: o,
        options: r,
        tests: this.tests
      }, i, n);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(t, r, i) {
    let n = !1, {
      tests: s,
      value: o,
      originalValue: c,
      path: a,
      options: f
    } = t, l = (_) => {
      n || (n = !0, r(_, o));
    }, d = (_) => {
      n || (n = !0, i(_, o));
    }, p = s.length, h = [];
    if (!p) return d([]);
    let m = {
      value: o,
      originalValue: c,
      path: a,
      options: f,
      schema: this
    };
    for (let _ = 0; _ < s.length; _++) {
      const y = s[_];
      y(m, l, function(S) {
        S && (Array.isArray(S) ? h.push(...S) : h.push(S)), --p <= 0 && d(h);
      });
    }
  }
  asNestedTest({
    key: t,
    index: r,
    parent: i,
    parentPath: n,
    originalParent: s,
    options: o
  }) {
    const c = t ?? r;
    if (c == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const a = typeof c == "number";
    let f = i[c];
    const l = Object.assign({}, o, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: i,
      value: f,
      originalValue: s[c],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [a ? "index" : "key"]: c,
      path: a || c.includes(".") ? `${n || ""}[${a ? c : `"${c}"`}]` : (n ? `${n}.` : "") + t
    });
    return (d, p, h) => this.resolve(l)._validate(f, l, p, h);
  }
  validate(t, r) {
    var i;
    let n = this.resolve(Object.assign({}, r, {
      value: t
    })), s = (i = r == null ? void 0 : r.disableStackTrace) != null ? i : n.spec.disableStackTrace;
    return new Promise((o, c) => n._validate(t, r, (a, f) => {
      te.isError(a) && (a.value = f), c(a);
    }, (a, f) => {
      a.length ? c(new te(a, f, void 0, void 0, s)) : o(f);
    }));
  }
  validateSync(t, r) {
    var i;
    let n = this.resolve(Object.assign({}, r, {
      value: t
    })), s, o = (i = r == null ? void 0 : r.disableStackTrace) != null ? i : n.spec.disableStackTrace;
    return n._validate(t, Object.assign({}, r, {
      sync: !0
    }), (c, a) => {
      throw te.isError(c) && (c.value = a), c;
    }, (c, a) => {
      if (c.length) throw new te(c, t, void 0, void 0, o);
      s = a;
    }), s;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (i) => {
      if (te.isError(i)) return !1;
      throw i;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (i) {
      if (te.isError(i)) return !1;
      throw i;
    }
  }
  _getDefault(t) {
    let r = this.spec.default;
    return r == null ? r : typeof r == "function" ? r.call(this, t) : We(r);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault(t);
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    return this.clone({
      strict: t
    });
  }
  nullability(t, r) {
    const i = this.clone({
      nullable: t
    });
    return i.internalTests.nullable = je({
      message: r,
      name: "nullable",
      test(n) {
        return n === null ? this.schema.spec.nullable : !0;
      }
    }), i;
  }
  optionality(t, r) {
    const i = this.clone({
      optional: t
    });
    return i.internalTests.optionality = je({
      message: r,
      name: "optionality",
      test(n) {
        return n === void 0 ? this.schema.spec.optional : !0;
      }
    }), i;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(t = de.defined) {
    return this.optionality(!1, t);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(t = de.notNull) {
    return this.nullability(!1, t);
  }
  required(t = de.required) {
    return this.clone().withMutation((r) => r.nonNullable(t).defined(t));
  }
  notRequired() {
    return this.clone().withMutation((t) => t.nullable().optional());
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = de.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let i = this.clone(), n = je(r), s = r.exclusive || r.name && i.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (i.exclusiveTests[r.name] = !!r.exclusive), i.tests = i.tests.filter((o) => !(o.OPTIONS.name === r.name && (s || o.OPTIONS.test === n.OPTIONS.test))), i.tests.push(n), i;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let i = this.clone(), n = _i(t).map((s) => new Ue(s));
    return n.forEach((s) => {
      s.isSibling && i.deps.push(s.key);
    }), i.conditions.push(typeof r == "function" ? new It(n, r) : It.fromOptions(n, r)), i;
  }
  typeError(t) {
    let r = this.clone();
    return r.internalTests.typeError = je({
      message: t,
      name: "typeError",
      skipAbsent: !0,
      test(i) {
        return this.schema._typeCheck(i) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), r;
  }
  oneOf(t, r = de.oneOf) {
    let i = this.clone();
    return t.forEach((n) => {
      i._whitelist.add(n), i._blacklist.delete(n);
    }), i.internalTests.whiteList = je({
      message: r,
      name: "oneOf",
      skipAbsent: !0,
      test(n) {
        let s = this.schema._whitelist, o = s.resolveAll(this.resolve);
        return o.includes(n) ? !0 : this.createError({
          params: {
            values: Array.from(s).join(", "),
            resolved: o
          }
        });
      }
    }), i;
  }
  notOneOf(t, r = de.notOneOf) {
    let i = this.clone();
    return t.forEach((n) => {
      i._blacklist.add(n), i._whitelist.delete(n);
    }), i.internalTests.blacklist = je({
      message: r,
      name: "notOneOf",
      test(n) {
        let s = this.schema._blacklist, o = s.resolveAll(this.resolve);
        return o.includes(n) ? this.createError({
          params: {
            values: Array.from(s).join(", "),
            resolved: o
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), {
      label: i,
      meta: n,
      optional: s,
      nullable: o
    } = r.spec;
    return {
      meta: n,
      label: i,
      optional: s,
      nullable: o,
      default: r.getDefault(t),
      type: r.type,
      oneOf: r._whitelist.describe(),
      notOneOf: r._blacklist.describe(),
      tests: r.tests.map((a) => ({
        name: a.OPTIONS.name,
        params: a.OPTIONS.params
      })).filter((a, f, l) => l.findIndex((d) => d.name === a.name) === f)
    };
  }
}
oe.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) oe.prototype[`${e}At`] = function(t, r, i = {}) {
  const {
    parent: n,
    parentPath: s,
    schema: o
  } = $n(this, t, r, i.context);
  return o[e](n && n[s], Object.assign({}, i, {
    parent: n,
    path: t
  }));
};
for (const e of ["equals", "is"]) oe.prototype[e] = oe.prototype.oneOf;
for (const e of ["not", "nope"]) oe.prototype[e] = oe.prototype.notOneOf;
function bi() {
  return new Si();
}
class Si extends oe {
  constructor() {
    super({
      type: "boolean",
      check(t) {
        return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
      }
    }), this.withMutation(() => {
      this.transform((t, r, i) => {
        if (i.spec.coerce && !i.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  isTrue(t = ar.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return ye(r) || r === !0;
      }
    });
  }
  isFalse(t = ar.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return ye(r) || r === !1;
      }
    });
  }
  default(t) {
    return super.default(t);
  }
  defined(t) {
    return super.defined(t);
  }
  optional() {
    return super.optional();
  }
  required(t) {
    return super.required(t);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(t) {
    return super.nonNullable(t);
  }
  strip(t) {
    return super.strip(t);
  }
}
bi.prototype = Si.prototype;
const Pn = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function qn(e) {
  const t = cr(e);
  if (!t) return Date.parse ? Date.parse(e) : Number.NaN;
  if (t.z === void 0 && t.plusMinus === void 0)
    return new Date(t.year, t.month, t.day, t.hour, t.minute, t.second, t.millisecond).valueOf();
  let r = 0;
  return t.z !== "Z" && t.plusMinus !== void 0 && (r = t.hourOffset * 60 + t.minuteOffset, t.plusMinus === "+" && (r = 0 - r)), Date.UTC(t.year, t.month, t.day, t.hour, t.minute + r, t.second, t.millisecond);
}
function cr(e) {
  var t, r;
  const i = Pn.exec(e);
  return i ? {
    year: _e(i[1]),
    month: _e(i[2], 1) - 1,
    day: _e(i[3], 1),
    hour: _e(i[4]),
    minute: _e(i[5]),
    second: _e(i[6]),
    millisecond: i[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      _e(i[7].substring(0, 3))
    ) : 0,
    precision: (t = (r = i[7]) == null ? void 0 : r.length) != null ? t : void 0,
    z: i[8] || void 0,
    plusMinus: i[9] || void 0,
    hourOffset: _e(i[10]),
    minuteOffset: _e(i[11])
  } : null;
}
function _e(e, t = 0) {
  return Number(e) || t;
}
let Un = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), jn = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), Bn = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, zn = "^\\d{4}-\\d{2}-\\d{2}", Wn = "\\d{2}:\\d{2}:\\d{2}", Hn = "(([+-]\\d{2}(:?\\d{2})?)|Z)", Vn = new RegExp(`${zn}T${Wn}(\\.\\d+)?${Hn}$`), Gn = (e) => ye(e) || e === e.trim(), Yn = {}.toString();
function me() {
  return new wi();
}
class wi extends oe {
  constructor() {
    super({
      type: "string",
      check(t) {
        return t instanceof String && (t = t.valueOf()), typeof t == "string";
      }
    }), this.withMutation(() => {
      this.transform((t, r, i) => {
        if (!i.spec.coerce || i.isType(t) || Array.isArray(t)) return t;
        const n = t != null && t.toString ? t.toString() : t;
        return n === Yn ? t : n;
      });
    });
  }
  required(t) {
    return super.required(t).withMutation((r) => r.test({
      message: t || de.required,
      name: "required",
      skipAbsent: !0,
      test: (i) => !!i.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((t) => (t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t));
  }
  length(t, r = Q.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(i) {
        return i.length === this.resolve(t);
      }
    });
  }
  min(t, r = Q.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(i) {
        return i.length >= this.resolve(t);
      }
    });
  }
  max(t, r = Q.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(i) {
        return i.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let i = !1, n, s;
    return r && (typeof r == "object" ? {
      excludeEmptyString: i = !1,
      message: n,
      name: s
    } = r : n = r), this.test({
      name: s || "matches",
      message: n || Q.matches,
      params: {
        regex: t
      },
      skipAbsent: !0,
      test: (o) => o === "" && i || o.search(t) !== -1
    });
  }
  email(t = Q.email) {
    return this.matches(Un, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Q.url) {
    return this.matches(jn, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Q.uuid) {
    return this.matches(Bn, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  datetime(t) {
    let r = "", i, n;
    return t && (typeof t == "object" ? {
      message: r = "",
      allowOffset: i = !1,
      precision: n = void 0
    } = t : r = t), this.matches(Vn, {
      name: "datetime",
      message: r || Q.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: r || Q.datetime_offset,
      params: {
        allowOffset: i
      },
      skipAbsent: !0,
      test: (s) => {
        if (!s || i) return !0;
        const o = cr(s);
        return o ? !!o.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: r || Q.datetime_precision,
      params: {
        precision: n
      },
      skipAbsent: !0,
      test: (s) => {
        if (!s || n == null) return !0;
        const o = cr(s);
        return o ? o.precision === n : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Q.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: Gn
    });
  }
  lowercase(t = Q.lowercase) {
    return this.transform((r) => ye(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => ye(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = Q.uppercase) {
    return this.transform((r) => ye(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => ye(r) || r === r.toUpperCase()
    });
  }
}
me.prototype = wi.prototype;
let Xn = /* @__PURE__ */ new Date(""), Kn = (e) => Object.prototype.toString.call(e) === "[object Date]";
class mr extends oe {
  constructor() {
    super({
      type: "date",
      check(t) {
        return Kn(t) && !isNaN(t.getTime());
      }
    }), this.withMutation(() => {
      this.transform((t, r, i) => !i.spec.coerce || i.isType(t) || t === null ? t : (t = qn(t), isNaN(t) ? mr.INVALID_DATE : new Date(t)));
    });
  }
  prepareParam(t, r) {
    let i;
    if (Ue.isRef(t))
      i = t;
    else {
      let n = this.cast(t);
      if (!this._typeCheck(n)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = n;
    }
    return i;
  }
  min(t, r = or.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(n) {
        return n >= this.resolve(i);
      }
    });
  }
  max(t, r = or.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(n) {
        return n <= this.resolve(i);
      }
    });
  }
}
mr.INVALID_DATE = Xn;
function Jn(e, t = []) {
  let r = [], i = /* @__PURE__ */ new Set(), n = new Set(t.map(([o, c]) => `${o}-${c}`));
  function s(o, c) {
    let a = Le.split(o)[0];
    i.add(a), n.has(`${c}-${a}`) || r.push([c, a]);
  }
  for (const o of Object.keys(e)) {
    let c = e[o];
    i.add(o), Ue.isRef(c) && c.isSibling ? s(c.path, o) : _r(c) && "deps" in c && c.deps.forEach((a) => s(a, o));
  }
  return On.array(Array.from(i), r).reverse();
}
function zr(e, t) {
  let r = 1 / 0;
  return e.some((i, n) => {
    var s;
    if ((s = t.path) != null && s.includes(i))
      return r = n, !0;
  }), r;
}
function xi(e) {
  return (t, r) => zr(e, t) - zr(e, r);
}
const Zn = (e, t, r) => {
  if (typeof e != "string")
    return e;
  let i = e;
  try {
    i = JSON.parse(e);
  } catch {
  }
  return r.isType(i) ? i : e;
};
function wt(e) {
  if ("fields" in e) {
    const t = {};
    for (const [r, i] of Object.entries(e.fields))
      t[r] = wt(i);
    return e.setFields(t);
  }
  if (e.type === "array") {
    const t = e.optional();
    return t.innerType && (t.innerType = wt(t.innerType)), t;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(wt)
  }) : "optional" in e ? e.optional() : e;
}
const Qn = (e, t) => {
  const r = [...Le.normalizePath(t)];
  if (r.length === 1) return r[0] in e;
  let i = r.pop(), n = Le.getter(Le.join(r), !0)(e);
  return !!(n && i in n);
};
let Wr = (e) => Object.prototype.toString.call(e) === "[object Object]";
function es(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((i) => r.indexOf(i) === -1);
}
const ts = xi([]);
function xt(e) {
  return new ki(e);
}
class ki extends oe {
  constructor(t) {
    super({
      type: "object",
      check(r) {
        return Wr(r) || typeof r == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = ts, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      t && this.shape(t);
    });
  }
  _cast(t, r = {}) {
    var i;
    let n = super._cast(t, r);
    if (n === void 0) return this.getDefault(r);
    if (!this._typeCheck(n)) return n;
    let s = this.fields, o = (i = r.stripUnknown) != null ? i : this.spec.noUnknown, c = [].concat(this._nodes, Object.keys(n).filter((d) => !this._nodes.includes(d))), a = {}, f = Object.assign({}, r, {
      parent: a,
      __validating: r.__validating || !1
    }), l = !1;
    for (const d of c) {
      let p = s[d], h = d in n;
      if (p) {
        let m, _ = n[d];
        f.path = (r.path ? `${r.path}.` : "") + d, p = p.resolve({
          value: _,
          context: r.context,
          parent: a
        });
        let y = p instanceof oe ? p.spec : void 0, v = y == null ? void 0 : y.strict;
        if (y != null && y.strip) {
          l = l || d in n;
          continue;
        }
        m = !r.__validating || !v ? (
          // TODO: use _cast, this is double resolving
          p.cast(n[d], f)
        ) : n[d], m !== void 0 && (a[d] = m);
      } else h && !o && (a[d] = n[d]);
      (h !== d in a || a[d] !== n[d]) && (l = !0);
    }
    return l ? a : n;
  }
  _validate(t, r = {}, i, n) {
    let {
      from: s = [],
      originalValue: o = t,
      recursive: c = this.spec.recursive
    } = r;
    r.from = [{
      schema: this,
      value: o
    }, ...s], r.__validating = !0, r.originalValue = o, super._validate(t, r, i, (a, f) => {
      if (!c || !Wr(f)) {
        n(a, f);
        return;
      }
      o = o || f;
      let l = [];
      for (let d of this._nodes) {
        let p = this.fields[d];
        !p || Ue.isRef(p) || l.push(p.asNestedTest({
          options: r,
          key: d,
          parent: f,
          parentPath: r.path,
          originalParent: o
        }));
      }
      this.runTests({
        tests: l,
        value: f,
        originalValue: o,
        options: r
      }, i, (d) => {
        n(d.sort(this._sortErrors).concat(a), f);
      });
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = Object.assign({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), i = r.fields;
    for (let [n, s] of Object.entries(this.fields)) {
      const o = i[n];
      i[n] = o === void 0 ? s : o;
    }
    return r.withMutation((n) => (
      // XXX: excludes here is wrong
      n.setFields(i, [...this._excludedEdges, ...t._excludedEdges])
    ));
  }
  _getDefault(t) {
    if ("default" in this.spec)
      return super._getDefault(t);
    if (!this._nodes.length)
      return;
    let r = {};
    return this._nodes.forEach((i) => {
      var n;
      const s = this.fields[i];
      let o = t;
      (n = o) != null && n.value && (o = Object.assign({}, o, {
        parent: o.value,
        value: o.value[i]
      })), r[i] = s && "getDefault" in s ? s.getDefault(o) : void 0;
    }), r;
  }
  setFields(t, r) {
    let i = this.clone();
    return i.fields = t, i._nodes = Jn(t, r), i._sortErrors = xi(Object.keys(t)), r && (i._excludedEdges = r), i;
  }
  shape(t, r = []) {
    return this.clone().withMutation((i) => {
      let n = i._excludedEdges;
      return r.length && (Array.isArray(r[0]) || (r = [r]), n = [...i._excludedEdges, ...r]), i.setFields(Object.assign(i.fields, t), n);
    });
  }
  partial() {
    const t = {};
    for (const [r, i] of Object.entries(this.fields))
      t[r] = "optional" in i && i.optional instanceof Function ? i.optional() : i;
    return this.setFields(t);
  }
  deepPartial() {
    return wt(this);
  }
  pick(t) {
    const r = {};
    for (const i of t)
      this.fields[i] && (r[i] = this.fields[i]);
    return this.setFields(r, this._excludedEdges.filter(([i, n]) => t.includes(i) && t.includes(n)));
  }
  omit(t) {
    const r = [];
    for (const i of Object.keys(this.fields))
      t.includes(i) || r.push(i);
    return this.pick(r);
  }
  from(t, r, i) {
    let n = Le.getter(t, !0);
    return this.transform((s) => {
      if (!s) return s;
      let o = s;
      return Qn(s, t) && (o = Object.assign({}, s), i || delete o[t], o[r] = n(s)), o;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(Zn);
  }
  noUnknown(t = !0, r = ur.noUnknown) {
    typeof t != "boolean" && (r = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(n) {
        if (n == null) return !0;
        const s = es(this.schema, n);
        return !t || s.length === 0 || this.createError({
          params: {
            unknown: s.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, r = ur.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => {
      if (!r) return r;
      const i = {};
      for (const n of Object.keys(r)) i[t(n)] = r[n];
      return i;
    });
  }
  camelCase() {
    return this.transformKeys(Qt.camelCase);
  }
  snakeCase() {
    return this.transformKeys(Qt.snakeCase);
  }
  constantCase() {
    return this.transformKeys((t) => Qt.snakeCase(t).toUpperCase());
  }
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), i = super.describe(t);
    i.fields = {};
    for (const [s, o] of Object.entries(r.fields)) {
      var n;
      let c = t;
      (n = c) != null && n.value && (c = Object.assign({}, c, {
        parent: c.value,
        value: c.value[s]
      })), i.fields[s] = o.describe(c);
    }
    return i;
  }
}
xt.prototype = ki.prototype;
class Ei extends Error {
  constructor(t) {
    super(t), this.name = "LocalLogicTracking/UnknownError";
  }
}
class Oi extends Error {
  constructor(t) {
    super(t), this.name = "LocalLogicTracking/ValidationError";
  }
}
const Hr = (e) => {
  throw e instanceof te ? new Oi(e.message) : e instanceof Ot ? new Ot(e.message) : new Ei(e.message);
}, rs = (e, t, r) => {
  const i = r.value;
  return r.value = function(...n) {
    try {
      const s = i.apply(this, n);
      return s && s instanceof Promise ? s.catch((o) => {
        Hr(o);
      }) : s;
    } catch (s) {
      Hr(s);
    }
  }, r;
}, is = ["1.0.0"], ns = xt({
  event_type: me().required(),
  event_version: me().required().oneOf(is),
  isTestEvent: bi(),
  meta: xt({
    user_id: me(),
    session_id: me(),
    page_load_id: me(),
    product_version: me(),
    client_id: me(),
    product_name: me().required()
  }),
  attributes: xt({})
}), ss = (e) => async (t) => {
  const r = await ns.validate(t), {
    event_type: i,
    isTestEvent: n,
    event_version: s,
    meta: o,
    attributes: c
  } = r;
  try {
    return await e.post("/record", {
      params: {
        event_type: i,
        event_version: s,
        isTestEvent: n,
        meta: o,
        attributes: c
      }
    });
  } catch (a) {
    if (a instanceof TypeError && (a.message.toLowerCase().includes("networkerror") || a.message.toLowerCase().includes("load failed") || a.message.toLowerCase().includes("failed to fetch")) || a instanceof DOMException && a.message.toLowerCase().includes("aborted") || a instanceof TypeError && a.message.toLowerCase().includes("cancelled") || a instanceof TypeError && a.message.toLowerCase().includes("annulé"))
      return;
    throw a;
  }
};
var os = Object.defineProperty, as = Object.getOwnPropertyDescriptor, us = (e, t, r, i) => {
  for (var n = as(t, r), s = e.length - 1, o; s >= 0; s--)
    (o = e[s]) && (n = o(t, r, n) || n);
  return n && os(t, r, n), n;
};
class Ii {
  constructor(t) {
    this.requests = Sn(t);
  }
  postEvent(t) {
    const r = {
      ...t,
      meta: {
        ...t.meta,
        event_time: /* @__PURE__ */ new Date()
      }
    };
    return ss(this.requests)(r);
  }
}
us([
  rs
], Ii.prototype, "postEvent");
const cs = (e) => new Ii(e);
var V;
(function(e) {
  e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment";
})(V || (V = {}));
function ls(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function tt(e) {
  const t = e == null ? void 0 : e.host;
  return (t == null ? void 0 : t.shadowRoot) === e;
}
function rt(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function fs(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;")), e;
}
function ds(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3)
    return t;
  const r = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? r.push("layer") : e.layerName && r.push(`layer(${e.layerName})`), e.supportsText && r.push(`supports(${e.supportsText})`), e.media.length && r.push(e.media.mediaText), r.join(" ") + ";";
}
function Ct(e) {
  try {
    const t = e.rules || e.cssRules;
    return t ? fs(Array.from(t, Mi).join("")) : null;
  } catch {
    return null;
  }
}
function Mi(e) {
  let t;
  if (hs(e))
    try {
      t = Ct(e.styleSheet) || ds(e);
    } catch {
    }
  else if (_s(e) && e.selectorText.includes(":"))
    return ps(e.cssText);
  return t || e.cssText;
}
function ps(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function hs(e) {
  return "styleSheet" in e;
}
function _s(e) {
  return "selectorText" in e;
}
class Ci {
  constructor() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t) {
    var r;
    if (!t)
      return -1;
    const i = (r = this.getMeta(t)) === null || r === void 0 ? void 0 : r.id;
    return i ?? -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  removeNodeFromMap(t) {
    const r = this.getId(t);
    this.idNodeMap.delete(r), t.childNodes && t.childNodes.forEach((i) => this.removeNodeFromMap(i));
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, r) {
    const i = r.id;
    this.idNodeMap.set(i, t), this.nodeMetaMap.set(t, r);
  }
  replace(t, r) {
    const i = this.getNode(t);
    if (i) {
      const n = this.nodeMetaMap.get(i);
      n && this.nodeMetaMap.set(r, n);
    }
    this.idNodeMap.set(t, r);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function ms() {
  return new Ci();
}
function gr({ element: e, maskInputOptions: t, tagName: r, type: i, value: n, maskInputFn: s }) {
  let o = n || "";
  const c = i && $e(i);
  return (t[r.toLowerCase()] || c && t[c]) && (s ? o = s(o, e) : o = "*".repeat(o.length)), o;
}
function $e(e) {
  return e.toLowerCase();
}
const Vr = "__rrweb_original__";
function gs(e) {
  const t = e.getContext("2d");
  if (!t)
    return !0;
  const r = 50;
  for (let i = 0; i < e.width; i += r)
    for (let n = 0; n < e.height; n += r) {
      const s = t.getImageData, o = Vr in s ? s[Vr] : s;
      if (new Uint32Array(o.call(t, i, n, Math.min(r, e.width - i), Math.min(r, e.height - n)).data.buffer).some((a) => a !== 0))
        return !1;
    }
  return !0;
}
function yr(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? $e(t) : null;
}
function Ti(e, t) {
  var r;
  let i;
  try {
    i = new URL(e, t ?? window.location.href);
  } catch {
    return null;
  }
  const n = /\.([0-9a-z]+)(?:$)/i, s = i.pathname.match(n);
  return (r = s == null ? void 0 : s[1]) !== null && r !== void 0 ? r : null;
}
let ys = 1;
const vs = new RegExp("[^a-z0-9-_:]"), ot = -2;
function Di() {
  return ys++;
}
function bs(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = $e(e.tagName);
  return vs.test(t) ? "div" : t;
}
function Ss(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
let Be, Gr;
const ws = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, xs = /^(?:[a-z+]+:)?\/\//i, ks = /^www\..*/i, Es = /^(data:)([^,]*),(.*)/i;
function Tt(e, t) {
  return (e || "").replace(ws, (r, i, n, s, o, c) => {
    const a = n || o || c, f = i || s || "";
    if (!a)
      return r;
    if (xs.test(a) || ks.test(a))
      return `url(${f}${a}${f})`;
    if (Es.test(a))
      return `url(${f}${a}${f})`;
    if (a[0] === "/")
      return `url(${f}${Ss(t) + a}${f})`;
    const l = t.split("/"), d = a.split("/");
    l.pop();
    for (const p of d)
      p !== "." && (p === ".." ? l.pop() : l.push(p));
    return `url(${f}${l.join("/")}${f})`;
  });
}
const Os = /^[^ \t\n\r\u000c]+/, Is = /^[, \t\n\r\u000c]+/;
function Ms(e, t) {
  if (t.trim() === "")
    return t;
  let r = 0;
  function i(s) {
    let o;
    const c = s.exec(t.substring(r));
    return c ? (o = c[0], r += o.length, o) : "";
  }
  const n = [];
  for (; i(Is), !(r >= t.length); ) {
    let s = i(Os);
    if (s.slice(-1) === ",")
      s = He(e, s.substring(0, s.length - 1)), n.push(s);
    else {
      let o = "";
      s = He(e, s);
      let c = !1;
      for (; ; ) {
        const a = t.charAt(r);
        if (a === "") {
          n.push((s + o).trim());
          break;
        } else if (c)
          a === ")" && (c = !1);
        else if (a === ",") {
          r += 1, n.push((s + o).trim());
          break;
        } else a === "(" && (c = !0);
        o += a, r += 1;
      }
    }
  }
  return n.join(", ");
}
function He(e, t) {
  if (!t || t.trim() === "")
    return t;
  const r = e.createElement("a");
  return r.href = t, r.href;
}
function Cs(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function vr() {
  const e = document.createElement("a");
  return e.href = "", e.href;
}
function Ni(e, t, r, i) {
  return i && (r === "src" || r === "href" && !(t === "use" && i[0] === "#") || r === "xlink:href" && i[0] !== "#" || r === "background" && (t === "table" || t === "td" || t === "th") ? He(e, i) : r === "srcset" ? Ms(e, i) : r === "style" ? Tt(i, vr()) : t === "object" && r === "data" ? He(e, i) : i);
}
function Ri(e, t, r) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function Ts(e, t, r) {
  try {
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let i = e.classList.length; i--; ) {
        const n = e.classList[i];
        if (t.test(n))
          return !0;
      }
    if (r)
      return e.matches(r);
  } catch {
  }
  return !1;
}
function Dt(e, t, r) {
  if (!e)
    return !1;
  if (e.nodeType !== e.ELEMENT_NODE)
    return r ? Dt(e.parentNode, t, r) : !1;
  for (let i = e.classList.length; i--; ) {
    const n = e.classList[i];
    if (t.test(n))
      return !0;
  }
  return r ? Dt(e.parentNode, t, r) : !1;
}
function Ai(e, t, r, i) {
  try {
    const n = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    if (n === null)
      return !1;
    if (typeof t == "string") {
      if (i) {
        if (n.closest(`.${t}`))
          return !0;
      } else if (n.classList.contains(t))
        return !0;
    } else if (Dt(n, t, i))
      return !0;
    if (r) {
      if (i) {
        if (n.closest(r))
          return !0;
      } else if (n.matches(r))
        return !0;
    }
  } catch {
  }
  return !1;
}
function Ds(e, t, r) {
  const i = e.contentWindow;
  if (!i)
    return;
  let n = !1, s;
  try {
    s = i.document.readyState;
  } catch {
    return;
  }
  if (s !== "complete") {
    const c = setTimeout(() => {
      n || (t(), n = !0);
    }, r);
    e.addEventListener("load", () => {
      clearTimeout(c), n = !0, t();
    });
    return;
  }
  const o = "about:blank";
  if (i.location.href !== o || e.src === o || e.src === "")
    return setTimeout(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function Ns(e, t, r) {
  let i = !1, n;
  try {
    n = e.sheet;
  } catch {
    return;
  }
  if (n)
    return;
  const s = setTimeout(() => {
    i || (t(), i = !0);
  }, r);
  e.addEventListener("load", () => {
    clearTimeout(s), i = !0, t();
  });
}
function Rs(e, t) {
  const { doc: r, mirror: i, blockClass: n, blockSelector: s, needsMask: o, inlineStylesheet: c, maskInputOptions: a = {}, maskTextFn: f, maskInputFn: l, dataURLOptions: d = {}, inlineImages: p, recordCanvas: h, keepIframeSrcFn: m, newlyAddedElement: _ = !1 } = t, y = As(r, i);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: V.Document,
        childNodes: [],
        compatMode: e.compatMode
      } : {
        type: V.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: V.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: y
      };
    case e.ELEMENT_NODE:
      return Ls(e, {
        doc: r,
        blockClass: n,
        blockSelector: s,
        inlineStylesheet: c,
        maskInputOptions: a,
        maskInputFn: l,
        dataURLOptions: d,
        inlineImages: p,
        recordCanvas: h,
        keepIframeSrcFn: m,
        newlyAddedElement: _,
        rootId: y
      });
    case e.TEXT_NODE:
      return Fs(e, {
        needsMask: o,
        maskTextFn: f,
        rootId: y
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: V.CDATA,
        textContent: "",
        rootId: y
      };
    case e.COMMENT_NODE:
      return {
        type: V.Comment,
        textContent: e.textContent || "",
        rootId: y
      };
    default:
      return !1;
  }
}
function As(e, t) {
  if (!t.hasNode(e))
    return;
  const r = t.getId(e);
  return r === 1 ? void 0 : r;
}
function Fs(e, t) {
  var r;
  const { needsMask: i, maskTextFn: n, rootId: s } = t, o = e.parentNode && e.parentNode.tagName;
  let c = e.textContent;
  const a = o === "STYLE" ? !0 : void 0, f = o === "SCRIPT" ? !0 : void 0;
  if (a && c) {
    try {
      e.nextSibling || e.previousSibling || !((r = e.parentNode.sheet) === null || r === void 0) && r.cssRules && (c = Ct(e.parentNode.sheet));
    } catch (l) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${l}`, e);
    }
    c = Tt(c, vr());
  }
  return f && (c = "SCRIPT_PLACEHOLDER"), !a && !f && c && i && (c = n ? n(c, e.parentElement) : c.replace(/[\S]/g, "*")), {
    type: V.Text,
    textContent: c || "",
    isStyle: a,
    rootId: s
  };
}
function Ls(e, t) {
  const { doc: r, blockClass: i, blockSelector: n, inlineStylesheet: s, maskInputOptions: o = {}, maskInputFn: c, dataURLOptions: a = {}, inlineImages: f, recordCanvas: l, keepIframeSrcFn: d, newlyAddedElement: p = !1, rootId: h } = t, m = Ts(e, i, n), _ = bs(e);
  let y = {};
  const v = e.attributes.length;
  for (let b = 0; b < v; b++) {
    const w = e.attributes[b];
    Ri(_, w.name, w.value) || (y[w.name] = Ni(r, _, $e(w.name), w.value));
  }
  if (_ === "link" && s) {
    const b = Array.from(r.styleSheets).find((x) => x.href === e.href);
    let w = null;
    b && (w = Ct(b)), w && (delete y.rel, delete y.href, y._cssText = Tt(w, b.href));
  }
  if (_ === "style" && e.sheet && !(e.innerText || e.textContent || "").trim().length) {
    const b = Ct(e.sheet);
    b && (y._cssText = Tt(b, vr()));
  }
  if (_ === "input" || _ === "textarea" || _ === "select") {
    const b = e.value, w = e.checked;
    y.type !== "radio" && y.type !== "checkbox" && y.type !== "submit" && y.type !== "button" && b ? y.value = gr({
      element: e,
      type: yr(e),
      tagName: _,
      value: b,
      maskInputOptions: o,
      maskInputFn: c
    }) : w && (y.checked = w);
  }
  if (_ === "option" && (e.selected && !o.select ? y.selected = !0 : delete y.selected), _ === "canvas" && l) {
    if (e.__context === "2d")
      gs(e) || (y.rr_dataURL = e.toDataURL(a.type, a.quality));
    else if (!("__context" in e)) {
      const b = e.toDataURL(a.type, a.quality), w = document.createElement("canvas");
      w.width = e.width, w.height = e.height;
      const x = w.toDataURL(a.type, a.quality);
      b !== x && (y.rr_dataURL = b);
    }
  }
  if (_ === "img" && f) {
    Be || (Be = r.createElement("canvas"), Gr = Be.getContext("2d"));
    const b = e, w = b.crossOrigin;
    b.crossOrigin = "anonymous";
    const x = () => {
      b.removeEventListener("load", x);
      try {
        Be.width = b.naturalWidth, Be.height = b.naturalHeight, Gr.drawImage(b, 0, 0), y.rr_dataURL = Be.toDataURL(a.type, a.quality);
      } catch (C) {
        console.warn(`Cannot inline img src=${b.currentSrc}! Error: ${C}`);
      }
      w ? y.crossOrigin = w : b.removeAttribute("crossorigin");
    };
    b.complete && b.naturalWidth !== 0 ? x() : b.addEventListener("load", x);
  }
  if (_ === "audio" || _ === "video") {
    const b = y;
    b.rr_mediaState = e.paused ? "paused" : "played", b.rr_mediaCurrentTime = e.currentTime, b.rr_mediaPlaybackRate = e.playbackRate, b.rr_mediaMuted = e.muted, b.rr_mediaLoop = e.loop, b.rr_mediaVolume = e.volume;
  }
  if (p || (e.scrollLeft && (y.rr_scrollLeft = e.scrollLeft), e.scrollTop && (y.rr_scrollTop = e.scrollTop)), m) {
    const { width: b, height: w } = e.getBoundingClientRect();
    y = {
      class: y.class,
      rr_width: `${b}px`,
      rr_height: `${w}px`
    };
  }
  _ === "iframe" && !d(y.src) && (e.contentDocument || (y.rr_src = y.src), delete y.src);
  let S;
  try {
    customElements.get(_) && (S = !0);
  } catch {
  }
  return {
    type: V.Element,
    tagName: _,
    attributes: y,
    childNodes: [],
    isSVG: Cs(e) || void 0,
    needBlock: m,
    rootId: h,
    isCustom: S
  };
}
function q(e) {
  return e == null ? "" : e.toLowerCase();
}
function $s(e, t) {
  if (t.comment && e.type === V.Comment)
    return !0;
  if (e.type === V.Element) {
    if (t.script && (e.tagName === "script" || e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") && e.attributes.as === "script" || e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && Ti(e.attributes.href) === "js"))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (q(e.attributes.name).match(/^msapplication-tile(image|color)$/) || q(e.attributes.name) === "application-name" || q(e.attributes.rel) === "icon" || q(e.attributes.rel) === "apple-touch-icon" || q(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && q(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (q(e.attributes.property).match(/^(og|twitter|fb):/) || q(e.attributes.name).match(/^(og|twitter):/) || q(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (q(e.attributes.name) === "robots" || q(e.attributes.name) === "googlebot" || q(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (q(e.attributes.name) === "author" || q(e.attributes.name) === "generator" || q(e.attributes.name) === "framework" || q(e.attributes.name) === "publisher" || q(e.attributes.name) === "progid" || q(e.attributes.property).match(/^article:/) || q(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (q(e.attributes.name) === "google-site-verification" || q(e.attributes.name) === "yandex-verification" || q(e.attributes.name) === "csrf-token" || q(e.attributes.name) === "p:domain_verify" || q(e.attributes.name) === "verify-v1" || q(e.attributes.name) === "verification" || q(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Ve(e, t) {
  const { doc: r, mirror: i, blockClass: n, blockSelector: s, maskTextClass: o, maskTextSelector: c, skipChild: a = !1, inlineStylesheet: f = !0, maskInputOptions: l = {}, maskTextFn: d, maskInputFn: p, slimDOMOptions: h, dataURLOptions: m = {}, inlineImages: _ = !1, recordCanvas: y = !1, onSerialize: v, onIframeLoad: S, iframeLoadTimeout: b = 5e3, onStylesheetLoad: w, stylesheetLoadTimeout: x = 5e3, keepIframeSrcFn: C = () => !1, newlyAddedElement: $ = !1 } = t;
  let { needsMask: D } = t, { preserveWhiteSpace: N = !0 } = t;
  !D && e.childNodes && (D = Ai(e, o, c, D === void 0));
  const X = Rs(e, {
    doc: r,
    mirror: i,
    blockClass: n,
    blockSelector: s,
    needsMask: D,
    inlineStylesheet: f,
    maskInputOptions: l,
    maskTextFn: d,
    maskInputFn: p,
    dataURLOptions: m,
    inlineImages: _,
    recordCanvas: y,
    keepIframeSrcFn: C,
    newlyAddedElement: $
  });
  if (!X)
    return console.warn(e, "not serialized"), null;
  let F;
  i.hasNode(e) ? F = i.getId(e) : $s(X, h) || !N && X.type === V.Text && !X.isStyle && !X.textContent.replace(/^\s+|\s+$/gm, "").length ? F = ot : F = Di();
  const I = Object.assign(X, { id: F });
  if (i.add(e, I), F === ot)
    return null;
  v && v(e);
  let ce = !a;
  if (I.type === V.Element) {
    ce = ce && !I.needBlock, delete I.needBlock;
    const G = e.shadowRoot;
    G && rt(G) && (I.isShadowHost = !0);
  }
  if ((I.type === V.Document || I.type === V.Element) && ce) {
    h.headWhitespace && I.type === V.Element && I.tagName === "head" && (N = !1);
    const G = {
      doc: r,
      mirror: i,
      blockClass: n,
      blockSelector: s,
      needsMask: D,
      maskTextClass: o,
      maskTextSelector: c,
      skipChild: a,
      inlineStylesheet: f,
      maskInputOptions: l,
      maskTextFn: d,
      maskInputFn: p,
      slimDOMOptions: h,
      dataURLOptions: m,
      inlineImages: _,
      recordCanvas: y,
      preserveWhiteSpace: N,
      onSerialize: v,
      onIframeLoad: S,
      iframeLoadTimeout: b,
      onStylesheetLoad: w,
      stylesheetLoadTimeout: x,
      keepIframeSrcFn: C
    };
    if (!(I.type === V.Element && I.tagName === "textarea" && I.attributes.value !== void 0)) for (const we of Array.from(e.childNodes)) {
      const le = Ve(we, G);
      le && I.childNodes.push(le);
    }
    if (ls(e) && e.shadowRoot)
      for (const we of Array.from(e.shadowRoot.childNodes)) {
        const le = Ve(we, G);
        le && (rt(e.shadowRoot) && (le.isShadow = !0), I.childNodes.push(le));
      }
  }
  return e.parentNode && tt(e.parentNode) && rt(e.parentNode) && (I.isShadow = !0), I.type === V.Element && I.tagName === "iframe" && Ds(e, () => {
    const G = e.contentDocument;
    if (G && S) {
      const we = Ve(G, {
        doc: G,
        mirror: i,
        blockClass: n,
        blockSelector: s,
        needsMask: D,
        maskTextClass: o,
        maskTextSelector: c,
        skipChild: !1,
        inlineStylesheet: f,
        maskInputOptions: l,
        maskTextFn: d,
        maskInputFn: p,
        slimDOMOptions: h,
        dataURLOptions: m,
        inlineImages: _,
        recordCanvas: y,
        preserveWhiteSpace: N,
        onSerialize: v,
        onIframeLoad: S,
        iframeLoadTimeout: b,
        onStylesheetLoad: w,
        stylesheetLoadTimeout: x,
        keepIframeSrcFn: C
      });
      we && S(e, we);
    }
  }, b), I.type === V.Element && I.tagName === "link" && typeof I.attributes.rel == "string" && (I.attributes.rel === "stylesheet" || I.attributes.rel === "preload" && typeof I.attributes.href == "string" && Ti(I.attributes.href) === "css") && Ns(e, () => {
    if (w) {
      const G = Ve(e, {
        doc: r,
        mirror: i,
        blockClass: n,
        blockSelector: s,
        needsMask: D,
        maskTextClass: o,
        maskTextSelector: c,
        skipChild: !1,
        inlineStylesheet: f,
        maskInputOptions: l,
        maskTextFn: d,
        maskInputFn: p,
        slimDOMOptions: h,
        dataURLOptions: m,
        inlineImages: _,
        recordCanvas: y,
        preserveWhiteSpace: N,
        onSerialize: v,
        onIframeLoad: S,
        iframeLoadTimeout: b,
        onStylesheetLoad: w,
        stylesheetLoadTimeout: x,
        keepIframeSrcFn: C
      });
      G && w(e, G);
    }
  }, x), I;
}
function Ps(e, t) {
  const { mirror: r = new Ci(), blockClass: i = "rr-block", blockSelector: n = null, maskTextClass: s = "rr-mask", maskTextSelector: o = null, inlineStylesheet: c = !0, inlineImages: a = !1, recordCanvas: f = !1, maskAllInputs: l = !1, maskTextFn: d, maskInputFn: p, slimDOM: h = !1, dataURLOptions: m, preserveWhiteSpace: _, onSerialize: y, onIframeLoad: v, iframeLoadTimeout: S, onStylesheetLoad: b, stylesheetLoadTimeout: w, keepIframeSrcFn: x = () => !1 } = t || {};
  return Ve(e, {
    doc: e,
    mirror: r,
    blockClass: i,
    blockSelector: n,
    maskTextClass: s,
    maskTextSelector: o,
    skipChild: !1,
    inlineStylesheet: c,
    maskInputOptions: l === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : l === !1 ? {
      password: !0
    } : l,
    maskTextFn: d,
    maskInputFn: p,
    slimDOMOptions: h === !0 || h === "all" ? {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: h === "all",
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    } : h === !1 ? {} : h,
    dataURLOptions: m,
    inlineImages: a,
    recordCanvas: f,
    preserveWhiteSpace: _,
    onSerialize: y,
    onIframeLoad: v,
    iframeLoadTimeout: S,
    onStylesheetLoad: b,
    stylesheetLoadTimeout: w,
    keepIframeSrcFn: x,
    newlyAddedElement: !1
  });
}
function J(e, t, r = document) {
  const i = { capture: !0, passive: !0 };
  return r.addEventListener(e, t, i), () => r.removeEventListener(e, t, i);
}
const ze = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Yr = {
  map: {},
  getId() {
    return console.error(ze), -1;
  },
  getNode() {
    return console.error(ze), null;
  },
  removeNodeFromMap() {
    console.error(ze);
  },
  has() {
    return console.error(ze), !1;
  },
  reset() {
    console.error(ze);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (Yr = new Proxy(Yr, {
  get(e, t, r) {
    return t === "map" && console.error(ze), Reflect.get(e, t, r);
  }
}));
function at(e, t, r = {}) {
  let i = null, n = 0;
  return function(...s) {
    const o = Date.now();
    !n && r.leading === !1 && (n = o);
    const c = t - (o - n), a = this;
    c <= 0 || c > t ? (i && (clearTimeout(i), i = null), n = o, e.apply(a, s)) : !i && r.trailing !== !1 && (i = setTimeout(() => {
      n = r.leading === !1 ? 0 : Date.now(), i = null, e.apply(a, s);
    }, c));
  };
}
function jt(e, t, r, i, n = window) {
  const s = n.Object.getOwnPropertyDescriptor(e, t);
  return n.Object.defineProperty(e, t, i ? r : {
    set(o) {
      setTimeout(() => {
        r.set.call(this, o);
      }, 0), s && s.set && s.set.call(this, o);
    }
  }), () => jt(e, t, s || {}, !0);
}
function Qe(e, t, r) {
  try {
    if (!(t in e))
      return () => {
      };
    const i = e[t], n = r(i);
    return typeof n == "function" && (n.prototype = n.prototype || {}, Object.defineProperties(n, {
      __rrweb_original__: {
        enumerable: !1,
        value: i
      }
    })), e[t] = n, () => {
      e[t] = i;
    };
  } catch {
    return () => {
    };
  }
}
let Nt = Date.now;
/[1-9][0-9]{12}/.test(Date.now().toString()) || (Nt = () => (/* @__PURE__ */ new Date()).getTime());
function Fi(e) {
  var t, r, i, n, s, o;
  const c = e.document;
  return {
    left: c.scrollingElement ? c.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : (c == null ? void 0 : c.documentElement.scrollLeft) || ((r = (t = c == null ? void 0 : c.body) === null || t === void 0 ? void 0 : t.parentElement) === null || r === void 0 ? void 0 : r.scrollLeft) || ((i = c == null ? void 0 : c.body) === null || i === void 0 ? void 0 : i.scrollLeft) || 0,
    top: c.scrollingElement ? c.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : (c == null ? void 0 : c.documentElement.scrollTop) || ((s = (n = c == null ? void 0 : c.body) === null || n === void 0 ? void 0 : n.parentElement) === null || s === void 0 ? void 0 : s.scrollTop) || ((o = c == null ? void 0 : c.body) === null || o === void 0 ? void 0 : o.scrollTop) || 0
  };
}
function Li() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $i() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function Pi(e) {
  return e ? e.nodeType === e.ELEMENT_NODE ? e : e.parentElement : null;
}
function Z(e, t, r, i) {
  if (!e)
    return !1;
  const n = Pi(e);
  if (!n)
    return !1;
  try {
    if (typeof t == "string") {
      if (n.classList.contains(t) || i && n.closest("." + t) !== null)
        return !0;
    } else if (Dt(n, t, i))
      return !0;
  } catch {
  }
  return !!(r && (n.matches(r) || i && n.closest(r) !== null));
}
function qs(e, t) {
  return t.getId(e) !== -1;
}
function er(e, t) {
  return t.getId(e) === ot;
}
function qi(e, t) {
  if (tt(e))
    return !1;
  const r = t.getId(e);
  return t.has(r) ? e.parentNode && e.parentNode.nodeType === e.DOCUMENT_NODE ? !1 : e.parentNode ? qi(e.parentNode, t) : !0 : !0;
}
function lr(e) {
  return !!e.changedTouches;
}
function Us(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let r = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === r)
        return !0;
    while (r = r && r.parentNode);
    return !1;
  });
}
function Ui(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function ji(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function fr(e) {
  return !!(e != null && e.shadowRoot);
}
class js {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(t) {
    var r;
    return (r = this.styleIDMap.get(t)) !== null && r !== void 0 ? r : -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  add(t, r) {
    if (this.has(t))
      return this.getId(t);
    let i;
    return r === void 0 ? i = this.id++ : i = r, this.styleIDMap.set(t, i), this.idStyleMap.set(i, t), i;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function Bi(e) {
  var t, r;
  let i = null;
  return ((r = (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e)) === null || r === void 0 ? void 0 : r.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && e.getRootNode().host && (i = e.getRootNode().host), i;
}
function Bs(e) {
  let t = e, r;
  for (; r = Bi(t); )
    t = r;
  return t;
}
function zs(e) {
  const t = e.ownerDocument;
  if (!t)
    return !1;
  const r = Bs(e);
  return t.contains(r);
}
function zi(e) {
  const t = e.ownerDocument;
  return t ? t.contains(e) || zs(e) : !1;
}
var A = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(A || {}), T = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(T || {}), ee = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(ee || {}), ge = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(ge || {}), Ke = /* @__PURE__ */ ((e) => (e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e))(Ke || {});
function Xr(e) {
  return "__ln" in e;
}
class Ws {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let r = this.head;
    for (let i = 0; i < t; i++)
      r = (r == null ? void 0 : r.next) || null;
    return r;
  }
  addNode(t) {
    const r = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = r, t.previousSibling && Xr(t.previousSibling)) {
      const i = t.previousSibling.__ln.next;
      r.next = i, r.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = r, i && (i.previous = r);
    } else if (t.nextSibling && Xr(t.nextSibling) && t.nextSibling.__ln.previous) {
      const i = t.nextSibling.__ln.previous;
      r.previous = i, r.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = r, i && (i.next = r);
    } else
      this.head && (this.head.previous = r), r.next = this.head, this.head = r;
    r.next === null && (this.tail = r), this.length++;
  }
  removeNode(t) {
    const r = t.__ln;
    this.head && (r.previous ? (r.previous.next = r.next, r.next ? r.next.previous = r.previous : this.tail = r.previous) : (this.head = r.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const Kr = (e, t) => `${e}@${t}`;
class Hs {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (t) => {
      t.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const t = [], r = /* @__PURE__ */ new Set(), i = new Ws(), n = (a) => {
        let f = a, l = ot;
        for (; l === ot; )
          f = f && f.nextSibling, l = f && this.mirror.getId(f);
        return l;
      }, s = (a) => {
        if (!a.parentNode || !zi(a) || a.parentNode.tagName === "TEXTAREA")
          return;
        const f = tt(a.parentNode) ? this.mirror.getId(Bi(a)) : this.mirror.getId(a.parentNode), l = n(a);
        if (f === -1 || l === -1)
          return i.addNode(a);
        const d = Ve(a, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (p) => {
            Ui(p, this.mirror) && this.iframeManager.addIframe(p), ji(p, this.mirror) && this.stylesheetManager.trackLinkElement(p), fr(a) && this.shadowDomManager.addShadowRoot(a.shadowRoot, this.doc);
          },
          onIframeLoad: (p, h) => {
            this.iframeManager.attachIframe(p, h), this.shadowDomManager.observeAttachShadow(p);
          },
          onStylesheetLoad: (p, h) => {
            this.stylesheetManager.attachLinkElement(p, h);
          }
        });
        d && (t.push({
          parentId: f,
          nextId: l,
          node: d
        }), r.add(d.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const a of this.movedSet)
        Jr(this.removes, a, this.mirror) && !this.movedSet.has(a.parentNode) || s(a);
      for (const a of this.addedSet)
        !Zr(this.droppedSet, a) && !Jr(this.removes, a, this.mirror) || Zr(this.movedSet, a) ? s(a) : this.droppedSet.add(a);
      let o = null;
      for (; i.length; ) {
        let a = null;
        if (o) {
          const f = this.mirror.getId(o.value.parentNode), l = n(o.value);
          f !== -1 && l !== -1 && (a = o);
        }
        if (!a) {
          let f = i.tail;
          for (; f; ) {
            const l = f;
            if (f = f.previous, l) {
              const d = this.mirror.getId(l.value.parentNode);
              if (n(l.value) === -1)
                continue;
              if (d !== -1) {
                a = l;
                break;
              } else {
                const h = l.value;
                if (h.parentNode && h.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const m = h.parentNode.host;
                  if (this.mirror.getId(m) !== -1) {
                    a = l;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!a) {
          for (; i.head; )
            i.removeNode(i.head.value);
          break;
        }
        o = a.previous, i.removeNode(a.value), s(a.value);
      }
      const c = {
        texts: this.texts.map((a) => {
          const f = a.node;
          return f.parentNode && f.parentNode.tagName === "TEXTAREA" && this.genTextAreaValueMutation(f.parentNode), {
            id: this.mirror.getId(f),
            value: a.value
          };
        }).filter((a) => !r.has(a.id)).filter((a) => this.mirror.has(a.id)),
        attributes: this.attributes.map((a) => {
          const { attributes: f } = a;
          if (typeof f.style == "string") {
            const l = JSON.stringify(a.styleDiff), d = JSON.stringify(a._unchangedStyles);
            l.length < f.style.length && (l + d).split("var(").length === f.style.split("var(").length && (f.style = a.styleDiff);
          }
          return {
            id: this.mirror.getId(a.node),
            attributes: f
          };
        }).filter((a) => !r.has(a.id)).filter((a) => this.mirror.has(a.id)),
        removes: this.removes,
        adds: t
      };
      !c.texts.length && !c.attributes.length && !c.removes.length && !c.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(c));
    }, this.genTextAreaValueMutation = (t) => {
      let r = this.attributeMap.get(t);
      r || (r = {
        node: t,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(r), this.attributeMap.set(t, r)), r.attributes.value = Array.from(t.childNodes, (i) => i.textContent || "").join("");
    }, this.processMutation = (t) => {
      if (!er(t.target, this.mirror))
        switch (t.type) {
          case "characterData": {
            const r = t.target.textContent;
            !Z(t.target, this.blockClass, this.blockSelector, !1) && r !== t.oldValue && this.texts.push({
              value: Ai(t.target, this.maskTextClass, this.maskTextSelector, !0) && r ? this.maskTextFn ? this.maskTextFn(r, Pi(t.target)) : r.replace(/[\S]/g, "*") : r,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const r = t.target;
            let i = t.attributeName, n = t.target.getAttribute(i);
            if (i === "value") {
              const o = yr(r);
              n = gr({
                element: r,
                maskInputOptions: this.maskInputOptions,
                tagName: r.tagName,
                type: o,
                value: n,
                maskInputFn: this.maskInputFn
              });
            }
            if (Z(t.target, this.blockClass, this.blockSelector, !1) || n === t.oldValue)
              return;
            let s = this.attributeMap.get(t.target);
            if (r.tagName === "IFRAME" && i === "src" && !this.keepIframeSrcFn(n))
              if (!r.contentDocument)
                i = "rr_src";
              else
                return;
            if (s || (s = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(s), this.attributeMap.set(t.target, s)), i === "type" && r.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && r.setAttribute("data-rr-is-password", "true"), !Ri(r.tagName, i) && (s.attributes[i] = Ni(this.doc, $e(r.tagName), $e(i), n), i === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const o = this.unattachedDoc.createElement("span");
              t.oldValue && o.setAttribute("style", t.oldValue);
              for (const c of Array.from(r.style)) {
                const a = r.style.getPropertyValue(c), f = r.style.getPropertyPriority(c);
                a !== o.style.getPropertyValue(c) || f !== o.style.getPropertyPriority(c) ? f === "" ? s.styleDiff[c] = a : s.styleDiff[c] = [a, f] : s._unchangedStyles[c] = [a, f];
              }
              for (const c of Array.from(o.style))
                r.style.getPropertyValue(c) === "" && (s.styleDiff[c] = !1);
            }
            break;
          }
          case "childList": {
            if (Z(t.target, this.blockClass, this.blockSelector, !0))
              return;
            if (t.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(t.target);
              return;
            }
            t.addedNodes.forEach((r) => this.genAdds(r, t.target)), t.removedNodes.forEach((r) => {
              const i = this.mirror.getId(r), n = tt(t.target) ? this.mirror.getId(t.target.host) : this.mirror.getId(t.target);
              Z(t.target, this.blockClass, this.blockSelector, !1) || er(r, this.mirror) || !qs(r, this.mirror) || (this.addedSet.has(r) ? (dr(this.addedSet, r), this.droppedSet.add(r)) : this.addedSet.has(t.target) && i === -1 || qi(t.target, this.mirror) || (this.movedSet.has(r) && this.movedMap[Kr(i, n)] ? dr(this.movedSet, r) : this.removes.push({
                parentId: n,
                id: i,
                isShadow: tt(t.target) && rt(t.target) ? !0 : void 0
              })), this.mapRemoves.push(r));
            });
            break;
          }
        }
    }, this.genAdds = (t, r) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (er(t, this.mirror))
            return;
          this.movedSet.add(t);
          let i = null;
          r && this.mirror.hasNode(r) && (i = this.mirror.getId(r)), i && i !== -1 && (this.movedMap[Kr(this.mirror.getId(t), i)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        Z(t, this.blockClass, this.blockSelector, !1) || (t.childNodes.forEach((i) => this.genAdds(i)), fr(t) && t.shadowRoot.childNodes.forEach((i) => {
          this.processedNodeManager.add(i, this), this.genAdds(i, t);
        }));
      }
    };
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((r) => {
      this[r] = t[r];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function dr(e, t) {
  e.delete(t), t.childNodes.forEach((r) => dr(e, r));
}
function Jr(e, t, r) {
  return e.length === 0 ? !1 : Wi(e, t, r);
}
function Wi(e, t, r) {
  const { parentNode: i } = t;
  if (!i)
    return !1;
  const n = r.getId(i);
  return e.some((s) => s.id === n) ? !0 : Wi(e, i, r);
}
function Zr(e, t) {
  return e.size === 0 ? !1 : Hi(e, t);
}
function Hi(e, t) {
  const { parentNode: r } = t;
  return r ? e.has(r) ? !0 : Hi(e, r) : !1;
}
let it;
function Vs(e) {
  it = e;
}
function Gs() {
  it = void 0;
}
const R = (e) => it ? (...r) => {
  try {
    return e(...r);
  } catch (i) {
    if (it && it(i) === !0)
      return;
    throw i;
  }
} : e, Ae = [];
function lt(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch {
  }
  return e && e.target;
}
function Vi(e, t) {
  var r, i;
  const n = new Hs();
  Ae.push(n), n.init(e);
  let s = window.MutationObserver || window.__rrMutationObserver;
  const o = (i = (r = window == null ? void 0 : window.Zone) === null || r === void 0 ? void 0 : r.__symbol__) === null || i === void 0 ? void 0 : i.call(r, "MutationObserver");
  o && window[o] && (s = window[o]);
  const c = new s(R(n.processMutations.bind(n)));
  return c.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), c;
}
function Ys({ mousemoveCb: e, sampling: t, doc: r, mirror: i }) {
  if (t.mousemove === !1)
    return () => {
    };
  const n = typeof t.mousemove == "number" ? t.mousemove : 50, s = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let o = [], c;
  const a = at(R((d) => {
    const p = Date.now() - c;
    e(o.map((h) => (h.timeOffset -= p, h)), d), o = [], c = null;
  }), s), f = R(at(R((d) => {
    const p = lt(d), { clientX: h, clientY: m } = lr(d) ? d.changedTouches[0] : d;
    c || (c = Nt()), o.push({
      x: h,
      y: m,
      id: i.getId(p),
      timeOffset: Nt() - c
    }), a(typeof DragEvent < "u" && d instanceof DragEvent ? T.Drag : d instanceof MouseEvent ? T.MouseMove : T.TouchMove);
  }), n, {
    trailing: !1
  })), l = [
    J("mousemove", f, r),
    J("touchmove", f, r),
    J("drag", f, r)
  ];
  return R(() => {
    l.forEach((d) => d());
  });
}
function Xs({ mouseInteractionCb: e, doc: t, mirror: r, blockClass: i, blockSelector: n, sampling: s }) {
  if (s.mouseInteraction === !1)
    return () => {
    };
  const o = s.mouseInteraction === !0 || s.mouseInteraction === void 0 ? {} : s.mouseInteraction, c = [];
  let a = null;
  const f = (l) => (d) => {
    const p = lt(d);
    if (Z(p, i, n, !0))
      return;
    let h = null, m = l;
    if ("pointerType" in d) {
      switch (d.pointerType) {
        case "mouse":
          h = ge.Mouse;
          break;
        case "touch":
          h = ge.Touch;
          break;
        case "pen":
          h = ge.Pen;
          break;
      }
      h === ge.Touch ? ee[l] === ee.MouseDown ? m = "TouchStart" : ee[l] === ee.MouseUp && (m = "TouchEnd") : ge.Pen;
    } else lr(d) && (h = ge.Touch);
    h !== null ? (a = h, (m.startsWith("Touch") && h === ge.Touch || m.startsWith("Mouse") && h === ge.Mouse) && (h = null)) : ee[l] === ee.Click && (h = a, a = null);
    const _ = lr(d) ? d.changedTouches[0] : d;
    if (!_)
      return;
    const y = r.getId(p), { clientX: v, clientY: S } = _;
    R(e)(Object.assign({ type: ee[m], id: y, x: v, y: S }, h !== null && { pointerType: h }));
  };
  return Object.keys(ee).filter((l) => Number.isNaN(Number(l)) && !l.endsWith("_Departed") && o[l] !== !1).forEach((l) => {
    let d = $e(l);
    const p = f(l);
    if (window.PointerEvent)
      switch (ee[l]) {
        case ee.MouseDown:
        case ee.MouseUp:
          d = d.replace("mouse", "pointer");
          break;
        case ee.TouchStart:
        case ee.TouchEnd:
          return;
      }
    c.push(J(d, p, t));
  }), R(() => {
    c.forEach((l) => l());
  });
}
function Gi({ scrollCb: e, doc: t, mirror: r, blockClass: i, blockSelector: n, sampling: s }) {
  const o = R(at(R((c) => {
    const a = lt(c);
    if (!a || Z(a, i, n, !0))
      return;
    const f = r.getId(a);
    if (a === t && t.defaultView) {
      const l = Fi(t.defaultView);
      e({
        id: f,
        x: l.left,
        y: l.top
      });
    } else
      e({
        id: f,
        x: a.scrollLeft,
        y: a.scrollTop
      });
  }), s.scroll || 100));
  return J("scroll", o, t);
}
function Ks({ viewportResizeCb: e }, { win: t }) {
  let r = -1, i = -1;
  const n = R(at(R(() => {
    const s = Li(), o = $i();
    (r !== s || i !== o) && (e({
      width: Number(o),
      height: Number(s)
    }), r = s, i = o);
  }), 200));
  return J("resize", n, t);
}
const Js = ["INPUT", "TEXTAREA", "SELECT"], Qr = /* @__PURE__ */ new WeakMap();
function Zs({ inputCb: e, doc: t, mirror: r, blockClass: i, blockSelector: n, ignoreClass: s, ignoreSelector: o, maskInputOptions: c, maskInputFn: a, sampling: f, userTriggeredOnInput: l }) {
  function d(S) {
    let b = lt(S);
    const w = S.isTrusted, x = b && b.tagName;
    if (b && x === "OPTION" && (b = b.parentElement), !b || !x || Js.indexOf(x) < 0 || Z(b, i, n, !0) || b.classList.contains(s) || o && b.matches(o))
      return;
    let C = b.value, $ = !1;
    const D = yr(b) || "";
    D === "radio" || D === "checkbox" ? $ = b.checked : (c[x.toLowerCase()] || c[D]) && (C = gr({
      element: b,
      maskInputOptions: c,
      tagName: x,
      type: D,
      value: C,
      maskInputFn: a
    })), p(b, l ? { text: C, isChecked: $, userTriggered: w } : { text: C, isChecked: $ });
    const N = b.name;
    D === "radio" && N && $ && t.querySelectorAll(`input[type="radio"][name="${N}"]`).forEach((X) => {
      if (X !== b) {
        const F = X.value;
        p(X, l ? { text: F, isChecked: !$, userTriggered: !1 } : { text: F, isChecked: !$ });
      }
    });
  }
  function p(S, b) {
    const w = Qr.get(S);
    if (!w || w.text !== b.text || w.isChecked !== b.isChecked) {
      Qr.set(S, b);
      const x = r.getId(S);
      R(e)(Object.assign(Object.assign({}, b), { id: x }));
    }
  }
  const m = (f.input === "last" ? ["change"] : ["input", "change"]).map((S) => J(S, R(d), t)), _ = t.defaultView;
  if (!_)
    return () => {
      m.forEach((S) => S());
    };
  const y = _.Object.getOwnPropertyDescriptor(_.HTMLInputElement.prototype, "value"), v = [
    [_.HTMLInputElement.prototype, "value"],
    [_.HTMLInputElement.prototype, "checked"],
    [_.HTMLSelectElement.prototype, "value"],
    [_.HTMLTextAreaElement.prototype, "value"],
    [_.HTMLSelectElement.prototype, "selectedIndex"],
    [_.HTMLOptionElement.prototype, "selected"]
  ];
  return y && y.set && m.push(...v.map((S) => jt(S[0], S[1], {
    set() {
      R(d)({
        target: this,
        isTrusted: !1
      });
    }
  }, !1, _))), R(() => {
    m.forEach((S) => S());
  });
}
function Rt(e) {
  const t = [];
  function r(i, n) {
    if (yt("CSSGroupingRule") && i.parentRule instanceof CSSGroupingRule || yt("CSSMediaRule") && i.parentRule instanceof CSSMediaRule || yt("CSSSupportsRule") && i.parentRule instanceof CSSSupportsRule || yt("CSSConditionRule") && i.parentRule instanceof CSSConditionRule) {
      const o = Array.from(i.parentRule.cssRules).indexOf(i);
      n.unshift(o);
    } else if (i.parentStyleSheet) {
      const o = Array.from(i.parentStyleSheet.cssRules).indexOf(i);
      n.unshift(o);
    }
    return n;
  }
  return r(e, t);
}
function xe(e, t, r) {
  let i, n;
  return e ? (e.ownerNode ? i = t.getId(e.ownerNode) : n = r.getId(e), {
    styleId: n,
    id: i
  }) : {};
}
function Qs({ styleSheetRuleCb: e, mirror: t, stylesheetManager: r }, { win: i }) {
  if (!i.CSSStyleSheet || !i.CSSStyleSheet.prototype)
    return () => {
    };
  const n = i.CSSStyleSheet.prototype.insertRule;
  i.CSSStyleSheet.prototype.insertRule = new Proxy(n, {
    apply: R((l, d, p) => {
      const [h, m] = p, { id: _, styleId: y } = xe(d, t, r.styleMirror);
      return (_ && _ !== -1 || y && y !== -1) && e({
        id: _,
        styleId: y,
        adds: [{ rule: h, index: m }]
      }), l.apply(d, p);
    })
  });
  const s = i.CSSStyleSheet.prototype.deleteRule;
  i.CSSStyleSheet.prototype.deleteRule = new Proxy(s, {
    apply: R((l, d, p) => {
      const [h] = p, { id: m, styleId: _ } = xe(d, t, r.styleMirror);
      return (m && m !== -1 || _ && _ !== -1) && e({
        id: m,
        styleId: _,
        removes: [{ index: h }]
      }), l.apply(d, p);
    })
  });
  let o;
  i.CSSStyleSheet.prototype.replace && (o = i.CSSStyleSheet.prototype.replace, i.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: R((l, d, p) => {
      const [h] = p, { id: m, styleId: _ } = xe(d, t, r.styleMirror);
      return (m && m !== -1 || _ && _ !== -1) && e({
        id: m,
        styleId: _,
        replace: h
      }), l.apply(d, p);
    })
  }));
  let c;
  i.CSSStyleSheet.prototype.replaceSync && (c = i.CSSStyleSheet.prototype.replaceSync, i.CSSStyleSheet.prototype.replaceSync = new Proxy(c, {
    apply: R((l, d, p) => {
      const [h] = p, { id: m, styleId: _ } = xe(d, t, r.styleMirror);
      return (m && m !== -1 || _ && _ !== -1) && e({
        id: m,
        styleId: _,
        replaceSync: h
      }), l.apply(d, p);
    })
  }));
  const a = {};
  vt("CSSGroupingRule") ? a.CSSGroupingRule = i.CSSGroupingRule : (vt("CSSMediaRule") && (a.CSSMediaRule = i.CSSMediaRule), vt("CSSConditionRule") && (a.CSSConditionRule = i.CSSConditionRule), vt("CSSSupportsRule") && (a.CSSSupportsRule = i.CSSSupportsRule));
  const f = {};
  return Object.entries(a).forEach(([l, d]) => {
    f[l] = {
      insertRule: d.prototype.insertRule,
      deleteRule: d.prototype.deleteRule
    }, d.prototype.insertRule = new Proxy(f[l].insertRule, {
      apply: R((p, h, m) => {
        const [_, y] = m, { id: v, styleId: S } = xe(h.parentStyleSheet, t, r.styleMirror);
        return (v && v !== -1 || S && S !== -1) && e({
          id: v,
          styleId: S,
          adds: [
            {
              rule: _,
              index: [
                ...Rt(h),
                y || 0
              ]
            }
          ]
        }), p.apply(h, m);
      })
    }), d.prototype.deleteRule = new Proxy(f[l].deleteRule, {
      apply: R((p, h, m) => {
        const [_] = m, { id: y, styleId: v } = xe(h.parentStyleSheet, t, r.styleMirror);
        return (y && y !== -1 || v && v !== -1) && e({
          id: y,
          styleId: v,
          removes: [
            { index: [...Rt(h), _] }
          ]
        }), p.apply(h, m);
      })
    });
  }), R(() => {
    i.CSSStyleSheet.prototype.insertRule = n, i.CSSStyleSheet.prototype.deleteRule = s, o && (i.CSSStyleSheet.prototype.replace = o), c && (i.CSSStyleSheet.prototype.replaceSync = c), Object.entries(a).forEach(([l, d]) => {
      d.prototype.insertRule = f[l].insertRule, d.prototype.deleteRule = f[l].deleteRule;
    });
  });
}
function Yi({ mirror: e, stylesheetManager: t }, r) {
  var i, n, s;
  let o = null;
  r.nodeName === "#document" ? o = e.getId(r) : o = e.getId(r.host);
  const c = r.nodeName === "#document" ? (i = r.defaultView) === null || i === void 0 ? void 0 : i.Document : (s = (n = r.ownerDocument) === null || n === void 0 ? void 0 : n.defaultView) === null || s === void 0 ? void 0 : s.ShadowRoot, a = c != null && c.prototype ? Object.getOwnPropertyDescriptor(c == null ? void 0 : c.prototype, "adoptedStyleSheets") : void 0;
  return o === null || o === -1 || !c || !a ? () => {
  } : (Object.defineProperty(r, "adoptedStyleSheets", {
    configurable: a.configurable,
    enumerable: a.enumerable,
    get() {
      var f;
      return (f = a.get) === null || f === void 0 ? void 0 : f.call(this);
    },
    set(f) {
      var l;
      const d = (l = a.set) === null || l === void 0 ? void 0 : l.call(this, f);
      if (o !== null && o !== -1)
        try {
          t.adoptStyleSheets(f, o);
        } catch {
        }
      return d;
    }
  }), R(() => {
    Object.defineProperty(r, "adoptedStyleSheets", {
      configurable: a.configurable,
      enumerable: a.enumerable,
      get: a.get,
      set: a.set
    });
  }));
}
function eo({ styleDeclarationCb: e, mirror: t, ignoreCSSAttributes: r, stylesheetManager: i }, { win: n }) {
  const s = n.CSSStyleDeclaration.prototype.setProperty;
  n.CSSStyleDeclaration.prototype.setProperty = new Proxy(s, {
    apply: R((c, a, f) => {
      var l;
      const [d, p, h] = f;
      if (r.has(d))
        return s.apply(a, [d, p, h]);
      const { id: m, styleId: _ } = xe((l = a.parentRule) === null || l === void 0 ? void 0 : l.parentStyleSheet, t, i.styleMirror);
      return (m && m !== -1 || _ && _ !== -1) && e({
        id: m,
        styleId: _,
        set: {
          property: d,
          value: p,
          priority: h
        },
        index: Rt(a.parentRule)
      }), c.apply(a, f);
    })
  });
  const o = n.CSSStyleDeclaration.prototype.removeProperty;
  return n.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: R((c, a, f) => {
      var l;
      const [d] = f;
      if (r.has(d))
        return o.apply(a, [d]);
      const { id: p, styleId: h } = xe((l = a.parentRule) === null || l === void 0 ? void 0 : l.parentStyleSheet, t, i.styleMirror);
      return (p && p !== -1 || h && h !== -1) && e({
        id: p,
        styleId: h,
        remove: {
          property: d
        },
        index: Rt(a.parentRule)
      }), c.apply(a, f);
    })
  }), R(() => {
    n.CSSStyleDeclaration.prototype.setProperty = s, n.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function to({ mediaInteractionCb: e, blockClass: t, blockSelector: r, mirror: i, sampling: n, doc: s }) {
  const o = R((a) => at(R((f) => {
    const l = lt(f);
    if (!l || Z(l, t, r, !0))
      return;
    const { currentTime: d, volume: p, muted: h, playbackRate: m, loop: _ } = l;
    e({
      type: a,
      id: i.getId(l),
      currentTime: d,
      volume: p,
      muted: h,
      playbackRate: m,
      loop: _
    });
  }), n.media || 500)), c = [
    J("play", o(0), s),
    J("pause", o(1), s),
    J("seeked", o(2), s),
    J("volumechange", o(3), s),
    J("ratechange", o(4), s)
  ];
  return R(() => {
    c.forEach((a) => a());
  });
}
function ro({ fontCb: e, doc: t }) {
  const r = t.defaultView;
  if (!r)
    return () => {
    };
  const i = [], n = /* @__PURE__ */ new WeakMap(), s = r.FontFace;
  r.FontFace = function(a, f, l) {
    const d = new s(a, f, l);
    return n.set(d, {
      family: a,
      buffer: typeof f != "string",
      descriptors: l,
      fontSource: typeof f == "string" ? f : JSON.stringify(Array.from(new Uint8Array(f)))
    }), d;
  };
  const o = Qe(t.fonts, "add", function(c) {
    return function(a) {
      return setTimeout(R(() => {
        const f = n.get(a);
        f && (e(f), n.delete(a));
      }), 0), c.apply(this, [a]);
    };
  });
  return i.push(() => {
    r.FontFace = s;
  }), i.push(o), R(() => {
    i.forEach((c) => c());
  });
}
function io(e) {
  const { doc: t, mirror: r, blockClass: i, blockSelector: n, selectionCb: s } = e;
  let o = !0;
  const c = R(() => {
    const a = t.getSelection();
    if (!a || o && (a != null && a.isCollapsed))
      return;
    o = a.isCollapsed || !1;
    const f = [], l = a.rangeCount || 0;
    for (let d = 0; d < l; d++) {
      const p = a.getRangeAt(d), { startContainer: h, startOffset: m, endContainer: _, endOffset: y } = p;
      Z(h, i, n, !0) || Z(_, i, n, !0) || f.push({
        start: r.getId(h),
        startOffset: m,
        end: r.getId(_),
        endOffset: y
      });
    }
    s({ ranges: f });
  });
  return c(), J("selectionchange", c);
}
function no({ doc: e, customElementCb: t }) {
  const r = e.defaultView;
  return !r || !r.customElements ? () => {
  } : Qe(r.customElements, "define", function(n) {
    return function(s, o, c) {
      try {
        t({
          define: {
            name: s
          }
        });
      } catch {
        console.warn(`Custom element callback failed for ${s}`);
      }
      return n.apply(this, [s, o, c]);
    };
  });
}
function so(e, t) {
  const { mutationCb: r, mousemoveCb: i, mouseInteractionCb: n, scrollCb: s, viewportResizeCb: o, inputCb: c, mediaInteractionCb: a, styleSheetRuleCb: f, styleDeclarationCb: l, canvasMutationCb: d, fontCb: p, selectionCb: h, customElementCb: m } = e;
  e.mutationCb = (..._) => {
    t.mutation && t.mutation(..._), r(..._);
  }, e.mousemoveCb = (..._) => {
    t.mousemove && t.mousemove(..._), i(..._);
  }, e.mouseInteractionCb = (..._) => {
    t.mouseInteraction && t.mouseInteraction(..._), n(..._);
  }, e.scrollCb = (..._) => {
    t.scroll && t.scroll(..._), s(..._);
  }, e.viewportResizeCb = (..._) => {
    t.viewportResize && t.viewportResize(..._), o(..._);
  }, e.inputCb = (..._) => {
    t.input && t.input(..._), c(..._);
  }, e.mediaInteractionCb = (..._) => {
    t.mediaInteaction && t.mediaInteaction(..._), a(..._);
  }, e.styleSheetRuleCb = (..._) => {
    t.styleSheetRule && t.styleSheetRule(..._), f(..._);
  }, e.styleDeclarationCb = (..._) => {
    t.styleDeclaration && t.styleDeclaration(..._), l(..._);
  }, e.canvasMutationCb = (..._) => {
    t.canvasMutation && t.canvasMutation(..._), d(..._);
  }, e.fontCb = (..._) => {
    t.font && t.font(..._), p(..._);
  }, e.selectionCb = (..._) => {
    t.selection && t.selection(..._), h(..._);
  }, e.customElementCb = (..._) => {
    t.customElement && t.customElement(..._), m(..._);
  };
}
function oo(e, t = {}) {
  const r = e.doc.defaultView;
  if (!r)
    return () => {
    };
  so(e, t);
  let i;
  e.recordDOM && (i = Vi(e, e.doc));
  const n = Ys(e), s = Xs(e), o = Gi(e), c = Ks(e, {
    win: r
  }), a = Zs(e), f = to(e);
  let l = () => {
  }, d = () => {
  }, p = () => {
  }, h = () => {
  };
  e.recordDOM && (l = Qs(e, { win: r }), d = Yi(e, e.doc), p = eo(e, {
    win: r
  }), e.collectFonts && (h = ro(e)));
  const m = io(e), _ = no(e), y = [];
  for (const v of e.plugins)
    y.push(v.observer(v.callback, r, v.options));
  return R(() => {
    Ae.forEach((v) => v.reset()), i == null || i.disconnect(), n(), s(), o(), c(), a(), f(), l(), d(), p(), h(), m(), _(), y.forEach((v) => v());
  });
}
function yt(e) {
  return typeof window[e] < "u";
}
function vt(e) {
  return !!(typeof window[e] < "u" && window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class ei {
  constructor(t) {
    this.generateIdFn = t, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t, r, i, n) {
    const s = i || this.getIdToRemoteIdMap(t), o = n || this.getRemoteIdToIdMap(t);
    let c = s.get(r);
    return c || (c = this.generateIdFn(), s.set(r, c), o.set(c, r)), c;
  }
  getIds(t, r) {
    const i = this.getIdToRemoteIdMap(t), n = this.getRemoteIdToIdMap(t);
    return r.map((s) => this.getId(t, s, i, n));
  }
  getRemoteId(t, r, i) {
    const n = i || this.getRemoteIdToIdMap(t);
    if (typeof r != "number")
      return r;
    const s = n.get(r);
    return s || -1;
  }
  getRemoteIds(t, r) {
    const i = this.getRemoteIdToIdMap(t);
    return r.map((n) => this.getRemoteId(t, n, i));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let r = this.iframeIdToRemoteIdMap.get(t);
    return r || (r = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, r)), r;
  }
  getRemoteIdToIdMap(t) {
    let r = this.iframeRemoteIdToIdMap.get(t);
    return r || (r = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, r)), r;
  }
}
class ao {
  constructor(t) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new ei(Di), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new ei(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, r) {
    var i;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: r
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), (i = this.loadListener) === null || i === void 0 || i.call(this, t), t.contentDocument && t.contentDocument.adoptedStyleSheets && t.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(t.contentDocument.adoptedStyleSheets, this.mirror.getId(t.contentDocument));
  }
  handleMessage(t) {
    const r = t;
    if (r.data.type !== "rrweb" || r.origin !== r.data.origin || !t.source)
      return;
    const n = this.crossOriginIframeMap.get(t.source);
    if (!n)
      return;
    const s = this.transformCrossOriginEvent(n, r.data.event);
    s && this.wrappedEmit(s, r.data.isCheckout);
  }
  transformCrossOriginEvent(t, r) {
    var i;
    switch (r.type) {
      case A.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(r.data.node, t);
        const n = r.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, n), this.patchRootIdOnNode(r.data.node, n), {
          timestamp: r.timestamp,
          type: A.IncrementalSnapshot,
          data: {
            source: T.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: r.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case A.Meta:
      case A.Load:
      case A.DomContentLoaded:
        return !1;
      case A.Plugin:
        return r;
      case A.Custom:
        return this.replaceIds(r.data.payload, t, ["id", "parentId", "previousId", "nextId"]), r;
      case A.IncrementalSnapshot:
        switch (r.data.source) {
          case T.Mutation:
            return r.data.adds.forEach((n) => {
              this.replaceIds(n, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(n.node, t);
              const s = this.crossOriginIframeRootIdMap.get(t);
              s && this.patchRootIdOnNode(n.node, s);
            }), r.data.removes.forEach((n) => {
              this.replaceIds(n, t, ["parentId", "id"]);
            }), r.data.attributes.forEach((n) => {
              this.replaceIds(n, t, ["id"]);
            }), r.data.texts.forEach((n) => {
              this.replaceIds(n, t, ["id"]);
            }), r;
          case T.Drag:
          case T.TouchMove:
          case T.MouseMove:
            return r.data.positions.forEach((n) => {
              this.replaceIds(n, t, ["id"]);
            }), r;
          case T.ViewportResize:
            return !1;
          case T.MediaInteraction:
          case T.MouseInteraction:
          case T.Scroll:
          case T.CanvasMutation:
          case T.Input:
            return this.replaceIds(r.data, t, ["id"]), r;
          case T.StyleSheetRule:
          case T.StyleDeclaration:
            return this.replaceIds(r.data, t, ["id"]), this.replaceStyleIds(r.data, t, ["styleId"]), r;
          case T.Font:
            return r;
          case T.Selection:
            return r.data.ranges.forEach((n) => {
              this.replaceIds(n, t, ["start", "end"]);
            }), r;
          case T.AdoptedStyleSheet:
            return this.replaceIds(r.data, t, ["id"]), this.replaceStyleIds(r.data, t, ["styleIds"]), (i = r.data.styles) === null || i === void 0 || i.forEach((n) => {
              this.replaceStyleIds(n, t, ["styleId"]);
            }), r;
        }
    }
    return !1;
  }
  replace(t, r, i, n) {
    for (const s of n)
      !Array.isArray(r[s]) && typeof r[s] != "number" || (Array.isArray(r[s]) ? r[s] = t.getIds(i, r[s]) : r[s] = t.getId(i, r[s]));
    return r;
  }
  replaceIds(t, r, i) {
    return this.replace(this.crossOriginIframeMirror, t, r, i);
  }
  replaceStyleIds(t, r, i) {
    return this.replace(this.crossOriginIframeStyleMirror, t, r, i);
  }
  replaceIdOnNode(t, r) {
    this.replaceIds(t, r, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((i) => {
      this.replaceIdOnNode(i, r);
    });
  }
  patchRootIdOnNode(t, r) {
    t.type !== V.Document && !t.rootId && (t.rootId = r), "childNodes" in t && t.childNodes.forEach((i) => {
      this.patchRootIdOnNode(i, r);
    });
  }
}
class uo {
  constructor(t) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, r) {
    if (!rt(t) || this.shadowDoms.has(t))
      return;
    this.shadowDoms.add(t);
    const i = Vi(Object.assign(Object.assign({}, this.bypassOptions), { doc: r, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), t);
    this.restoreHandlers.push(() => i.disconnect()), this.restoreHandlers.push(Gi(Object.assign(Object.assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: t, mirror: this.mirror }))), setTimeout(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(t.adoptedStyleSheets, this.mirror.getId(t.host)), this.restoreHandlers.push(Yi({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, t));
    }, 0);
  }
  observeAttachShadow(t) {
    !t.contentWindow || !t.contentDocument || this.patchAttachShadow(t.contentWindow.Element, t.contentDocument);
  }
  patchAttachShadow(t, r) {
    const i = this;
    this.restoreHandlers.push(Qe(t.prototype, "attachShadow", function(n) {
      return function(s) {
        const o = n.call(this, s);
        return this.shadowRoot && zi(this) && i.addShadowRoot(this.shadowRoot, r), o;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function co(e, t) {
  var r = {};
  for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
}
function lo(e, t, r, i) {
  function n(s) {
    return s instanceof r ? s : new r(function(o) {
      o(s);
    });
  }
  return new (r || (r = Promise))(function(s, o) {
    function c(l) {
      try {
        f(i.next(l));
      } catch (d) {
        o(d);
      }
    }
    function a(l) {
      try {
        f(i.throw(l));
      } catch (d) {
        o(d);
      }
    }
    function f(l) {
      l.done ? s(l.value) : n(l.value).then(c, a);
    }
    f((i = i.apply(e, [])).next());
  });
}
var Ge = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", fo = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var bt = 0; bt < Ge.length; bt++)
  fo[Ge.charCodeAt(bt)] = bt;
var po = function(e) {
  var t = new Uint8Array(e), r, i = t.length, n = "";
  for (r = 0; r < i; r += 3)
    n += Ge[t[r] >> 2], n += Ge[(t[r] & 3) << 4 | t[r + 1] >> 4], n += Ge[(t[r + 1] & 15) << 2 | t[r + 2] >> 6], n += Ge[t[r + 2] & 63];
  return i % 3 === 2 ? n = n.substring(0, n.length - 1) + "=" : i % 3 === 1 && (n = n.substring(0, n.length - 2) + "=="), n;
};
const ti = /* @__PURE__ */ new Map();
function ho(e, t) {
  let r = ti.get(e);
  return r || (r = /* @__PURE__ */ new Map(), ti.set(e, r)), r.has(t) || r.set(t, []), r.get(t);
}
const Xi = (e, t, r) => {
  if (!e || !(Ji(e, t) || typeof e == "object"))
    return;
  const i = e.constructor.name, n = ho(r, i);
  let s = n.indexOf(e);
  return s === -1 && (s = n.length, n.push(e)), s;
};
function kt(e, t, r) {
  if (e instanceof Array)
    return e.map((i) => kt(i, t, r));
  if (e === null)
    return e;
  if (e instanceof Float32Array || e instanceof Float64Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Int8Array || e instanceof Uint8ClampedArray)
    return {
      rr_type: e.constructor.name,
      args: [Object.values(e)]
    };
  if (e instanceof ArrayBuffer) {
    const i = e.constructor.name, n = po(e);
    return {
      rr_type: i,
      base64: n
    };
  } else {
    if (e instanceof DataView)
      return {
        rr_type: e.constructor.name,
        args: [
          kt(e.buffer, t, r),
          e.byteOffset,
          e.byteLength
        ]
      };
    if (e instanceof HTMLImageElement) {
      const i = e.constructor.name, { src: n } = e;
      return {
        rr_type: i,
        src: n
      };
    } else if (e instanceof HTMLCanvasElement) {
      const i = "HTMLImageElement", n = e.toDataURL();
      return {
        rr_type: i,
        src: n
      };
    } else {
      if (e instanceof ImageData)
        return {
          rr_type: e.constructor.name,
          args: [kt(e.data, t, r), e.width, e.height]
        };
      if (Ji(e, t) || typeof e == "object") {
        const i = e.constructor.name, n = Xi(e, t, r);
        return {
          rr_type: i,
          index: n
        };
      }
    }
  }
  return e;
}
const Ki = (e, t, r) => e.map((i) => kt(i, t, r)), Ji = (e, t) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  "WebGLVertexArrayObjectOES"
].filter((n) => typeof t[n] == "function").find((n) => e instanceof t[n]);
function _o(e, t, r, i) {
  const n = [], s = Object.getOwnPropertyNames(t.CanvasRenderingContext2D.prototype);
  for (const o of s)
    try {
      if (typeof t.CanvasRenderingContext2D.prototype[o] != "function")
        continue;
      const c = Qe(t.CanvasRenderingContext2D.prototype, o, function(a) {
        return function(...f) {
          return Z(this.canvas, r, i, !0) || setTimeout(() => {
            const l = Ki(f, t, this);
            e(this.canvas, {
              type: Ke["2D"],
              property: o,
              args: l
            });
          }, 0), a.apply(this, f);
        };
      });
      n.push(c);
    } catch {
      const a = jt(t.CanvasRenderingContext2D.prototype, o, {
        set(f) {
          e(this.canvas, {
            type: Ke["2D"],
            property: o,
            args: [f],
            setter: !0
          });
        }
      });
      n.push(a);
    }
  return () => {
    n.forEach((o) => o());
  };
}
function mo(e) {
  return e === "experimental-webgl" ? "webgl" : e;
}
function ri(e, t, r, i) {
  const n = [];
  try {
    const s = Qe(e.HTMLCanvasElement.prototype, "getContext", function(o) {
      return function(c, ...a) {
        if (!Z(this, t, r, !0)) {
          const f = mo(c);
          if ("__context" in this || (this.__context = f), i && ["webgl", "webgl2"].includes(f))
            if (a[0] && typeof a[0] == "object") {
              const l = a[0];
              l.preserveDrawingBuffer || (l.preserveDrawingBuffer = !0);
            } else
              a.splice(0, 1, {
                preserveDrawingBuffer: !0
              });
        }
        return o.apply(this, [c, ...a]);
      };
    });
    n.push(s);
  } catch {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    n.forEach((s) => s());
  };
}
function ii(e, t, r, i, n, s, o) {
  const c = [], a = Object.getOwnPropertyNames(e);
  for (const f of a)
    if (![
      "isContextLost",
      "canvas",
      "drawingBufferWidth",
      "drawingBufferHeight"
    ].includes(f))
      try {
        if (typeof e[f] != "function")
          continue;
        const l = Qe(e, f, function(d) {
          return function(...p) {
            const h = d.apply(this, p);
            if (Xi(h, o, this), "tagName" in this.canvas && !Z(this.canvas, i, n, !0)) {
              const m = Ki(p, o, this), _ = {
                type: t,
                property: f,
                args: m
              };
              r(this.canvas, _);
            }
            return h;
          };
        });
        c.push(l);
      } catch {
        const d = jt(e, f, {
          set(p) {
            r(this.canvas, {
              type: t,
              property: f,
              args: [p],
              setter: !0
            });
          }
        });
        c.push(d);
      }
  return c;
}
function go(e, t, r, i, n) {
  const s = [];
  return s.push(...ii(t.WebGLRenderingContext.prototype, Ke.WebGL, e, r, i, n, t)), typeof t.WebGL2RenderingContext < "u" && s.push(...ii(t.WebGL2RenderingContext.prototype, Ke.WebGL2, e, r, i, n, t)), () => {
    s.forEach((o) => o());
  };
}
function yo(e, t) {
  var r = e.toString(), i = r.split(`
`);
  i.pop(), i.shift();
  for (var n = i[0].search(/\S/), s = /(['"])__worker_loader_strict__(['"])/g, o = 0, c = i.length; o < c; ++o)
    i[o] = i[o].substring(n).replace(s, "$1use strict$2") + `
`;
  return i;
}
function vo(e, t) {
  var r = yo(e), i = new Blob(r, { type: "application/javascript" });
  return URL.createObjectURL(i);
}
function bo(e, t) {
  var r;
  return function(n) {
    return r = r || vo(e), new Worker(r, n);
  };
}
var So = bo(
  /* rollup-plugin-web-worker-loader */
  function() {
    (function() {
      "__worker_loader_strict__";
      /*! *****************************************************************************
          Copyright (c) Microsoft Corporation.
      
          Permission to use, copy, modify, and/or distribute this software for any
          purpose with or without fee is hereby granted.
      
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
          REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
          AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
          INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
          LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
          OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
          PERFORMANCE OF THIS SOFTWARE.
          ***************************************************************************** */
      function e(f, l, d, p) {
        function h(m) {
          return m instanceof d ? m : new d(function(_) {
            _(m);
          });
        }
        return new (d || (d = Promise))(function(m, _) {
          function y(b) {
            try {
              S(p.next(b));
            } catch (w) {
              _(w);
            }
          }
          function v(b) {
            try {
              S(p.throw(b));
            } catch (w) {
              _(w);
            }
          }
          function S(b) {
            b.done ? m(b.value) : h(b.value).then(y, v);
          }
          S((p = p.apply(f, [])).next());
        });
      }
      for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = typeof Uint8Array > "u" ? [] : new Uint8Array(256), i = 0; i < t.length; i++)
        r[t.charCodeAt(i)] = i;
      var n = function(f) {
        var l = new Uint8Array(f), d, p = l.length, h = "";
        for (d = 0; d < p; d += 3)
          h += t[l[d] >> 2], h += t[(l[d] & 3) << 4 | l[d + 1] >> 4], h += t[(l[d + 1] & 15) << 2 | l[d + 2] >> 6], h += t[l[d + 2] & 63];
        return p % 3 === 2 ? h = h.substring(0, h.length - 1) + "=" : p % 3 === 1 && (h = h.substring(0, h.length - 2) + "=="), h;
      };
      const s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
      function c(f, l, d) {
        return e(this, void 0, void 0, function* () {
          const p = `${f}-${l}`;
          if ("OffscreenCanvas" in globalThis) {
            if (o.has(p))
              return o.get(p);
            const h = new OffscreenCanvas(f, l);
            h.getContext("2d");
            const _ = yield (yield h.convertToBlob(d)).arrayBuffer(), y = n(_);
            return o.set(p, y), y;
          } else
            return "";
        });
      }
      const a = self;
      a.onmessage = function(f) {
        return e(this, void 0, void 0, function* () {
          if ("OffscreenCanvas" in globalThis) {
            const { id: l, bitmap: d, width: p, height: h, dataURLOptions: m } = f.data, _ = c(p, h, m), y = new OffscreenCanvas(p, h);
            y.getContext("2d").drawImage(d, 0, 0), d.close();
            const S = yield y.convertToBlob(m), b = S.type, w = yield S.arrayBuffer(), x = n(w);
            if (!s.has(l) && (yield _) === x)
              return s.set(l, x), a.postMessage({ id: l });
            if (s.get(l) === x)
              return a.postMessage({ id: l });
            a.postMessage({
              id: l,
              type: b,
              base64: x,
              width: p,
              height: h
            }), s.set(l, x);
          } else
            return a.postMessage({ id: f.data.id });
        });
      };
    })();
  }
);
class wo {
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  constructor(t) {
    this.pendingCanvasMutations = /* @__PURE__ */ new Map(), this.rafStamps = { latestId: 0, invokeId: null }, this.frozen = !1, this.locked = !1, this.processMutation = (a, f) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(a) || this.pendingCanvasMutations.set(a, []), this.pendingCanvasMutations.get(a).push(f);
    };
    const { sampling: r = "all", win: i, blockClass: n, blockSelector: s, recordCanvas: o, dataURLOptions: c } = t;
    this.mutationCb = t.mutationCb, this.mirror = t.mirror, o && r === "all" && this.initCanvasMutationObserver(i, n, s), o && typeof r == "number" && this.initCanvasFPSObserver(r, i, n, s, {
      dataURLOptions: c
    });
  }
  initCanvasFPSObserver(t, r, i, n, s) {
    const o = ri(r, i, n, !0), c = /* @__PURE__ */ new Map(), a = new So();
    a.onmessage = (m) => {
      const { id: _ } = m.data;
      if (c.set(_, !1), !("base64" in m.data))
        return;
      const { base64: y, type: v, width: S, height: b } = m.data;
      this.mutationCb({
        id: _,
        type: Ke["2D"],
        commands: [
          {
            property: "clearRect",
            args: [0, 0, S, b]
          },
          {
            property: "drawImage",
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: y }],
                    type: v
                  }
                ]
              },
              0,
              0
            ]
          }
        ]
      });
    };
    const f = 1e3 / t;
    let l = 0, d;
    const p = () => {
      const m = [];
      return r.document.querySelectorAll("canvas").forEach((_) => {
        Z(_, i, n, !0) || m.push(_);
      }), m;
    }, h = (m) => {
      if (l && m - l < f) {
        d = requestAnimationFrame(h);
        return;
      }
      l = m, p().forEach((_) => lo(this, void 0, void 0, function* () {
        var y;
        const v = this.mirror.getId(_);
        if (c.get(v) || _.width === 0 || _.height === 0)
          return;
        if (c.set(v, !0), ["webgl", "webgl2"].includes(_.__context)) {
          const b = _.getContext(_.__context);
          ((y = b == null ? void 0 : b.getContextAttributes()) === null || y === void 0 ? void 0 : y.preserveDrawingBuffer) === !1 && b.clear(b.COLOR_BUFFER_BIT);
        }
        const S = yield createImageBitmap(_);
        a.postMessage({
          id: v,
          bitmap: S,
          width: _.width,
          height: _.height,
          dataURLOptions: s.dataURLOptions
        }, [S]);
      })), d = requestAnimationFrame(h);
    };
    d = requestAnimationFrame(h), this.resetObservers = () => {
      o(), cancelAnimationFrame(d);
    };
  }
  initCanvasMutationObserver(t, r, i) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const n = ri(t, r, i, !1), s = _o(this.processMutation.bind(this), t, r, i), o = go(this.processMutation.bind(this), t, r, i, this.mirror);
    this.resetObservers = () => {
      n(), s(), o();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const t = (r) => {
      this.rafStamps.latestId = r, requestAnimationFrame(t);
    };
    requestAnimationFrame(t);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach((t, r) => {
      const i = this.mirror.getId(r);
      this.flushPendingCanvasMutationFor(r, i);
    }), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(t, r) {
    if (this.frozen || this.locked)
      return;
    const i = this.pendingCanvasMutations.get(t);
    if (!i || r === -1)
      return;
    const n = i.map((o) => co(o, ["type"])), { type: s } = i[0];
    this.mutationCb({ id: r, type: s, commands: n }), this.pendingCanvasMutations.delete(t);
  }
}
class xo {
  constructor(t) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new js(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, r) {
    "_cssText" in r.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: r.id,
          attributes: r.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, r) {
    if (t.length === 0)
      return;
    const i = {
      id: r,
      styleIds: []
    }, n = [];
    for (const s of t) {
      let o;
      this.styleMirror.has(s) ? o = this.styleMirror.getId(s) : (o = this.styleMirror.add(s), n.push({
        styleId: o,
        rules: Array.from(s.rules || CSSRule, (c, a) => ({
          rule: Mi(c),
          index: a
        }))
      })), i.styleIds.push(o);
    }
    n.length > 0 && (i.styles = n), this.adoptedStyleSheetCb(i);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  trackStylesheetInLinkElement(t) {
  }
}
class ko {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.loop = !0, this.periodicallyClear();
  }
  periodicallyClear() {
    requestAnimationFrame(() => {
      this.clear(), this.loop && this.periodicallyClear();
    });
  }
  inOtherBuffer(t, r) {
    const i = this.nodeMap.get(t);
    return i && Array.from(i).some((n) => n !== r);
  }
  add(t, r) {
    this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(r));
  }
  clear() {
    this.nodeMap = /* @__PURE__ */ new WeakMap();
  }
  destroy() {
    this.loop = !1;
  }
}
function H(e) {
  return Object.assign(Object.assign({}, e), { timestamp: Nt() });
}
let z, Et, tr, At = !1;
const ne = ms();
function ft(e = {}) {
  const { emit: t, checkoutEveryNms: r, checkoutEveryNth: i, blockClass: n = "rr-block", blockSelector: s = null, ignoreClass: o = "rr-ignore", ignoreSelector: c = null, maskTextClass: a = "rr-mask", maskTextSelector: f = null, inlineStylesheet: l = !0, maskAllInputs: d, maskInputOptions: p, slimDOMOptions: h, maskInputFn: m, maskTextFn: _, hooks: y, packFn: v, sampling: S = {}, dataURLOptions: b = {}, mousemoveWait: w, recordDOM: x = !0, recordCanvas: C = !1, recordCrossOriginIframes: $ = !1, recordAfter: D = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load", userTriggeredOnInput: N = !1, collectFonts: X = !1, inlineImages: F = !1, plugins: I, keepIframeSrcFn: ce = () => !1, ignoreCSSAttributes: G = /* @__PURE__ */ new Set([]), errorHandler: we } = e;
  Vs(we);
  const le = $ ? window.parent === window : !0;
  let pt = !1;
  if (!le)
    try {
      window.parent.document && (pt = !1);
    } catch {
      pt = !0;
    }
  if (le && !t)
    throw new Error("emit function is required");
  w !== void 0 && S.mousemove === void 0 && (S.mousemove = w), ne.reset();
  const Vt = d === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : p !== void 0 ? p : { password: !0 }, Gt = h === !0 || h === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    headMetaAuthorship: h === "all",
    headMetaDescKeywords: h === "all"
  } : h || {};
  Us();
  let Ar, Yt = 0;
  const Fr = (O) => {
    for (const ie of I || [])
      ie.eventProcessor && (O = ie.eventProcessor(O));
    return v && !pt && (O = v(O)), O;
  };
  z = (O, ie) => {
    var B;
    if (!((B = Ae[0]) === null || B === void 0) && B.isFrozen() && O.type !== A.FullSnapshot && !(O.type === A.IncrementalSnapshot && O.data.source === T.Mutation) && Ae.forEach((K) => K.unfreeze()), le)
      t == null || t(Fr(O), ie);
    else if (pt) {
      const K = {
        type: "rrweb",
        event: Fr(O),
        origin: window.location.origin,
        isCheckout: ie
      };
      window.parent.postMessage(K, "*");
    }
    if (O.type === A.FullSnapshot)
      Ar = O, Yt = 0;
    else if (O.type === A.IncrementalSnapshot) {
      if (O.data.source === T.Mutation && O.data.isAttachIframe)
        return;
      Yt++;
      const K = i && Yt >= i, Re = r && O.timestamp - Ar.timestamp > r;
      (K || Re) && Et(!0);
    }
  };
  const ht = (O) => {
    z(H({
      type: A.IncrementalSnapshot,
      data: Object.assign({ source: T.Mutation }, O)
    }));
  }, Lr = (O) => z(H({
    type: A.IncrementalSnapshot,
    data: Object.assign({ source: T.Scroll }, O)
  })), $r = (O) => z(H({
    type: A.IncrementalSnapshot,
    data: Object.assign({ source: T.CanvasMutation }, O)
  })), _n = (O) => z(H({
    type: A.IncrementalSnapshot,
    data: Object.assign({ source: T.AdoptedStyleSheet }, O)
  })), De = new xo({
    mutationCb: ht,
    adoptedStyleSheetCb: _n
  }), Ne = new ao({
    mirror: ne,
    mutationCb: ht,
    stylesheetManager: De,
    recordCrossOriginIframes: $,
    wrappedEmit: z
  });
  for (const O of I || [])
    O.getMirror && O.getMirror({
      nodeMirror: ne,
      crossOriginIframeMirror: Ne.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: Ne.crossOriginIframeStyleMirror
    });
  const Xt = new ko();
  tr = new wo({
    recordCanvas: C,
    mutationCb: $r,
    win: window,
    blockClass: n,
    blockSelector: s,
    mirror: ne,
    sampling: S.canvas,
    dataURLOptions: b
  });
  const _t = new uo({
    mutationCb: ht,
    scrollCb: Lr,
    bypassOptions: {
      blockClass: n,
      blockSelector: s,
      maskTextClass: a,
      maskTextSelector: f,
      inlineStylesheet: l,
      maskInputOptions: Vt,
      dataURLOptions: b,
      maskTextFn: _,
      maskInputFn: m,
      recordCanvas: C,
      inlineImages: F,
      sampling: S,
      slimDOMOptions: Gt,
      iframeManager: Ne,
      stylesheetManager: De,
      canvasManager: tr,
      keepIframeSrcFn: ce,
      processedNodeManager: Xt
    },
    mirror: ne
  });
  Et = (O = !1) => {
    if (!x)
      return;
    z(H({
      type: A.Meta,
      data: {
        href: window.location.href,
        width: $i(),
        height: Li()
      }
    }), O), De.reset(), _t.init(), Ae.forEach((B) => B.lock());
    const ie = Ps(document, {
      mirror: ne,
      blockClass: n,
      blockSelector: s,
      maskTextClass: a,
      maskTextSelector: f,
      inlineStylesheet: l,
      maskAllInputs: Vt,
      maskTextFn: _,
      slimDOM: Gt,
      dataURLOptions: b,
      recordCanvas: C,
      inlineImages: F,
      onSerialize: (B) => {
        Ui(B, ne) && Ne.addIframe(B), ji(B, ne) && De.trackLinkElement(B), fr(B) && _t.addShadowRoot(B.shadowRoot, document);
      },
      onIframeLoad: (B, K) => {
        Ne.attachIframe(B, K), _t.observeAttachShadow(B);
      },
      onStylesheetLoad: (B, K) => {
        De.attachLinkElement(B, K);
      },
      keepIframeSrcFn: ce
    });
    if (!ie)
      return console.warn("Failed to snapshot the document");
    z(H({
      type: A.FullSnapshot,
      data: {
        node: ie,
        initialOffset: Fi(window)
      }
    }), O), Ae.forEach((B) => B.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && De.adoptStyleSheets(document.adoptedStyleSheets, ne.getId(document));
  };
  try {
    const O = [], ie = (K) => {
      var Re;
      return R(oo)({
        mutationCb: ht,
        mousemoveCb: (U, Kt) => z(H({
          type: A.IncrementalSnapshot,
          data: {
            source: Kt,
            positions: U
          }
        })),
        mouseInteractionCb: (U) => z(H({
          type: A.IncrementalSnapshot,
          data: Object.assign({ source: T.MouseInteraction }, U)
        })),
        scrollCb: Lr,
        viewportResizeCb: (U) => z(H({
          type: A.IncrementalSnapshot,
          data: Object.assign({ source: T.ViewportResize }, U)
        })),
        inputCb: (U) => z(H({
          type: A.IncrementalSnapshot,
          data: Object.assign({ source: T.Input }, U)
        })),
        mediaInteractionCb: (U) => z(H({
          type: A.IncrementalSnapshot,
          data: Object.assign({ source: T.MediaInteraction }, U)
        })),
        styleSheetRuleCb: (U) => z(H({
          type: A.IncrementalSnapshot,
          data: Object.assign({ source: T.StyleSheetRule }, U)
        })),
        styleDeclarationCb: (U) => z(H({
          type: A.IncrementalSnapshot,
          data: Object.assign({ source: T.StyleDeclaration }, U)
        })),
        canvasMutationCb: $r,
        fontCb: (U) => z(H({
          type: A.IncrementalSnapshot,
          data: Object.assign({ source: T.Font }, U)
        })),
        selectionCb: (U) => {
          z(H({
            type: A.IncrementalSnapshot,
            data: Object.assign({ source: T.Selection }, U)
          }));
        },
        customElementCb: (U) => {
          z(H({
            type: A.IncrementalSnapshot,
            data: Object.assign({ source: T.CustomElement }, U)
          }));
        },
        blockClass: n,
        ignoreClass: o,
        ignoreSelector: c,
        maskTextClass: a,
        maskTextSelector: f,
        maskInputOptions: Vt,
        inlineStylesheet: l,
        sampling: S,
        recordDOM: x,
        recordCanvas: C,
        inlineImages: F,
        userTriggeredOnInput: N,
        collectFonts: X,
        doc: K,
        maskInputFn: m,
        maskTextFn: _,
        keepIframeSrcFn: ce,
        blockSelector: s,
        slimDOMOptions: Gt,
        dataURLOptions: b,
        mirror: ne,
        iframeManager: Ne,
        stylesheetManager: De,
        shadowDomManager: _t,
        processedNodeManager: Xt,
        canvasManager: tr,
        ignoreCSSAttributes: G,
        plugins: ((Re = I == null ? void 0 : I.filter((U) => U.observer)) === null || Re === void 0 ? void 0 : Re.map((U) => ({
          observer: U.observer,
          options: U.options,
          callback: (Kt) => z(H({
            type: A.Plugin,
            data: {
              plugin: U.name,
              payload: Kt
            }
          }))
        }))) || []
      }, y);
    };
    Ne.addLoadListener((K) => {
      try {
        O.push(ie(K.contentDocument));
      } catch (Re) {
        console.warn(Re);
      }
    });
    const B = () => {
      Et(), O.push(ie(document)), At = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? B() : (O.push(J("DOMContentLoaded", () => {
      z(H({
        type: A.DomContentLoaded,
        data: {}
      })), D === "DOMContentLoaded" && B();
    })), O.push(J("load", () => {
      z(H({
        type: A.Load,
        data: {}
      })), D === "load" && B();
    }, window))), () => {
      O.forEach((K) => K()), Xt.destroy(), At = !1, Gs();
    };
  } catch (O) {
    console.warn(O);
  }
}
ft.addCustomEvent = (e, t) => {
  if (!At)
    throw new Error("please add custom event after start recording");
  z(H({
    type: A.Custom,
    data: {
      tag: e,
      payload: t
    }
  }));
};
ft.freezePage = () => {
  Ae.forEach((e) => e.freeze());
};
ft.takeFullSnapshot = (e) => {
  if (!At)
    throw new Error("please take full snapshot after start recording");
  Et(e);
};
ft.mirror = ne;
var Zi = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(Zi || {}), fe = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(fe || {}), ve = {
  DEBUG: !1,
  LIB_VERSION: "2.55.1"
}, k;
if (typeof window > "u") {
  var ni = {
    hostname: ""
  };
  k = {
    navigator: { userAgent: "", onLine: !0 },
    document: {
      location: ni,
      referrer: ""
    },
    screen: { width: 0, height: 0 },
    location: ni
  };
} else
  k = window;
var nt = 24 * 60 * 60 * 1e3, rr = 8 * 1e3, Bt = Array.prototype, Eo = Function.prototype, Qi = Object.prototype, ke = Bt.slice, dt = Qi.toString, zt = Qi.hasOwnProperty, W = k.console, Ee = k.navigator, P = k.document, St = k.opera, Ft = k.screen, pe = Ee.userAgent, ir = Eo.bind, si = Bt.forEach, oi = Bt.indexOf, ai = Bt.map, Oo = Array.isArray, pr = {}, u = {
  trim: function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  }
}, L = {
  /** @type {function(...*)} */
  log: function() {
    if (ve.DEBUG && !u.isUndefined(W) && W)
      try {
        W.log.apply(W, arguments);
      } catch {
        u.each(arguments, function(t) {
          W.log(t);
        });
      }
  },
  /** @type {function(...*)} */
  warn: function() {
    if (ve.DEBUG && !u.isUndefined(W) && W) {
      var e = ["Mixpanel warning:"].concat(u.toArray(arguments));
      try {
        W.warn.apply(W, e);
      } catch {
        u.each(e, function(r) {
          W.warn(r);
        });
      }
    }
  },
  /** @type {function(...*)} */
  error: function() {
    if (ve.DEBUG && !u.isUndefined(W) && W) {
      var e = ["Mixpanel error:"].concat(u.toArray(arguments));
      try {
        W.error.apply(W, e);
      } catch {
        u.each(e, function(r) {
          W.error(r);
        });
      }
    }
  },
  /** @type {function(...*)} */
  critical: function() {
    if (!u.isUndefined(W) && W) {
      var e = ["Mixpanel error:"].concat(u.toArray(arguments));
      try {
        W.error.apply(W, e);
      } catch {
        u.each(e, function(r) {
          W.error(r);
        });
      }
    }
  }
}, nr = function(e, t) {
  return function() {
    return arguments[0] = "[" + t + "] " + arguments[0], e.apply(L, arguments);
  };
}, Wt = function(e) {
  return {
    log: nr(L.log, e),
    error: nr(L.error, e),
    critical: nr(L.critical, e)
  };
};
u.bind = function(e, t) {
  var r, i;
  if (ir && e.bind === ir)
    return ir.apply(e, ke.call(arguments, 1));
  if (!u.isFunction(e))
    throw new TypeError();
  return r = ke.call(arguments, 2), i = function() {
    if (!(this instanceof i))
      return e.apply(t, r.concat(ke.call(arguments)));
    var n = {};
    n.prototype = e.prototype;
    var s = new n();
    n.prototype = null;
    var o = e.apply(s, r.concat(ke.call(arguments)));
    return Object(o) === o ? o : s;
  }, i;
};
u.each = function(e, t, r) {
  if (e != null) {
    if (si && e.forEach === si)
      e.forEach(t, r);
    else if (e.length === +e.length) {
      for (var i = 0, n = e.length; i < n; i++)
        if (i in e && t.call(r, e[i], i, e) === pr)
          return;
    } else
      for (var s in e)
        if (zt.call(e, s) && t.call(r, e[s], s, e) === pr)
          return;
  }
};
u.extend = function(e) {
  return u.each(ke.call(arguments, 1), function(t) {
    for (var r in t)
      t[r] !== void 0 && (e[r] = t[r]);
  }), e;
};
u.isArray = Oo || function(e) {
  return dt.call(e) === "[object Array]";
};
u.isFunction = function(e) {
  try {
    return /^\s*\bfunction\b/.test(e);
  } catch {
    return !1;
  }
};
u.isArguments = function(e) {
  return !!(e && zt.call(e, "callee"));
};
u.toArray = function(e) {
  return e ? e.toArray ? e.toArray() : u.isArray(e) || u.isArguments(e) ? ke.call(e) : u.values(e) : [];
};
u.map = function(e, t, r) {
  if (ai && e.map === ai)
    return e.map(t, r);
  var i = [];
  return u.each(e, function(n) {
    i.push(t.call(r, n));
  }), i;
};
u.keys = function(e) {
  var t = [];
  return e === null || u.each(e, function(r, i) {
    t[t.length] = i;
  }), t;
};
u.values = function(e) {
  var t = [];
  return e === null || u.each(e, function(r) {
    t[t.length] = r;
  }), t;
};
u.include = function(e, t) {
  var r = !1;
  return e === null ? r : oi && e.indexOf === oi ? e.indexOf(t) != -1 : (u.each(e, function(i) {
    if (r || (r = i === t))
      return pr;
  }), r);
};
u.includes = function(e, t) {
  return e.indexOf(t) !== -1;
};
u.inherit = function(e, t) {
  return e.prototype = new t(), e.prototype.constructor = e, e.superclass = t.prototype, e;
};
u.isObject = function(e) {
  return e === Object(e) && !u.isArray(e);
};
u.isEmptyObject = function(e) {
  if (u.isObject(e)) {
    for (var t in e)
      if (zt.call(e, t))
        return !1;
    return !0;
  }
  return !1;
};
u.isUndefined = function(e) {
  return e === void 0;
};
u.isString = function(e) {
  return dt.call(e) == "[object String]";
};
u.isDate = function(e) {
  return dt.call(e) == "[object Date]";
};
u.isNumber = function(e) {
  return dt.call(e) == "[object Number]";
};
u.isElement = function(e) {
  return !!(e && e.nodeType === 1);
};
u.encodeDates = function(e) {
  return u.each(e, function(t, r) {
    u.isDate(t) ? e[r] = u.formatDate(t) : u.isObject(t) && (e[r] = u.encodeDates(t));
  }), e;
};
u.timestamp = function() {
  return Date.now = Date.now || function() {
    return +/* @__PURE__ */ new Date();
  }, Date.now();
};
u.formatDate = function(e) {
  function t(r) {
    return r < 10 ? "0" + r : r;
  }
  return e.getUTCFullYear() + "-" + t(e.getUTCMonth() + 1) + "-" + t(e.getUTCDate()) + "T" + t(e.getUTCHours()) + ":" + t(e.getUTCMinutes()) + ":" + t(e.getUTCSeconds());
};
u.strip_empty_properties = function(e) {
  var t = {};
  return u.each(e, function(r, i) {
    u.isString(r) && r.length > 0 && (t[i] = r);
  }), t;
};
u.truncate = function(e, t) {
  var r;
  return typeof e == "string" ? r = e.slice(0, t) : u.isArray(e) ? (r = [], u.each(e, function(i) {
    r.push(u.truncate(i, t));
  })) : u.isObject(e) ? (r = {}, u.each(e, function(i, n) {
    r[n] = u.truncate(i, t);
  })) : r = e, r;
};
u.JSONEncode = /* @__PURE__ */ function() {
  return function(e) {
    var t = e, r = function(n) {
      var s = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, o = {
        // table of character substitutions
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      };
      return s.lastIndex = 0, s.test(n) ? '"' + n.replace(s, function(c) {
        var a = o[c];
        return typeof a == "string" ? a : "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + n + '"';
    }, i = function(n, s) {
      var o = "", c = "    ", a = 0, f = "", l = "", d = 0, p = o, h = [], m = s[n];
      switch (m && typeof m == "object" && typeof m.toJSON == "function" && (m = m.toJSON(n)), typeof m) {
        case "string":
          return r(m);
        case "number":
          return isFinite(m) ? String(m) : "null";
        case "boolean":
        case "null":
          return String(m);
        case "object":
          if (!m)
            return "null";
          if (o += c, h = [], dt.apply(m) === "[object Array]") {
            for (d = m.length, a = 0; a < d; a += 1)
              h[a] = i(a, m) || "null";
            return l = h.length === 0 ? "[]" : o ? `[
` + o + h.join(`,
` + o) + `
` + p + "]" : "[" + h.join(",") + "]", o = p, l;
          }
          for (f in m)
            zt.call(m, f) && (l = i(f, m), l && h.push(r(f) + (o ? ": " : ":") + l));
          return l = h.length === 0 ? "{}" : o ? "{" + h.join(",") + p + "}" : "{" + h.join(",") + "}", o = p, l;
      }
    };
    return i("", {
      "": t
    });
  };
}();
u.JSONDecode = function() {
  var e, t, r = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, i, n = function(h) {
    var m = new SyntaxError(h);
    throw m.at = e, m.text = i, m;
  }, s = function(h) {
    return h && h !== t && n("Expected '" + h + "' instead of '" + t + "'"), t = i.charAt(e), e += 1, t;
  }, o = function() {
    var h, m = "";
    for (t === "-" && (m = "-", s("-")); t >= "0" && t <= "9"; )
      m += t, s();
    if (t === ".")
      for (m += "."; s() && t >= "0" && t <= "9"; )
        m += t;
    if (t === "e" || t === "E")
      for (m += t, s(), (t === "-" || t === "+") && (m += t, s()); t >= "0" && t <= "9"; )
        m += t, s();
    if (h = +m, !isFinite(h))
      n("Bad number");
    else
      return h;
  }, c = function() {
    var h, m, _ = "", y;
    if (t === '"')
      for (; s(); ) {
        if (t === '"')
          return s(), _;
        if (t === "\\")
          if (s(), t === "u") {
            for (y = 0, m = 0; m < 4 && (h = parseInt(s(), 16), !!isFinite(h)); m += 1)
              y = y * 16 + h;
            _ += String.fromCharCode(y);
          } else if (typeof r[t] == "string")
            _ += r[t];
          else
            break;
        else
          _ += t;
      }
    n("Bad string");
  }, a = function() {
    for (; t && t <= " "; )
      s();
  }, f = function() {
    switch (t) {
      case "t":
        return s("t"), s("r"), s("u"), s("e"), !0;
      case "f":
        return s("f"), s("a"), s("l"), s("s"), s("e"), !1;
      case "n":
        return s("n"), s("u"), s("l"), s("l"), null;
    }
    n('Unexpected "' + t + '"');
  }, l, d = function() {
    var h = [];
    if (t === "[") {
      if (s("["), a(), t === "]")
        return s("]"), h;
      for (; t; ) {
        if (h.push(l()), a(), t === "]")
          return s("]"), h;
        s(","), a();
      }
    }
    n("Bad array");
  }, p = function() {
    var h, m = {};
    if (t === "{") {
      if (s("{"), a(), t === "}")
        return s("}"), m;
      for (; t; ) {
        if (h = c(), a(), s(":"), Object.hasOwnProperty.call(m, h) && n('Duplicate key "' + h + '"'), m[h] = l(), a(), t === "}")
          return s("}"), m;
        s(","), a();
      }
    }
    n("Bad object");
  };
  return l = function() {
    switch (a(), t) {
      case "{":
        return p();
      case "[":
        return d();
      case '"':
        return c();
      case "-":
        return o();
      default:
        return t >= "0" && t <= "9" ? o() : f();
    }
  }, function(h) {
    var m;
    return i = h, e = 0, t = " ", m = l(), a(), t && n("Syntax error"), m;
  };
}();
u.base64Encode = function(e) {
  var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r, i, n, s, o, c, a, f, l = 0, d = 0, p = "", h = [];
  if (!e)
    return e;
  e = u.utf8Encode(e);
  do
    r = e.charCodeAt(l++), i = e.charCodeAt(l++), n = e.charCodeAt(l++), f = r << 16 | i << 8 | n, s = f >> 18 & 63, o = f >> 12 & 63, c = f >> 6 & 63, a = f & 63, h[d++] = t.charAt(s) + t.charAt(o) + t.charAt(c) + t.charAt(a);
  while (l < e.length);
  switch (p = h.join(""), e.length % 3) {
    case 1:
      p = p.slice(0, -2) + "==";
      break;
    case 2:
      p = p.slice(0, -1) + "=";
      break;
  }
  return p;
};
u.utf8Encode = function(e) {
  e = (e + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`);
  var t = "", r, i, n = 0, s;
  for (r = i = 0, n = e.length, s = 0; s < n; s++) {
    var o = e.charCodeAt(s), c = null;
    o < 128 ? i++ : o > 127 && o < 2048 ? c = String.fromCharCode(o >> 6 | 192, o & 63 | 128) : c = String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, o & 63 | 128), c !== null && (i > r && (t += e.substring(r, i)), t += c, r = i = s + 1);
  }
  return i > r && (t += e.substring(r, e.length)), t;
};
u.UUID = /* @__PURE__ */ function() {
  var e = function() {
    var i = 1 * /* @__PURE__ */ new Date(), n;
    if (k.performance && k.performance.now)
      n = k.performance.now();
    else
      for (n = 0; i == 1 * /* @__PURE__ */ new Date(); )
        n++;
    return i.toString(16) + Math.floor(n).toString(16);
  }, t = function() {
    return Math.random().toString(16).replace(".", "");
  }, r = function() {
    var i = pe, n, s, o = [], c = 0;
    function a(f, l) {
      var d, p = 0;
      for (d = 0; d < l.length; d++)
        p |= o[d] << d * 8;
      return f ^ p;
    }
    for (n = 0; n < i.length; n++)
      s = i.charCodeAt(n), o.unshift(s & 255), o.length >= 4 && (c = a(c, o), o = []);
    return o.length > 0 && (c = a(c, o)), c.toString(16);
  };
  return function() {
    var i = (Ft.height * Ft.width).toString(16);
    return e() + "-" + t() + "-" + r() + "-" + i + "-" + e();
  };
}();
var ui = [
  "ahrefsbot",
  "ahrefssiteaudit",
  "baiduspider",
  "bingbot",
  "bingpreview",
  "chrome-lighthouse",
  "facebookexternal",
  "petalbot",
  "pinterest",
  "screaming frog",
  "yahoo! slurp",
  "yandexbot",
  // a whole bunch of goog-specific crawlers
  // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
  "adsbot-google",
  "apis-google",
  "duplexweb-google",
  "feedfetcher-google",
  "google favicon",
  "google web preview",
  "google-read-aloud",
  "googlebot",
  "googleweblight",
  "mediapartners-google",
  "storebot-google"
];
u.isBlockedUA = function(e) {
  var t;
  for (e = e.toLowerCase(), t = 0; t < ui.length; t++)
    if (e.indexOf(ui[t]) !== -1)
      return !0;
  return !1;
};
u.HTTPBuildQuery = function(e, t) {
  var r, i, n = [];
  return u.isUndefined(t) && (t = "&"), u.each(e, function(s, o) {
    r = encodeURIComponent(s.toString()), i = encodeURIComponent(o), n[n.length] = i + "=" + r;
  }), n.join(t);
};
u.getQueryParam = function(e, t) {
  t = t.replace(/[[]/g, "\\[").replace(/[\]]/g, "\\]");
  var r = "[\\?&]" + t + "=([^&#]*)", i = new RegExp(r), n = i.exec(e);
  if (n === null || n && typeof n[1] != "string" && n[1].length)
    return "";
  var s = n[1];
  try {
    s = decodeURIComponent(s);
  } catch {
    L.error("Skipping decoding for malformed query param: " + s);
  }
  return s.replace(/\+/g, " ");
};
u.cookie = {
  get: function(e) {
    for (var t = e + "=", r = P.cookie.split(";"), i = 0; i < r.length; i++) {
      for (var n = r[i]; n.charAt(0) == " "; )
        n = n.substring(1, n.length);
      if (n.indexOf(t) === 0)
        return decodeURIComponent(n.substring(t.length, n.length));
    }
    return null;
  },
  parse: function(e) {
    var t;
    try {
      t = u.JSONDecode(u.cookie.get(e)) || {};
    } catch {
    }
    return t;
  },
  set_seconds: function(e, t, r, i, n, s, o) {
    var c = "", a = "", f = "";
    if (o)
      c = "; domain=" + o;
    else if (i) {
      var l = ci(P.location.hostname);
      c = l ? "; domain=." + l : "";
    }
    if (r) {
      var d = /* @__PURE__ */ new Date();
      d.setTime(d.getTime() + r * 1e3), a = "; expires=" + d.toGMTString();
    }
    s && (n = !0, f = "; SameSite=None"), n && (f += "; secure"), P.cookie = e + "=" + encodeURIComponent(t) + a + "; path=/" + c + f;
  },
  set: function(e, t, r, i, n, s, o) {
    var c = "", a = "", f = "";
    if (o)
      c = "; domain=" + o;
    else if (i) {
      var l = ci(P.location.hostname);
      c = l ? "; domain=." + l : "";
    }
    if (r) {
      var d = /* @__PURE__ */ new Date();
      d.setTime(d.getTime() + r * 24 * 60 * 60 * 1e3), a = "; expires=" + d.toGMTString();
    }
    s && (n = !0, f = "; SameSite=None"), n && (f += "; secure");
    var p = e + "=" + encodeURIComponent(t) + a + "; path=/" + c + f;
    return P.cookie = p, p;
  },
  remove: function(e, t, r) {
    u.cookie.set(e, "", -1, t, !1, !1, r);
  }
};
var sr = null, Lt = function(e, t) {
  if (sr !== null && !t)
    return sr;
  var r = !0;
  try {
    e = e || window.localStorage;
    var i = "__mplss_" + br(8), n = "xyz";
    e.setItem(i, n), e.getItem(i) !== n && (r = !1), e.removeItem(i);
  } catch {
    r = !1;
  }
  return sr = r, r;
};
u.localStorage = {
  is_supported: function(e) {
    var t = Lt(null, e);
    return t || L.error("localStorage unsupported; falling back to cookie store"), t;
  },
  error: function(e) {
    L.error("localStorage error: " + e);
  },
  get: function(e) {
    try {
      return window.localStorage.getItem(e);
    } catch (t) {
      u.localStorage.error(t);
    }
    return null;
  },
  parse: function(e) {
    try {
      return u.JSONDecode(u.localStorage.get(e)) || {};
    } catch {
    }
    return null;
  },
  set: function(e, t) {
    try {
      window.localStorage.setItem(e, t);
    } catch (r) {
      u.localStorage.error(r);
    }
  },
  remove: function(e) {
    try {
      window.localStorage.removeItem(e);
    } catch (t) {
      u.localStorage.error(t);
    }
  }
};
u.register_event = function() {
  var e = function(i, n, s, o, c) {
    if (!i) {
      L.error("No valid element provided to register_event");
      return;
    }
    if (i.addEventListener && !o)
      i.addEventListener(n, s, !!c);
    else {
      var a = "on" + n, f = i[a];
      i[a] = t(i, s, f);
    }
  };
  function t(i, n, s) {
    var o = function(c) {
      if (c = c || r(window.event), !!c) {
        var a = !0, f, l;
        return u.isFunction(s) && (f = s(c)), l = n.call(i, c), (f === !1 || l === !1) && (a = !1), a;
      }
    };
    return o;
  }
  function r(i) {
    return i && (i.preventDefault = r.preventDefault, i.stopPropagation = r.stopPropagation), i;
  }
  return r.preventDefault = function() {
    this.returnValue = !1;
  }, r.stopPropagation = function() {
    this.cancelBubble = !0;
  }, e;
}();
var Io = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
u.dom_query = /* @__PURE__ */ function() {
  function e(n) {
    return n.all ? n.all : n.getElementsByTagName("*");
  }
  var t = /[\t\r\n]/g;
  function r(n, s) {
    var o = " " + s + " ";
    return (" " + n.className + " ").replace(t, " ").indexOf(o) >= 0;
  }
  function i(n) {
    if (!P.getElementsByTagName)
      return [];
    var s = n.split(" "), o, c, a, f, l, d, p, h, m, _, y = [P];
    for (d = 0; d < s.length; d++) {
      if (o = s[d].replace(/^\s+/, "").replace(/\s+$/, ""), o.indexOf("#") > -1) {
        c = o.split("#"), a = c[0];
        var v = c[1], S = P.getElementById(v);
        if (!S || a && S.nodeName.toLowerCase() != a)
          return [];
        y = [S];
        continue;
      }
      if (o.indexOf(".") > -1) {
        c = o.split("."), a = c[0];
        var b = c[1];
        for (a || (a = "*"), f = [], l = 0, p = 0; p < y.length; p++)
          for (a == "*" ? m = e(y[p]) : m = y[p].getElementsByTagName(a), h = 0; h < m.length; h++)
            f[l++] = m[h];
        for (y = [], _ = 0, p = 0; p < f.length; p++)
          f[p].className && u.isString(f[p].className) && // some SVG elements have classNames which are not strings
          r(f[p], b) && (y[_++] = f[p]);
        continue;
      }
      var w = o.match(Io);
      if (w) {
        a = w[1];
        var x = w[2], C = w[3], $ = w[4];
        for (a || (a = "*"), f = [], l = 0, p = 0; p < y.length; p++)
          for (a == "*" ? m = e(y[p]) : m = y[p].getElementsByTagName(a), h = 0; h < m.length; h++)
            f[l++] = m[h];
        y = [], _ = 0;
        var D;
        switch (C) {
          case "=":
            D = function(N) {
              return N.getAttribute(x) == $;
            };
            break;
          case "~":
            D = function(N) {
              return N.getAttribute(x).match(new RegExp("\\b" + $ + "\\b"));
            };
            break;
          case "|":
            D = function(N) {
              return N.getAttribute(x).match(new RegExp("^" + $ + "-?"));
            };
            break;
          case "^":
            D = function(N) {
              return N.getAttribute(x).indexOf($) === 0;
            };
            break;
          case "$":
            D = function(N) {
              return N.getAttribute(x).lastIndexOf($) == N.getAttribute(x).length - $.length;
            };
            break;
          case "*":
            D = function(N) {
              return N.getAttribute(x).indexOf($) > -1;
            };
            break;
          default:
            D = function(N) {
              return N.getAttribute(x);
            };
        }
        for (y = [], _ = 0, p = 0; p < f.length; p++)
          D(f[p]) && (y[_++] = f[p]);
        continue;
      }
      for (a = o, f = [], l = 0, p = 0; p < y.length; p++)
        for (m = y[p].getElementsByTagName(a), h = 0; h < m.length; h++)
          f[l++] = m[h];
      y = f;
    }
    return y;
  }
  return function(n) {
    return u.isElement(n) ? [n] : u.isObject(n) && !u.isUndefined(n.length) ? n : i.call(this, n);
  };
}();
var Mo = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "utm_source_platform", "utm_campaign_id", "utm_creative_format", "utm_marketing_tactic"], Co = ["dclid", "fbclid", "gclid", "ko_click_id", "li_fat_id", "msclkid", "sccid", "ttclid", "twclid", "wbraid"];
u.info = {
  campaignParams: function(e) {
    var t = "", r = {};
    return u.each(Mo, function(i) {
      t = u.getQueryParam(P.URL, i), t.length ? r[i] = t : e !== void 0 && (r[i] = e);
    }), r;
  },
  clickParams: function() {
    var e = "", t = {};
    return u.each(Co, function(r) {
      e = u.getQueryParam(P.URL, r), e.length && (t[r] = e);
    }), t;
  },
  marketingParams: function() {
    return u.extend(u.info.campaignParams(), u.info.clickParams());
  },
  searchEngine: function(e) {
    return e.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : e.search("https?://(.*)bing.com") === 0 ? "bing" : e.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : e.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null;
  },
  searchInfo: function(e) {
    var t = u.info.searchEngine(e), r = t != "yahoo" ? "q" : "p", i = {};
    if (t !== null) {
      i.$search_engine = t;
      var n = u.getQueryParam(e, r);
      n.length && (i.mp_keyword = n);
    }
    return i;
  },
  /**
   * This function detects which browser is running this script.
   * The order of the checks are important since many user agents
   * include key words used in later checks.
   */
  browser: function(e, t, r) {
    return t = t || "", r || u.includes(e, " OPR/") ? u.includes(e, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : u.includes(e, "IEMobile") || u.includes(e, "WPDesktop") ? "Internet Explorer Mobile" : u.includes(e, "SamsungBrowser/") ? "Samsung Internet" : u.includes(e, "Edge") || u.includes(e, "Edg/") ? "Microsoft Edge" : u.includes(e, "FBIOS") ? "Facebook Mobile" : u.includes(e, "Chrome") ? "Chrome" : u.includes(e, "CriOS") ? "Chrome iOS" : u.includes(e, "UCWEB") || u.includes(e, "UCBrowser") ? "UC Browser" : u.includes(e, "FxiOS") ? "Firefox iOS" : u.includes(t, "Apple") ? u.includes(e, "Mobile") ? "Mobile Safari" : "Safari" : u.includes(e, "Android") ? "Android Mobile" : u.includes(e, "Konqueror") ? "Konqueror" : u.includes(e, "Firefox") ? "Firefox" : u.includes(e, "MSIE") || u.includes(e, "Trident/") ? "Internet Explorer" : u.includes(e, "Gecko") ? "Mozilla" : "";
  },
  /**
   * This function detects which browser version is running this script,
   * parsing major and minor version (e.g., 42.1). User agent strings from:
   * http://www.useragentstring.com/pages/useragentstring.php
   */
  browserVersion: function(e, t, r) {
    var i = u.info.browser(e, t, r), n = {
      "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
      "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
      "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      "Android Mobile": /android\s(\d+(\.\d+)?)/,
      "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
      "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/
    }, s = n[i];
    if (s === void 0)
      return null;
    var o = e.match(s);
    return o ? parseFloat(o[o.length - 2]) : null;
  },
  os: function() {
    var e = pe;
    return /Windows/i.test(e) ? /Phone/.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : "Windows" : /(iPhone|iPad|iPod)/.test(e) ? "iOS" : /Android/.test(e) ? "Android" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Mac/i.test(e) ? "Mac OS X" : /Linux/.test(e) ? "Linux" : /CrOS/.test(e) ? "Chrome OS" : "";
  },
  device: function(e) {
    return /Windows Phone/i.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : /iPad/.test(e) ? "iPad" : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Android/.test(e) ? "Android" : "";
  },
  referringDomain: function(e) {
    var t = e.split("/");
    return t.length >= 3 ? t[2] : "";
  },
  currentUrl: function() {
    return k.location.href;
  },
  properties: function(e) {
    return typeof e != "object" && (e = {}), u.extend(u.strip_empty_properties({
      $os: u.info.os(),
      $browser: u.info.browser(pe, Ee.vendor, St),
      $referrer: P.referrer,
      $referring_domain: u.info.referringDomain(P.referrer),
      $device: u.info.device(pe)
    }), {
      $current_url: u.info.currentUrl(),
      $browser_version: u.info.browserVersion(pe, Ee.vendor, St),
      $screen_height: Ft.height,
      $screen_width: Ft.width,
      mp_lib: "web",
      $lib_version: ve.LIB_VERSION,
      $insert_id: br(),
      time: u.timestamp() / 1e3
      // epoch time in seconds
    }, u.strip_empty_properties(e));
  },
  people_properties: function() {
    return u.extend(u.strip_empty_properties({
      $os: u.info.os(),
      $browser: u.info.browser(pe, Ee.vendor, St)
    }), {
      $browser_version: u.info.browserVersion(pe, Ee.vendor, St)
    });
  },
  mpPageViewProperties: function() {
    return u.strip_empty_properties({
      current_page_title: P.title,
      current_domain: k.location.hostname,
      current_url_path: k.location.pathname,
      current_url_protocol: k.location.protocol,
      current_url_search: k.location.search
    });
  }
};
var br = function(e) {
  var t = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  return e ? t.substring(0, e) : t;
}, To = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, Do = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, ci = function(e) {
  var t = Do, r = e.split("."), i = r[r.length - 1];
  (i.length > 4 || i === "com" || i === "org") && (t = To);
  var n = e.match(t);
  return n ? n[0] : "";
}, No = function() {
  var e = k.navigator.onLine;
  return u.isUndefined(e) || e;
}, $t = null, Pt = null;
typeof JSON < "u" && ($t = JSON.stringify, Pt = JSON.parse);
$t = $t || u.JSONEncode;
Pt = Pt || u.JSONDecode;
u.toArray = u.toArray;
u.isObject = u.isObject;
u.JSONEncode = u.JSONEncode;
u.JSONDecode = u.JSONDecode;
u.isBlockedUA = u.isBlockedUA;
u.isEmptyObject = u.isEmptyObject;
u.info = u.info;
u.info.device = u.info.device;
u.info.browser = u.info.browser;
u.info.browserVersion = u.info.browserVersion;
u.info.properties = u.info.properties;
var Ro = "__mp_opt_in_out_";
function Ao(e, t) {
  rn(!0, e, t);
}
function Fo(e, t) {
  rn(!1, e, t);
}
function Lo(e, t) {
  return tn(e, t) === "1";
}
function en(e, t) {
  if (Po(t))
    return L.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"'), !0;
  var r = tn(e, t) === "0";
  return r && L.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data."), r;
}
function Me(e) {
  return xr(e, function(t) {
    return this.get_config(t);
  });
}
function Ce(e) {
  return xr(e, function(t) {
    return this._get_config(t);
  });
}
function et(e) {
  return xr(e, function(t) {
    return this._get_config(t);
  });
}
function $o(e, t) {
  t = t || {}, Sr(t).remove(
    wr(e, t),
    !!t.crossSubdomainCookie,
    t.cookieDomain
  );
}
function Sr(e) {
  return e = e || {}, e.persistenceType === "localStorage" ? u.localStorage : u.cookie;
}
function wr(e, t) {
  return t = t || {}, (t.persistencePrefix || Ro) + e;
}
function tn(e, t) {
  return Sr(t).get(wr(e, t));
}
function Po(e) {
  if (e && e.ignoreDnt)
    return !1;
  var t = e && e.window || k, r = t.navigator || {}, i = !1;
  return u.each([
    r.doNotTrack,
    // standard
    r.msDoNotTrack,
    t.doNotTrack
  ], function(n) {
    u.includes([!0, 1, "1", "yes"], n) && (i = !0);
  }), i;
}
function rn(e, t, r) {
  if (!u.isString(t) || !t.length) {
    L.error("gdpr." + (e ? "optIn" : "optOut") + " called with an invalid token");
    return;
  }
  r = r || {}, Sr(r).set(
    wr(t, r),
    e ? 1 : 0,
    u.isNumber(r.cookieExpiration) ? r.cookieExpiration : null,
    !!r.crossSubdomainCookie,
    !!r.secureCookie,
    !!r.crossSiteCookie,
    r.cookieDomain
  ), r.track && e && r.track(r.trackEventName || "$opt_in", r.trackProperties, {
    send_immediately: !0
  });
}
function xr(e, t) {
  return function() {
    var r = !1;
    try {
      var i = t.call(this, "token"), n = t.call(this, "ignore_dnt"), s = t.call(this, "opt_out_tracking_persistence_type"), o = t.call(this, "opt_out_tracking_cookie_prefix"), c = t.call(this, "window");
      i && (r = en(i, {
        ignoreDnt: n,
        persistenceType: s,
        persistencePrefix: o,
        window: c
      }));
    } catch (f) {
      L.error("Unexpected error when checking tracking opt-out status: " + f);
    }
    if (!r)
      return e.apply(this, arguments);
    var a = arguments[arguments.length - 1];
    typeof a == "function" && a(0);
  };
}
var qo = Wt("lock"), nn = function(e, t) {
  t = t || {}, this.storageKey = e, this.storage = t.storage || window.localStorage, this.pollIntervalMS = t.pollIntervalMS || 100, this.timeoutMS = t.timeoutMS || 2e3;
};
nn.prototype.withLock = function(e, t, r) {
  !r && typeof t != "function" && (r = t, t = null);
  var i = r || (/* @__PURE__ */ new Date()).getTime() + "|" + Math.random(), n = (/* @__PURE__ */ new Date()).getTime(), s = this.storageKey, o = this.pollIntervalMS, c = this.timeoutMS, a = this.storage, f = s + ":X", l = s + ":Y", d = s + ":Z", p = function(S) {
    t && t(S);
  }, h = function(S) {
    if ((/* @__PURE__ */ new Date()).getTime() - n > c) {
      qo.error("Timeout waiting for mutex on " + s + "; clearing lock. [" + i + "]"), a.removeItem(d), a.removeItem(l), y();
      return;
    }
    setTimeout(function() {
      try {
        S();
      } catch (b) {
        p(b);
      }
    }, o * (Math.random() + 0.1));
  }, m = function(S, b) {
    S() ? b() : h(function() {
      m(S, b);
    });
  }, _ = function() {
    var S = a.getItem(l);
    if (S && S !== i)
      return !1;
    if (a.setItem(l, i), a.getItem(l) === i)
      return !0;
    if (!Lt(a, !0))
      throw new Error("localStorage support dropped while acquiring lock");
    return !1;
  }, y = function() {
    a.setItem(f, i), m(_, function() {
      if (a.getItem(f) === i) {
        v();
        return;
      }
      h(function() {
        if (a.getItem(l) !== i) {
          y();
          return;
        }
        m(function() {
          return !a.getItem(d);
        }, v);
      });
    });
  }, v = function() {
    a.setItem(d, "1");
    try {
      e();
    } finally {
      a.removeItem(d), a.getItem(l) === i && a.removeItem(l), a.getItem(f) === i && a.removeItem(f);
    }
  };
  try {
    if (Lt(a, !0))
      y();
    else
      throw new Error("localStorage support check failed");
  } catch (S) {
    p(S);
  }
};
var li = Wt("batch"), Te = function(e, t) {
  t = t || {}, this.storageKey = e, this.storage = t.storage || window.localStorage, this.reportError = t.errorReporter || u.bind(li.error, li), this.lock = new nn(e, { storage: this.storage }), this.usePersistence = t.usePersistence, this.pid = t.pid || null, this.memQueue = [];
};
Te.prototype.enqueue = function(e, t, r) {
  var i = {
    id: br(),
    flushAfter: (/* @__PURE__ */ new Date()).getTime() + t * 2,
    payload: e
  };
  this.usePersistence ? this.lock.withLock(u.bind(function() {
    var s;
    try {
      var o = this.readFromStorage();
      o.push(i), s = this.saveToStorage(o), s && this.memQueue.push(i);
    } catch {
      this.reportError("Error enqueueing item", e), s = !1;
    }
    r && r(s);
  }, this), u.bind(function(s) {
    this.reportError("Error acquiring storage lock", s), r && r(!1);
  }, this), this.pid) : (this.memQueue.push(i), r && r(!0));
};
Te.prototype.fillBatch = function(e) {
  var t = this.memQueue.slice(0, e);
  if (this.usePersistence && t.length < e) {
    var r = this.readFromStorage();
    if (r.length) {
      var i = {};
      u.each(t, function(o) {
        i[o.id] = !0;
      });
      for (var n = 0; n < r.length; n++) {
        var s = r[n];
        if ((/* @__PURE__ */ new Date()).getTime() > s.flushAfter && !i[s.id] && (s.orphaned = !0, t.push(s), t.length >= e))
          break;
      }
    }
  }
  return t;
};
var fi = function(e, t) {
  var r = [];
  return u.each(e, function(i) {
    i.id && !t[i.id] && r.push(i);
  }), r;
};
Te.prototype.removeItemsByID = function(e, t) {
  var r = {};
  if (u.each(e, function(n) {
    r[n] = !0;
  }), this.memQueue = fi(this.memQueue, r), !this.usePersistence)
    t && t(!0);
  else {
    var i = u.bind(function() {
      var n;
      try {
        var s = this.readFromStorage();
        if (s = fi(s, r), n = this.saveToStorage(s), n) {
          s = this.readFromStorage();
          for (var o = 0; o < s.length; o++) {
            var c = s[o];
            if (c.id && r[c.id])
              return this.reportError("Item not removed from storage"), !1;
          }
        }
      } catch {
        this.reportError("Error removing items", e), n = !1;
      }
      return n;
    }, this);
    this.lock.withLock(function() {
      var s = i();
      t && t(s);
    }, u.bind(function(s) {
      var o = !1;
      if (this.reportError("Error acquiring storage lock", s), !Lt(this.storage, !0) && (o = i(), !o))
        try {
          this.storage.removeItem(this.storageKey);
        } catch (c) {
          this.reportError("Error clearing queue", c);
        }
      t && t(o);
    }, this), this.pid);
  }
};
var di = function(e, t) {
  var r = [];
  return u.each(e, function(i) {
    var n = i.id;
    if (n in t) {
      var s = t[n];
      s !== null && (i.payload = s, r.push(i));
    } else
      r.push(i);
  }), r;
};
Te.prototype.updatePayloads = function(e, t) {
  this.memQueue = di(this.memQueue, e), this.usePersistence ? this.lock.withLock(u.bind(function() {
    var i;
    try {
      var n = this.readFromStorage();
      n = di(n, e), i = this.saveToStorage(n);
    } catch {
      this.reportError("Error updating items", e), i = !1;
    }
    t && t(i);
  }, this), u.bind(function(i) {
    this.reportError("Error acquiring storage lock", i), t && t(!1);
  }, this), this.pid) : t && t(!0);
};
Te.prototype.readFromStorage = function() {
  var e;
  try {
    e = this.storage.getItem(this.storageKey), e && (e = Pt(e), u.isArray(e) || (this.reportError("Invalid storage entry:", e), e = null));
  } catch (t) {
    this.reportError("Error retrieving queue", t), e = null;
  }
  return e || [];
};
Te.prototype.saveToStorage = function(e) {
  try {
    return this.storage.setItem(this.storageKey, $t(e)), !0;
  } catch (t) {
    return this.reportError("Error saving queue", t), !1;
  }
};
Te.prototype.clear = function() {
  this.memQueue = [], this.usePersistence && this.storage.removeItem(this.storageKey);
};
var Uo = 10 * 60 * 1e3, st = Wt("batch"), ae = function(e, t) {
  this.errorReporter = t.errorReporter, this.queue = new Te(e, {
    errorReporter: u.bind(this.reportError, this),
    storage: t.storage,
    usePersistence: t.usePersistence
  }), this.libConfig = t.libConfig, this.sendRequest = t.sendRequestFunc, this.beforeSendHook = t.beforeSendHook, this.stopAllBatching = t.stopAllBatchingFunc, this.batchSize = this.libConfig.batch_size, this.flushInterval = this.libConfig.batch_flush_interval_ms, this.stopped = !this.libConfig.batch_autostart, this.consecutiveRemovalFailures = 0, this.itemIdsSentSuccessfully = {}, this.flushOnlyOnInterval = t.flushOnlyOnInterval || !1;
};
ae.prototype.enqueue = function(e, t) {
  this.queue.enqueue(e, this.flushInterval, t);
};
ae.prototype.start = function() {
  this.stopped = !1, this.consecutiveRemovalFailures = 0, this.flush();
};
ae.prototype.stop = function() {
  this.stopped = !0, this.timeoutID && (clearTimeout(this.timeoutID), this.timeoutID = null);
};
ae.prototype.clear = function() {
  this.queue.clear();
};
ae.prototype.resetBatchSize = function() {
  this.batchSize = this.libConfig.batch_size;
};
ae.prototype.resetFlush = function() {
  this.scheduleFlush(this.libConfig.batch_flush_interval_ms);
};
ae.prototype.scheduleFlush = function(e) {
  this.flushInterval = e, this.stopped || (this.timeoutID = setTimeout(u.bind(function() {
    this.stopped || this.flush();
  }, this), this.flushInterval));
};
ae.prototype.flush = function(e) {
  try {
    if (this.requestInProgress) {
      st.log("Flush: Request already in progress");
      return;
    }
    e = e || {};
    var t = this.libConfig.batch_request_timeout_ms, r = (/* @__PURE__ */ new Date()).getTime(), i = this.batchSize, n = this.queue.fillBatch(i), s = n.length === i, o = [], c = {};
    if (u.each(n, function(l) {
      var d = l.payload;
      if (this.beforeSendHook && !l.orphaned && (d = this.beforeSendHook(d)), d) {
        d.event && d.properties && (d.properties = u.extend(
          {},
          d.properties,
          { mp_sent_by_lib_version: ve.LIB_VERSION }
        ));
        var p = !0, h = l.id;
        h ? (this.itemIdsSentSuccessfully[h] || 0) > 5 && (this.reportError("[dupe] item ID sent too many times, not sending", {
          item: l,
          batchSize: n.length,
          timesSent: this.itemIdsSentSuccessfully[h]
        }), p = !1) : this.reportError("[dupe] found item with no ID", { item: l }), p && o.push(d);
      }
      c[l.id] = d;
    }, this), o.length < 1) {
      this.resetFlush();
      return;
    }
    this.requestInProgress = !0;
    var a = u.bind(function(l) {
      this.requestInProgress = !1;
      try {
        var d = !1;
        if (e.unloading)
          this.queue.updatePayloads(c);
        else if (u.isObject(l) && l.error === "timeout" && (/* @__PURE__ */ new Date()).getTime() - r >= t)
          this.reportError("Network timeout; retrying"), this.flush();
        else if (u.isObject(l) && (l.httpStatusCode >= 500 || l.httpStatusCode === 429 || l.httpStatusCode <= 0 && !No() || l.error === "timeout")) {
          var p = this.flushInterval * 2;
          l.retryAfter && (p = parseInt(l.retryAfter, 10) * 1e3 || p), p = Math.min(Uo, p), this.reportError("Error; retry in " + p + " ms"), this.scheduleFlush(p);
        } else if (u.isObject(l) && l.httpStatusCode === 413)
          if (n.length > 1) {
            var h = Math.max(1, Math.floor(i / 2));
            this.batchSize = Math.min(this.batchSize, h, n.length - 1), this.reportError("413 response; reducing batch size to " + this.batchSize), this.resetFlush();
          } else
            this.reportError("Single-event request too large; dropping", n), this.resetBatchSize(), d = !0;
        else
          d = !0;
        d && (this.queue.removeItemsByID(
          u.map(n, function(m) {
            return m.id;
          }),
          u.bind(function(m) {
            m ? (this.consecutiveRemovalFailures = 0, this.flushOnlyOnInterval && !s ? this.resetFlush() : this.flush()) : (this.reportError("Failed to remove items from queue"), ++this.consecutiveRemovalFailures > 5 ? (this.reportError("Too many queue failures; disabling batching system."), this.stopAllBatching()) : this.resetFlush());
          }, this)
        ), u.each(n, u.bind(function(m) {
          var _ = m.id;
          _ ? (this.itemIdsSentSuccessfully[_] = this.itemIdsSentSuccessfully[_] || 0, this.itemIdsSentSuccessfully[_]++, this.itemIdsSentSuccessfully[_] > 5 && this.reportError("[dupe] item ID sent too many times", {
            item: m,
            batchSize: n.length,
            timesSent: this.itemIdsSentSuccessfully[_]
          })) : this.reportError("[dupe] found item with no ID while removing", { item: m });
        }, this)));
      } catch (m) {
        this.reportError("Error handling API response", m), this.resetFlush();
      }
    }, this), f = {
      method: "POST",
      verbose: !0,
      ignore_json_errors: !0,
      // eslint-disable-line camelcase
      timeout_ms: t
      // eslint-disable-line camelcase
    };
    e.unloading && (f.transport = "sendBeacon"), st.log("MIXPANEL REQUEST:", o), this.sendRequest(o, f, a);
  } catch (l) {
    this.reportError("Error flushing request queue", l), this.resetFlush();
  }
};
ae.prototype.reportError = function(e, t) {
  if (st.error.apply(st.error, arguments), this.errorReporter)
    try {
      t instanceof Error || (t = new Error(e)), this.errorReporter(e, t);
    } catch (r) {
      st.error(r);
    }
};
var Fe = Wt("recorder"), pi = k.CompressionStream, jo = {
  batch_size: 1e3,
  batch_flush_interval_ms: 10 * 1e3,
  batch_request_timeout_ms: 90 * 1e3,
  batch_autostart: !0
}, Bo = /* @__PURE__ */ new Set([
  fe.MouseMove,
  fe.MouseInteraction,
  fe.Scroll,
  fe.ViewportResize,
  fe.Input,
  fe.TouchMove,
  fe.MediaInteraction,
  fe.Drag,
  fe.Selection
]);
function zo(e) {
  return e.type === Zi.IncrementalSnapshot && Bo.has(e.data.source);
}
var ue = function(e) {
  this._mixpanel = e, this._stopRecording = null, this.recEvents = [], this.seqNo = 0, this.replayId = null, this.replayStartTime = null, this.sendBatchId = null, this.idleTimeoutId = null, this.maxTimeoutId = null, this.recordMaxMs = nt, this.recordMinMs = 0, this._initBatcher();
};
ue.prototype._initBatcher = function() {
  this.batcher = new ae("__mprec", {
    libConfig: jo,
    sendRequestFunc: u.bind(this.flushEventsWithOptOut, this),
    errorReporter: u.bind(this.reportError, this),
    flushOnlyOnInterval: !0,
    usePersistence: !1
  });
};
ue.prototype.get_config = function(e) {
  return this._mixpanel.get_config(e);
};
ue.prototype.startRecording = function(e) {
  if (this._stopRecording !== null) {
    Fe.log("Recording already in progress, skipping startRecording.");
    return;
  }
  this.recordMaxMs = this.get_config("record_max_ms"), this.recordMaxMs > nt && (this.recordMaxMs = nt, Fe.critical("record_max_ms cannot be greater than " + nt + "ms. Capping value.")), this.recordMinMs = this.get_config("record_min_ms"), this.recordMinMs > rr && (this.recordMinMs = rr, Fe.critical("record_min_ms cannot be greater than " + rr + "ms. Capping value.")), this.recEvents = [], this.seqNo = 0, this.replayStartTime = (/* @__PURE__ */ new Date()).getTime(), this.replayId = u.UUID(), e || this.recordMinMs > 0 ? this.batcher.stop() : this.batcher.start();
  var t = u.bind(function() {
    clearTimeout(this.idleTimeoutId), this.idleTimeoutId = setTimeout(u.bind(function() {
      Fe.log("Idle timeout reached, restarting recording."), this.resetRecording();
    }, this), this.get_config("record_idle_timeout_ms"));
  }, this), r = this.get_config("record_block_selector");
  (r === "" || r === null) && (r = void 0), this._stopRecording = ft({
    emit: u.bind(function(i) {
      this.batcher.enqueue(i), zo(i) && (this.batcher.stopped && (/* @__PURE__ */ new Date()).getTime() - this.replayStartTime >= this.recordMinMs && this.batcher.start(), t());
    }, this),
    blockClass: this.get_config("record_block_class"),
    blockSelector: r,
    collectFonts: this.get_config("record_collect_fonts"),
    inlineImages: this.get_config("record_inline_images"),
    maskAllInputs: !0,
    maskTextClass: this.get_config("record_mask_text_class"),
    maskTextSelector: this.get_config("record_mask_text_selector")
  }), t(), this.maxTimeoutId = setTimeout(u.bind(this.resetRecording, this), this.recordMaxMs);
};
ue.prototype.resetRecording = function() {
  this.stopRecording(), this.startRecording(!0);
};
ue.prototype.stopRecording = function() {
  this._stopRecording !== null && (this._stopRecording(), this._stopRecording = null), this.batcher.stopped ? this.batcher.clear() : (this.batcher.flush(), this.batcher.stop()), this.replayId = null, clearTimeout(this.idleTimeoutId), clearTimeout(this.maxTimeoutId);
};
ue.prototype.flushEventsWithOptOut = function(e, t, r) {
  this._flushEvents(e, t, r, u.bind(this._onOptOut, this));
};
ue.prototype._onOptOut = function(e) {
  e === 0 && (this.recEvents = [], this.stopRecording());
};
ue.prototype._sendRequest = function(e, t, r, i) {
  var n = u.bind(function(s, o) {
    s.status === 200 && this.replayId === e && this.seqNo++, i({
      status: 0,
      httpStatusCode: s.status,
      responseBody: o,
      retryAfter: s.headers.get("Retry-After")
    });
  }, this);
  k.fetch(this.get_config("api_host") + "/" + this.get_config("api_routes").record + "?" + new URLSearchParams(t), {
    method: "POST",
    headers: {
      Authorization: "Basic " + btoa(this.get_config("token") + ":"),
      "Content-Type": "application/octet-stream"
    },
    body: r
  }).then(function(s) {
    s.json().then(function(o) {
      n(s, o);
    }).catch(function(o) {
      i({ error: o });
    });
  }).catch(function(s) {
    i({ error: s, httpStatusCode: 0 });
  });
};
ue.prototype._flushEvents = Me(function(e, t, r) {
  const i = e.length;
  if (i > 0) {
    var n = this.replayId, s = e[0].timestamp;
    (this.seqNo === 0 || !this.replayStartTime) && (this.seqNo !== 0 && this.reportError("Replay start time not set but seqNo is not 0. Using current batch start time as a fallback."), this.replayStartTime = s);
    var o = e[i - 1].timestamp - this.replayStartTime, c = {
      distinct_id: String(this._mixpanel.get_distinct_id()),
      seq: this.seqNo,
      batch_start_time: s / 1e3,
      replay_id: n,
      replay_length_ms: o,
      replay_start_time: this.replayStartTime / 1e3
    }, a = u.JSONEncode(e), f = this._mixpanel.get_property("$device_id");
    f && (c.$device_id = f);
    var l = this._mixpanel.get_property("$user_id");
    if (l && (c.$user_id = l), pi) {
      var d = new Blob([a], { type: "application/json" }).stream(), p = d.pipeThrough(new pi("gzip"));
      new Response(p).blob().then(u.bind(function(h) {
        c.format = "gzip", this._sendRequest(n, c, h, r);
      }, this));
    } else
      c.format = "body", this._sendRequest(n, c, a, r);
  }
});
ue.prototype.reportError = function(e, t) {
  Fe.error.apply(Fe.error, arguments);
  try {
    !t && !(e instanceof Error) && (e = new Error(e)), this.get_config("error_reporter")(e, t);
  } catch (r) {
    Fe.error(r);
  }
};
k.__mp_recorder = ue;
var Se = function() {
};
Se.prototype.create_properties = function() {
};
Se.prototype.event_handler = function() {
};
Se.prototype.after_track_handler = function() {
};
Se.prototype.init = function(e) {
  return this.mp = e, this;
};
Se.prototype.track = function(e, t, r, i) {
  var n = this, s = u.dom_query(e);
  if (s.length === 0) {
    L.error("The DOM query (" + e + ") returned 0 elements");
    return;
  }
  return u.each(s, function(o) {
    u.register_event(o, this.override_event, function(c) {
      var a = {}, f = n.create_properties(r, this), l = n.mp.get_config("track_links_timeout");
      n.event_handler(c, this, a), window.setTimeout(n.track_callback(i, f, a, !0), l), n.mp.track(t, f, n.track_callback(i, f, a));
    });
  }, this), !0;
};
Se.prototype.track_callback = function(e, t, r, i) {
  i = i || !1;
  var n = this;
  return function() {
    r.callback_fired || (r.callback_fired = !0, !(e && e(i, t) === !1) && n.after_track_handler(t, r, i));
  };
};
Se.prototype.create_properties = function(e, t) {
  var r;
  return typeof e == "function" ? r = e(t) : r = u.extend({}, e), r;
};
var Je = function() {
  this.override_event = "click";
};
u.inherit(Je, Se);
Je.prototype.create_properties = function(e, t) {
  var r = Je.superclass.create_properties.apply(this, arguments);
  return t.href && (r.url = t.href), r;
};
Je.prototype.event_handler = function(e, t, r) {
  r.new_tab = e.which === 2 || e.metaKey || e.ctrlKey || t.target === "_blank", r.href = t.href, r.new_tab || e.preventDefault();
};
Je.prototype.after_track_handler = function(e, t) {
  t.new_tab || setTimeout(function() {
    window.location = t.href;
  }, 0);
};
var Ht = function() {
  this.override_event = "submit";
};
u.inherit(Ht, Se);
Ht.prototype.event_handler = function(e, t, r) {
  r.element = t, e.preventDefault();
};
Ht.prototype.after_track_handler = function(e, t) {
  setTimeout(function() {
    t.element.submit();
  }, 0);
};
var Ie = "$set", Ze = "$set_once", se = "$unset", Pe = "$add", he = "$append", qe = "$union", be = "$remove", Wo = "$delete", sn = {
  set_action: function(e, t) {
    var r = {}, i = {};
    return u.isObject(e) ? u.each(e, function(n, s) {
      this._is_reserved_property(s) || (i[s] = n);
    }, this) : i[e] = t, r[Ie] = i, r;
  },
  unset_action: function(e) {
    var t = {}, r = [];
    return u.isArray(e) || (e = [e]), u.each(e, function(i) {
      this._is_reserved_property(i) || r.push(i);
    }, this), t[se] = r, t;
  },
  set_once_action: function(e, t) {
    var r = {}, i = {};
    return u.isObject(e) ? u.each(e, function(n, s) {
      this._is_reserved_property(s) || (i[s] = n);
    }, this) : i[e] = t, r[Ze] = i, r;
  },
  union_action: function(e, t) {
    var r = {}, i = {};
    return u.isObject(e) ? u.each(e, function(n, s) {
      this._is_reserved_property(s) || (i[s] = u.isArray(n) ? n : [n]);
    }, this) : i[e] = u.isArray(t) ? t : [t], r[qe] = i, r;
  },
  append_action: function(e, t) {
    var r = {}, i = {};
    return u.isObject(e) ? u.each(e, function(n, s) {
      this._is_reserved_property(s) || (i[s] = n);
    }, this) : i[e] = t, r[he] = i, r;
  },
  remove_action: function(e, t) {
    var r = {}, i = {};
    return u.isObject(e) ? u.each(e, function(n, s) {
      this._is_reserved_property(s) || (i[s] = n);
    }, this) : i[e] = t, r[be] = i, r;
  },
  delete_action: function() {
    var e = {};
    return e[Wo] = "", e;
  }
}, j = function() {
};
u.extend(j.prototype, sn);
j.prototype._init = function(e, t, r) {
  this._mixpanel = e, this._group_key = t, this._group_id = r;
};
j.prototype.set = et(function(e, t, r) {
  var i = this.set_action(e, t);
  return u.isObject(e) && (r = t), this._send_request(i, r);
});
j.prototype.set_once = et(function(e, t, r) {
  var i = this.set_once_action(e, t);
  return u.isObject(e) && (r = t), this._send_request(i, r);
});
j.prototype.unset = et(function(e, t) {
  var r = this.unset_action(e);
  return this._send_request(r, t);
});
j.prototype.union = et(function(e, t, r) {
  u.isObject(e) && (r = t);
  var i = this.union_action(e, t);
  return this._send_request(i, r);
});
j.prototype.delete = et(function(e) {
  var t = this.delete_action();
  return this._send_request(t, e);
});
j.prototype.remove = et(function(e, t, r) {
  var i = this.remove_action(e, t);
  return this._send_request(i, r);
});
j.prototype._send_request = function(e, t) {
  e.$group_key = this._group_key, e.$group_id = this._group_id, e.$token = this._get_config("token");
  var r = u.encodeDates(e);
  return this._mixpanel._track_or_batch({
    type: "groups",
    data: r,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").groups,
    batcher: this._mixpanel.request_batchers.groups
  }, t);
};
j.prototype._is_reserved_property = function(e) {
  return e === "$group_key" || e === "$group_id";
};
j.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
j.prototype.toString = function() {
  return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
j.prototype.remove = j.prototype.remove;
j.prototype.set = j.prototype.set;
j.prototype.set_once = j.prototype.set_once;
j.prototype.union = j.prototype.union;
j.prototype.unset = j.prototype.unset;
j.prototype.toString = j.prototype.toString;
var E = function() {
};
u.extend(E.prototype, sn);
E.prototype._init = function(e) {
  this._mixpanel = e;
};
E.prototype.set = Ce(function(e, t, r) {
  var i = this.set_action(e, t);
  return u.isObject(e) && (r = t), this._get_config("save_referrer") && this._mixpanel.persistence.update_referrer_info(document.referrer), i[Ie] = u.extend(
    {},
    u.info.people_properties(),
    i[Ie]
  ), this._send_request(i, r);
});
E.prototype.set_once = Ce(function(e, t, r) {
  var i = this.set_once_action(e, t);
  return u.isObject(e) && (r = t), this._send_request(i, r);
});
E.prototype.unset = Ce(function(e, t) {
  var r = this.unset_action(e);
  return this._send_request(r, t);
});
E.prototype.increment = Ce(function(e, t, r) {
  var i = {}, n = {};
  return u.isObject(e) ? (u.each(e, function(s, o) {
    if (!this._is_reserved_property(o))
      if (isNaN(parseFloat(s))) {
        L.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
        return;
      } else
        n[o] = s;
  }, this), r = t) : (u.isUndefined(t) && (t = 1), n[e] = t), i[Pe] = n, this._send_request(i, r);
});
E.prototype.append = Ce(function(e, t, r) {
  u.isObject(e) && (r = t);
  var i = this.append_action(e, t);
  return this._send_request(i, r);
});
E.prototype.remove = Ce(function(e, t, r) {
  u.isObject(e) && (r = t);
  var i = this.remove_action(e, t);
  return this._send_request(i, r);
});
E.prototype.union = Ce(function(e, t, r) {
  u.isObject(e) && (r = t);
  var i = this.union_action(e, t);
  return this._send_request(i, r);
});
E.prototype.track_charge = Ce(function(e, t, r) {
  if (!u.isNumber(e) && (e = parseFloat(e), isNaN(e))) {
    L.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
    return;
  }
  return this.append("$transactions", u.extend({
    $amount: e
  }, t), r);
});
E.prototype.clear_charges = function(e) {
  return this.set("$transactions", [], e);
};
E.prototype.delete_user = function() {
  if (!this._identify_called()) {
    L.error("mixpanel.people.delete_user() requires you to call identify() first");
    return;
  }
  var e = { $delete: this._mixpanel.get_distinct_id() };
  return this._send_request(e);
};
E.prototype.toString = function() {
  return this._mixpanel.toString() + ".people";
};
E.prototype._send_request = function(e, t) {
  e.$token = this._get_config("token"), e.$distinct_id = this._mixpanel.get_distinct_id();
  var r = this._mixpanel.get_property("$device_id"), i = this._mixpanel.get_property("$user_id"), n = this._mixpanel.get_property("$had_persisted_distinct_id");
  r && (e.$device_id = r), i && (e.$user_id = i), n && (e.$had_persisted_distinct_id = n);
  var s = u.encodeDates(e);
  return this._identify_called() ? this._mixpanel._track_or_batch({
    type: "people",
    data: s,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").engage,
    batcher: this._mixpanel.request_batchers.people
  }, t) : (this._enqueue(e), u.isUndefined(t) || (this._get_config("verbose") ? t({ status: -1, error: null }) : t(-1)), u.truncate(s, 255));
};
E.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
E.prototype._identify_called = function() {
  return this._mixpanel._flags.identify_called === !0;
};
E.prototype._enqueue = function(e) {
  Ie in e ? this._mixpanel.persistence._add_to_people_queue(Ie, e) : Ze in e ? this._mixpanel.persistence._add_to_people_queue(Ze, e) : se in e ? this._mixpanel.persistence._add_to_people_queue(se, e) : Pe in e ? this._mixpanel.persistence._add_to_people_queue(Pe, e) : he in e ? this._mixpanel.persistence._add_to_people_queue(he, e) : be in e ? this._mixpanel.persistence._add_to_people_queue(be, e) : qe in e ? this._mixpanel.persistence._add_to_people_queue(qe, e) : L.error("Invalid call to _enqueue():", e);
};
E.prototype._flush_one_queue = function(e, t, r, i) {
  var n = this, s = u.extend({}, this._mixpanel.persistence.load_queue(e)), o = s;
  !u.isUndefined(s) && u.isObject(s) && !u.isEmptyObject(s) && (n._mixpanel.persistence._pop_from_people_queue(e, s), n._mixpanel.persistence.save(), i && (o = i(s)), t.call(n, o, function(c, a) {
    c === 0 && n._mixpanel.persistence._add_to_people_queue(e, s), u.isUndefined(r) || r(c, a);
  }));
};
E.prototype._flush = function(e, t, r, i, n, s, o) {
  var c = this;
  this._flush_one_queue(Ie, this.set, e), this._flush_one_queue(Ze, this.set_once, i), this._flush_one_queue(se, this.unset, s, function(y) {
    return u.keys(y);
  }), this._flush_one_queue(Pe, this.increment, t), this._flush_one_queue(qe, this.union, n);
  var a = this._mixpanel.persistence.load_queue(he);
  if (!u.isUndefined(a) && u.isArray(a) && a.length)
    for (var f, l = function(y, v) {
      y === 0 && c._mixpanel.persistence._add_to_people_queue(he, f), u.isUndefined(r) || r(y, v);
    }, d = a.length - 1; d >= 0; d--)
      a = this._mixpanel.persistence.load_queue(he), f = a.pop(), c._mixpanel.persistence.save(), u.isEmptyObject(f) || c.append(f, l);
  var p = this._mixpanel.persistence.load_queue(be);
  if (!u.isUndefined(p) && u.isArray(p) && p.length)
    for (var h, m = function(y, v) {
      y === 0 && c._mixpanel.persistence._add_to_people_queue(be, h), u.isUndefined(o) || o(y, v);
    }, _ = p.length - 1; _ >= 0; _--)
      p = this._mixpanel.persistence.load_queue(be), h = p.pop(), c._mixpanel.persistence.save(), u.isEmptyObject(h) || c.remove(h, m);
};
E.prototype._is_reserved_property = function(e) {
  return e === "$distinct_id" || e === "$token" || e === "$device_id" || e === "$user_id" || e === "$had_persisted_distinct_id";
};
E.prototype.set = E.prototype.set;
E.prototype.set_once = E.prototype.set_once;
E.prototype.unset = E.prototype.unset;
E.prototype.increment = E.prototype.increment;
E.prototype.append = E.prototype.append;
E.prototype.remove = E.prototype.remove;
E.prototype.union = E.prototype.union;
E.prototype.track_charge = E.prototype.track_charge;
E.prototype.clear_charges = E.prototype.clear_charges;
E.prototype.delete_user = E.prototype.delete_user;
E.prototype.toString = E.prototype.toString;
var kr = "__mps", Er = "__mpso", Or = "__mpus", Ir = "__mpa", Mr = "__mpap", Cr = "__mpr", Tr = "__mpu", on = "$people_distinct_id", qt = "__alias", ut = "__timers", Ho = [
  kr,
  Er,
  Or,
  Ir,
  Mr,
  Cr,
  Tr,
  on,
  qt,
  ut
], M = function(e) {
  this.props = {}, this.campaign_params_saved = !1, e.persistence_name ? this.name = "mp_" + e.persistence_name : this.name = "mp_" + e.token + "_mixpanel";
  var t = e.persistence;
  t !== "cookie" && t !== "localStorage" && (L.critical("Unknown persistence type " + t + "; falling back to cookie"), t = e.persistence = "cookie"), t === "localStorage" && u.localStorage.is_supported() ? this.storage = u.localStorage : this.storage = u.cookie, this.load(), this.update_config(e), this.upgrade(), this.save();
};
M.prototype.properties = function() {
  var e = {};
  return this.load(), u.each(this.props, function(t, r) {
    u.include(Ho, r) || (e[r] = t);
  }), e;
};
M.prototype.load = function() {
  if (!this.disabled) {
    var e = this.storage.parse(this.name);
    e && (this.props = u.extend({}, e));
  }
};
M.prototype.upgrade = function() {
  var e, t;
  this.storage === u.localStorage ? (e = u.cookie.parse(this.name), u.cookie.remove(this.name), u.cookie.remove(this.name, !0), e && this.register_once(e)) : this.storage === u.cookie && (t = u.localStorage.parse(this.name), u.localStorage.remove(this.name), t && this.register_once(t));
};
M.prototype.save = function() {
  this.disabled || this.storage.set(
    this.name,
    u.JSONEncode(this.props),
    this.expire_days,
    this.cross_subdomain,
    this.secure,
    this.cross_site,
    this.cookie_domain
  );
};
M.prototype.load_prop = function(e) {
  return this.load(), this.props[e];
};
M.prototype.remove = function() {
  this.storage.remove(this.name, !1, this.cookie_domain), this.storage.remove(this.name, !0, this.cookie_domain);
};
M.prototype.clear = function() {
  this.remove(), this.props = {};
};
M.prototype.register_once = function(e, t, r) {
  return u.isObject(e) ? (typeof t > "u" && (t = "None"), this.expire_days = typeof r > "u" ? this.default_expiry : r, this.load(), u.each(e, function(i, n) {
    (!this.props.hasOwnProperty(n) || this.props[n] === t) && (this.props[n] = i);
  }, this), this.save(), !0) : !1;
};
M.prototype.register = function(e, t) {
  return u.isObject(e) ? (this.expire_days = typeof t > "u" ? this.default_expiry : t, this.load(), u.extend(this.props, e), this.save(), !0) : !1;
};
M.prototype.unregister = function(e) {
  this.load(), e in this.props && (delete this.props[e], this.save());
};
M.prototype.update_search_keyword = function(e) {
  this.register(u.info.searchInfo(e));
};
M.prototype.update_referrer_info = function(e) {
  this.register_once({
    $initial_referrer: e || "$direct",
    $initial_referring_domain: u.info.referringDomain(e) || "$direct"
  }, "");
};
M.prototype.get_referrer_info = function() {
  return u.strip_empty_properties({
    $initial_referrer: this.props.$initial_referrer,
    $initial_referring_domain: this.props.$initial_referring_domain
  });
};
M.prototype.update_config = function(e) {
  this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cookie_domain(e.cookie_domain), this.set_cross_site(e.cross_site_cookie), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie);
};
M.prototype.set_disabled = function(e) {
  this.disabled = e, this.disabled ? this.remove() : this.save();
};
M.prototype.set_cookie_domain = function(e) {
  e !== this.cookie_domain && (this.remove(), this.cookie_domain = e, this.save());
};
M.prototype.set_cross_site = function(e) {
  e !== this.cross_site && (this.cross_site = e, this.remove(), this.save());
};
M.prototype.set_cross_subdomain = function(e) {
  e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
};
M.prototype.get_cross_subdomain = function() {
  return this.cross_subdomain;
};
M.prototype.set_secure = function(e) {
  e !== this.secure && (this.secure = !!e, this.remove(), this.save());
};
M.prototype._add_to_people_queue = function(e, t) {
  var r = this._get_queue_key(e), i = t[e], n = this._get_or_create_queue(Ie), s = this._get_or_create_queue(Ze), o = this._get_or_create_queue(se), c = this._get_or_create_queue(Pe), a = this._get_or_create_queue(qe), f = this._get_or_create_queue(be, []), l = this._get_or_create_queue(he, []);
  r === kr ? (u.extend(n, i), this._pop_from_people_queue(Pe, i), this._pop_from_people_queue(qe, i), this._pop_from_people_queue(se, i)) : r === Er ? (u.each(i, function(d, p) {
    p in s || (s[p] = d);
  }), this._pop_from_people_queue(se, i)) : r === Or ? u.each(i, function(d) {
    u.each([n, s, c, a], function(p) {
      d in p && delete p[d];
    }), u.each(l, function(p) {
      d in p && delete p[d];
    }), o[d] = !0;
  }) : r === Ir ? (u.each(i, function(d, p) {
    p in n ? n[p] += d : (p in c || (c[p] = 0), c[p] += d);
  }, this), this._pop_from_people_queue(se, i)) : r === Tr ? (u.each(i, function(d, p) {
    u.isArray(d) && (p in a || (a[p] = []), a[p] = a[p].concat(d));
  }), this._pop_from_people_queue(se, i)) : r === Cr ? (f.push(i), this._pop_from_people_queue(he, i)) : r === Mr && (l.push(i), this._pop_from_people_queue(se, i)), L.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):"), L.log(t), this.save();
};
M.prototype._pop_from_people_queue = function(e, t) {
  var r = this.props[this._get_queue_key(e)];
  u.isUndefined(r) || u.each(t, function(i, n) {
    e === he || e === be ? u.each(r, function(s) {
      s[n] === i && delete s[n];
    }) : delete r[n];
  }, this);
};
M.prototype.load_queue = function(e) {
  return this.load_prop(this._get_queue_key(e));
};
M.prototype._get_queue_key = function(e) {
  if (e === Ie)
    return kr;
  if (e === Ze)
    return Er;
  if (e === se)
    return Or;
  if (e === Pe)
    return Ir;
  if (e === he)
    return Mr;
  if (e === be)
    return Cr;
  if (e === qe)
    return Tr;
  L.error("Invalid queue:", e);
};
M.prototype._get_or_create_queue = function(e, t) {
  var r = this._get_queue_key(e);
  return t = u.isUndefined(t) ? {} : t, this.props[r] || (this.props[r] = t);
};
M.prototype.set_event_timer = function(e, t) {
  var r = this.load_prop(ut) || {};
  r[e] = t, this.props[ut] = r, this.save();
};
M.prototype.remove_event_timer = function(e) {
  var t = this.load_prop(ut) || {}, r = t[e];
  return u.isUndefined(r) || (delete this.props[ut][e], this.save()), r;
};
var Dr, an = function(e, t) {
  throw new Error(e + " not available in this build.");
}, Y, un = 0, Vo = 1, Go = function(e) {
  return e;
}, ct = function() {
}, re = "mixpanel", cn = "base64", Yo = "json", Nr = "$device:", Xe = k.XMLHttpRequest && "withCredentials" in new XMLHttpRequest(), ln = !Xe && pe.indexOf("MSIE") === -1 && pe.indexOf("Mozilla") === -1, Ut = null;
Ee.sendBeacon && (Ut = function() {
  return Ee.sendBeacon.apply(Ee, arguments);
});
var fn = {
  track: "track/",
  engage: "engage/",
  groups: "groups/",
  record: "record/"
}, hi = {
  api_host: "https://api-js.mixpanel.com",
  api_routes: fn,
  api_method: "POST",
  api_transport: "XHR",
  api_payload_format: cn,
  app_host: "https://mixpanel.com",
  cdn: "https://cdn.mxpnl.com",
  cross_site_cookie: !1,
  cross_subdomain_cookie: !0,
  error_reporter: ct,
  persistence: "cookie",
  persistence_name: "",
  cookie_domain: "",
  cookie_name: "",
  loaded: ct,
  mp_loader: null,
  track_marketing: !0,
  track_pageview: !1,
  skip_first_touch_marketing: !1,
  store_google: !0,
  stop_utm_persistence: !1,
  save_referrer: !0,
  test: !1,
  verbose: !1,
  img: !1,
  debug: !1,
  track_links_timeout: 300,
  cookie_expiration: 365,
  upgrade: !1,
  disable_persistence: !1,
  disable_cookie: !1,
  secure_cookie: !1,
  ip: !0,
  opt_out_tracking_by_default: !1,
  opt_out_persistence_by_default: !1,
  opt_out_tracking_persistence_type: "localStorage",
  opt_out_tracking_cookie_prefix: null,
  property_blacklist: [],
  xhr_headers: {},
  // { header: value, header2: value }
  ignore_dnt: !1,
  batch_requests: !0,
  batch_size: 50,
  batch_flush_interval_ms: 5e3,
  batch_request_timeout_ms: 9e4,
  batch_autostart: !0,
  hooks: {},
  record_block_class: new RegExp("^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$"),
  record_block_selector: "img, video",
  record_collect_fonts: !1,
  record_idle_timeout_ms: 30 * 60 * 1e3,
  // 30 minutes
  record_inline_images: !1,
  record_mask_text_class: new RegExp("^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$"),
  record_mask_text_selector: "*",
  record_max_ms: nt,
  record_min_ms: 0,
  record_sessions_percent: 0,
  recorder_src: "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
}, dn = !1, g = function() {
}, hr = function(e, t, r) {
  var i, n = r === re ? Y : Y[r];
  if (n && Dr === un)
    i = n;
  else {
    if (n && !u.isArray(n)) {
      L.error("You have already initialized " + r);
      return;
    }
    i = new g();
  }
  if (i._cached_groups = {}, i._init(e, t, r), i.people = new E(), i.people._init(i), !i.get_config("skip_first_touch_marketing")) {
    var s = u.info.campaignParams(null), o = {}, c = !1;
    u.each(s, function(a, f) {
      o["initial_" + f] = a, a && (c = !0);
    }), c && i.people.set_once(o);
  }
  return ve.DEBUG = ve.DEBUG || i.get_config("debug"), !u.isUndefined(n) && u.isArray(n) && (i._execute_array.call(i.people, n.people), i._execute_array(n)), i;
};
g.prototype.init = function(e, t, r) {
  if (u.isUndefined(r)) {
    this.report_error("You must name your new library: init(token, config, name)");
    return;
  }
  if (r === re) {
    this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
    return;
  }
  var i = hr(e, t, r);
  return Y[r] = i, i._loaded(), i;
};
g.prototype._init = function(e, t, r) {
  t = t || {}, this.__loaded = !0, this.config = {};
  var i = {};
  if (!("api_payload_format" in t)) {
    var n = t.api_host || hi.api_host;
    n.match(/\.mixpanel\.com/) && (i.api_payload_format = Yo);
  }
  if (this.set_config(u.extend({}, hi, i, t, {
    name: r,
    token: e,
    callback_fn: (r === re ? r : re + "." + r) + "._jsc"
  })), this._jsc = ct, this.__dom_loaded_queue = [], this.__request_queue = [], this.__disabled_events = [], this._flags = {
    disable_all_events: !1,
    identify_called: !1
  }, this.request_batchers = {}, this._batch_requests = this.get_config("batch_requests"), this._batch_requests) {
    if (!u.localStorage.is_supported(!0) || !Xe)
      this._batch_requests = !1, L.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support"), u.each(this.get_batcher_configs(), function(a) {
        L.log("Clearing batch queue " + a.queue_key), u.localStorage.remove(a.queue_key);
      });
    else if (this.init_batchers(), Ut && k.addEventListener) {
      var s = u.bind(function() {
        this.request_batchers.events.stopped || this.request_batchers.events.flush({ unloading: !0 });
      }, this);
      k.addEventListener("pagehide", function(a) {
        a.persisted && s();
      }), k.addEventListener("visibilitychange", function() {
        P.visibilityState === "hidden" && s();
      });
    }
  }
  this.persistence = this.cookie = new M(this.config), this.unpersisted_superprops = {}, this._gdpr_init();
  var o = u.UUID();
  this.get_distinct_id() || this.register_once({
    distinct_id: Nr + o,
    $device_id: o
  }, "");
  var c = this.get_config("track_pageview");
  c && this._init_url_change_tracking(c), this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent") && this.start_session_recording();
};
g.prototype.start_session_recording = Me(function() {
  if (!k.MutationObserver) {
    L.critical("Browser does not support MutationObserver; skipping session recording");
    return;
  }
  var e = u.bind(function() {
    this._recorder = this._recorder || new k.__mp_recorder(this), this._recorder.startRecording();
  }, this);
  u.isUndefined(k.__mp_recorder) ? an(this.get_config("recorder_src"), e) : e();
});
g.prototype.stop_session_recording = function() {
  this._recorder ? this._recorder.stopRecording() : L.critical("Session recorder module not loaded");
};
g.prototype.get_session_recording_properties = function() {
  var e = {};
  if (this._recorder) {
    var t = this._recorder.replayId;
    t && (e.$mp_replay_id = t);
  }
  return e;
};
g.prototype._loaded = function() {
  if (this.get_config("loaded")(this), this._set_default_superprops(), this.people.set_once(this.persistence.get_referrer_info()), this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
    var e = u.info.campaignParams(null);
    u.each(e, (function(t, r) {
      this.unregister(r);
    }).bind(this));
  }
};
g.prototype._set_default_superprops = function() {
  this.persistence.update_search_keyword(P.referrer), this.get_config("store_google") && !this.get_config("stop_utm_persistence") && this.register(u.info.campaignParams()), this.get_config("save_referrer") && this.persistence.update_referrer_info(P.referrer);
};
g.prototype._dom_loaded = function() {
  u.each(this.__dom_loaded_queue, function(e) {
    this._track_dom.apply(this, e);
  }, this), this.has_opted_out_tracking() || u.each(this.__request_queue, function(e) {
    this._send_request.apply(this, e);
  }, this), delete this.__dom_loaded_queue, delete this.__request_queue;
};
g.prototype._track_dom = function(e, t) {
  if (this.get_config("img"))
    return this.report_error("You can't use DOM tracking functions with img = true."), !1;
  if (!dn)
    return this.__dom_loaded_queue.push([e, t]), !1;
  var r = new e().init(this);
  return r.track.apply(r, t);
};
g.prototype._init_url_change_tracking = function(e) {
  var t = "", r = this.track_pageview();
  if (r && (t = u.info.currentUrl()), u.include(["full-url", "url-with-path-and-query-string", "url-with-path"], e)) {
    k.addEventListener("popstate", function() {
      k.dispatchEvent(new Event("mp_locationchange"));
    }), k.addEventListener("hashchange", function() {
      k.dispatchEvent(new Event("mp_locationchange"));
    });
    var i = k.history.pushState;
    typeof i == "function" && (k.history.pushState = function(s, o, c) {
      i.call(k.history, s, o, c), k.dispatchEvent(new Event("mp_locationchange"));
    });
    var n = k.history.replaceState;
    typeof n == "function" && (k.history.replaceState = function(s, o, c) {
      n.call(k.history, s, o, c), k.dispatchEvent(new Event("mp_locationchange"));
    }), k.addEventListener("mp_locationchange", (function() {
      var s = u.info.currentUrl(), o = !1;
      if (e === "full-url" ? o = s !== t : e === "url-with-path-and-query-string" ? o = s.split("#")[0] !== t.split("#")[0] : e === "url-with-path" && (o = s.split("#")[0].split("?")[0] !== t.split("#")[0].split("?")[0]), o) {
        var c = this.track_pageview();
        c && (t = s);
      }
    }).bind(this));
  }
};
g.prototype._prepare_callback = function(e, t) {
  if (u.isUndefined(e))
    return null;
  if (Xe) {
    var r = function(o) {
      e(o, t);
    };
    return r;
  } else {
    var i = this._jsc, n = "" + Math.floor(Math.random() * 1e8), s = this.get_config("callback_fn") + "[" + n + "]";
    return i[n] = function(o) {
      delete i[n], e(o, t);
    }, s;
  }
};
g.prototype._send_request = function(e, t, r, i) {
  var n = !0;
  if (ln)
    return this.__request_queue.push(arguments), n;
  var s = {
    method: this.get_config("api_method"),
    transport: this.get_config("api_transport"),
    verbose: this.get_config("verbose")
  }, o = null;
  !i && (u.isFunction(r) || typeof r == "string") && (i = r, r = null), r = u.extend(s, r || {}), Xe || (r.method = "GET");
  var c = r.method === "POST", a = Ut && c && r.transport.toLowerCase() === "sendbeacon", f = r.verbose;
  t.verbose && (f = !0), this.get_config("test") && (t.test = 1), f && (t.verbose = 1), this.get_config("img") && (t.img = 1), Xe || (i ? t.callback = i : (f || this.get_config("test")) && (t.callback = "(function(){})")), t.ip = this.get_config("ip") ? 1 : 0, t._ = (/* @__PURE__ */ new Date()).getTime().toString(), c && (o = "data=" + encodeURIComponent(t.data), delete t.data), e += "?" + u.HTTPBuildQuery(t);
  var l = this;
  if ("img" in t) {
    var d = P.createElement("img");
    d.src = e, P.body.appendChild(d);
  } else if (a) {
    try {
      n = Ut(e, o);
    } catch (v) {
      l.report_error(v), n = !1;
    }
    try {
      i && i(n ? 1 : 0);
    } catch (v) {
      l.report_error(v);
    }
  } else if (Xe)
    try {
      var p = new XMLHttpRequest();
      p.open(r.method, e, !0);
      var h = this.get_config("xhr_headers");
      if (c && (h["Content-Type"] = "application/x-www-form-urlencoded"), u.each(h, function(v, S) {
        p.setRequestHeader(S, v);
      }), r.timeout_ms && typeof p.timeout < "u") {
        p.timeout = r.timeout_ms;
        var m = (/* @__PURE__ */ new Date()).getTime();
      }
      p.withCredentials = !0, p.onreadystatechange = function() {
        if (p.readyState === 4)
          if (p.status === 200) {
            if (i)
              if (f) {
                var v;
                try {
                  v = u.JSONDecode(p.responseText);
                } catch (w) {
                  if (l.report_error(w), r.ignore_json_errors)
                    v = p.responseText;
                  else
                    return;
                }
                i(v);
              } else
                i(Number(p.responseText));
          } else {
            var S;
            if (p.timeout && !p.status && (/* @__PURE__ */ new Date()).getTime() - m >= p.timeout ? S = "timeout" : S = "Bad HTTP status: " + p.status + " " + p.statusText, l.report_error(S), i)
              if (f) {
                var b = p.responseHeaders || {};
                i({ status: 0, httpStatusCode: p.status, error: S, retryAfter: b["Retry-After"] });
              } else
                i(0);
          }
      }, p.send(o);
    } catch (v) {
      l.report_error(v), n = !1;
    }
  else {
    var _ = P.createElement("script");
    _.type = "text/javascript", _.async = !0, _.defer = !0, _.src = e;
    var y = P.getElementsByTagName("script")[0];
    y.parentNode.insertBefore(_, y);
  }
  return n;
};
g.prototype._execute_array = function(e) {
  var t, r = [], i = [], n = [];
  u.each(e, function(o) {
    o && (t = o[0], u.isArray(t) ? n.push(o) : typeof o == "function" ? o.call(this) : u.isArray(o) && t === "alias" ? r.push(o) : u.isArray(o) && t.indexOf("track") !== -1 && typeof this[t] == "function" ? n.push(o) : i.push(o));
  }, this);
  var s = function(o, c) {
    u.each(o, function(a) {
      if (u.isArray(a[0])) {
        var f = c;
        u.each(a, function(l) {
          f = f[l[0]].apply(f, l.slice(1));
        });
      } else
        this[a[0]].apply(this, a.slice(1));
    }, c);
  };
  s(r, this), s(i, this), s(n, this);
};
g.prototype.are_batchers_initialized = function() {
  return !!this.request_batchers.events;
};
g.prototype.get_batcher_configs = function() {
  var e = "__mpq_" + this.get_config("token"), t = this.get_config("api_routes");
  return this._batcher_configs = this._batcher_configs || {
    events: { type: "events", endpoint: "/" + t.track, queue_key: e + "_ev" },
    people: { type: "people", endpoint: "/" + t.engage, queue_key: e + "_pp" },
    groups: { type: "groups", endpoint: "/" + t.groups, queue_key: e + "_gr" }
  }, this._batcher_configs;
};
g.prototype.init_batchers = function() {
  if (!this.are_batchers_initialized()) {
    var e = u.bind(function(r) {
      return new ae(
        r.queue_key,
        {
          libConfig: this.config,
          errorReporter: this.get_config("error_reporter"),
          sendRequestFunc: u.bind(function(i, n, s) {
            this._send_request(
              this.get_config("api_host") + r.endpoint,
              this._encode_data_for_request(i),
              n,
              this._prepare_callback(s, i)
            );
          }, this),
          beforeSendHook: u.bind(function(i) {
            return this._run_hook("before_send_" + r.type, i);
          }, this),
          stopAllBatchingFunc: u.bind(this.stop_batch_senders, this),
          usePersistence: !0
        }
      );
    }, this), t = this.get_batcher_configs();
    this.request_batchers = {
      events: e(t.events),
      people: e(t.people),
      groups: e(t.groups)
    };
  }
  this.get_config("batch_autostart") && this.start_batch_senders();
};
g.prototype.start_batch_senders = function() {
  this._batchers_were_started = !0, this.are_batchers_initialized() && (this._batch_requests = !0, u.each(this.request_batchers, function(e) {
    e.start();
  }));
};
g.prototype.stop_batch_senders = function() {
  this._batch_requests = !1, u.each(this.request_batchers, function(e) {
    e.stop(), e.clear();
  });
};
g.prototype.push = function(e) {
  this._execute_array([e]);
};
g.prototype.disable = function(e) {
  typeof e > "u" ? this._flags.disable_all_events = !0 : this.__disabled_events = this.__disabled_events.concat(e);
};
g.prototype._encode_data_for_request = function(e) {
  var t = u.JSONEncode(e);
  return this.get_config("api_payload_format") === cn && (t = u.base64Encode(t)), { data: t };
};
g.prototype._track_or_batch = function(e, t) {
  var r = u.truncate(e.data, 255), i = e.endpoint, n = e.batcher, s = e.should_send_immediately, o = e.send_request_options || {};
  t = t || ct;
  var c = !0, a = u.bind(function() {
    return o.skip_hooks || (r = this._run_hook("before_send_" + e.type, r)), r ? (L.log("MIXPANEL REQUEST:"), L.log(r), this._send_request(
      i,
      this._encode_data_for_request(r),
      o,
      this._prepare_callback(t, r)
    )) : null;
  }, this);
  return this._batch_requests && !s ? n.enqueue(r, function(f) {
    f ? t(1, r) : a();
  }) : c = a(), c && r;
};
g.prototype.track = Me(function(e, t, r, i) {
  !i && typeof r == "function" && (i = r, r = null), r = r || {};
  var n = r.transport;
  n && (r.transport = n);
  var s = r.send_immediately;
  if (typeof i != "function" && (i = ct), u.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.track");
    return;
  }
  if (this._event_is_disabled(e)) {
    i(0);
    return;
  }
  t = u.extend({}, t), t.token = this.get_config("token");
  var o = this.persistence.remove_event_timer(e);
  if (!u.isUndefined(o)) {
    var c = (/* @__PURE__ */ new Date()).getTime() - o;
    t.$duration = parseFloat((c / 1e3).toFixed(3));
  }
  this._set_default_superprops();
  var a = this.get_config("track_marketing") ? u.info.marketingParams() : {};
  t = u.extend(
    {},
    u.info.properties({ mp_loader: this.get_config("mp_loader") }),
    a,
    this.persistence.properties(),
    this.unpersisted_superprops,
    this.get_session_recording_properties(),
    t
  );
  var f = this.get_config("property_blacklist");
  u.isArray(f) ? u.each(f, function(p) {
    delete t[p];
  }) : this.report_error("Invalid value for property_blacklist config: " + f);
  var l = {
    event: e,
    properties: t
  }, d = this._track_or_batch({
    type: "events",
    data: l,
    endpoint: this.get_config("api_host") + "/" + this.get_config("api_routes").track,
    batcher: this.request_batchers.events,
    should_send_immediately: s,
    send_request_options: r
  }, i);
  return d;
});
g.prototype.set_group = Me(function(e, t, r) {
  u.isArray(t) || (t = [t]);
  var i = {};
  return i[e] = t, this.register(i), this.people.set(e, t, r);
});
g.prototype.add_group = Me(function(e, t, r) {
  var i = this.get_property(e), n = {};
  return i === void 0 ? (n[e] = [t], this.register(n)) : i.indexOf(t) === -1 && (i.push(t), n[e] = i, this.register(n)), this.people.union(e, t, r);
});
g.prototype.remove_group = Me(function(e, t, r) {
  var i = this.get_property(e);
  if (i !== void 0) {
    var n = i.indexOf(t);
    n > -1 && (i.splice(n, 1), this.register({ group_key: i })), i.length === 0 && this.unregister(e);
  }
  return this.people.remove(e, t, r);
});
g.prototype.track_with_groups = Me(function(e, t, r, i) {
  var n = u.extend({}, t || {});
  return u.each(r, function(s, o) {
    s != null && (n[o] = s);
  }), this.track(e, n, i);
});
g.prototype._create_map_key = function(e, t) {
  return e + "_" + JSON.stringify(t);
};
g.prototype._remove_group_from_cache = function(e, t) {
  delete this._cached_groups[this._create_map_key(e, t)];
};
g.prototype.get_group = function(e, t) {
  var r = this._create_map_key(e, t), i = this._cached_groups[r];
  return (i === void 0 || i._group_key !== e || i._group_id !== t) && (i = new j(), i._init(this, e, t), this._cached_groups[r] = i), i;
};
g.prototype.track_pageview = Me(function(e, t) {
  typeof e != "object" && (e = {}), t = t || {};
  var r = t.event_name || "$mp_web_page_view", i = u.extend(
    u.info.mpPageViewProperties(),
    u.info.campaignParams(),
    u.info.clickParams()
  ), n = u.extend(
    {},
    i,
    e
  );
  return this.track(r, n);
});
g.prototype.track_links = function() {
  return this._track_dom.call(this, Je, arguments);
};
g.prototype.track_forms = function() {
  return this._track_dom.call(this, Ht, arguments);
};
g.prototype.time_event = function(e) {
  if (u.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.time_event");
    return;
  }
  this._event_is_disabled(e) || this.persistence.set_event_timer(e, (/* @__PURE__ */ new Date()).getTime());
};
var Xo = {
  persistent: !0
}, Rr = function(e) {
  var t;
  return u.isObject(e) ? t = e : u.isUndefined(e) ? t = {} : t = { days: e }, u.extend({}, Xo, t);
};
g.prototype.register = function(e, t) {
  var r = Rr(t);
  r.persistent ? this.persistence.register(e, r.days) : u.extend(this.unpersisted_superprops, e);
};
g.prototype.register_once = function(e, t, r) {
  var i = Rr(r);
  i.persistent ? this.persistence.register_once(e, t, i.days) : (typeof t > "u" && (t = "None"), u.each(e, function(n, s) {
    (!this.unpersisted_superprops.hasOwnProperty(s) || this.unpersisted_superprops[s] === t) && (this.unpersisted_superprops[s] = n);
  }, this));
};
g.prototype.unregister = function(e, t) {
  t = Rr(t), t.persistent ? this.persistence.unregister(e) : delete this.unpersisted_superprops[e];
};
g.prototype._register_single = function(e, t) {
  var r = {};
  r[e] = t, this.register(r);
};
g.prototype.identify = function(e, t, r, i, n, s, o, c) {
  var a = this.get_distinct_id();
  if (e && a !== e) {
    if (typeof e == "string" && e.indexOf(Nr) === 0)
      return this.report_error("distinct_id cannot have $device: prefix"), -1;
    this.register({ $user_id: e });
  }
  if (!this.get_property("$device_id")) {
    var f = a;
    this.register_once({
      $had_persisted_distinct_id: !0,
      $device_id: f
    }, "");
  }
  e !== a && e !== this.get_property(qt) && (this.unregister(qt), this.register({ distinct_id: e })), this._flags.identify_called = !0, this.people._flush(t, r, i, n, s, o, c), e !== a && this.track("$identify", {
    distinct_id: e,
    $anon_distinct_id: a
  }, { skip_hooks: !0 });
};
g.prototype.reset = function() {
  this.persistence.clear(), this._flags.identify_called = !1;
  var e = u.UUID();
  this.register_once({
    distinct_id: Nr + e,
    $device_id: e
  }, "");
};
g.prototype.get_distinct_id = function() {
  return this.get_property("distinct_id");
};
g.prototype.alias = function(e, t) {
  if (e === this.get_property(on))
    return this.report_error("Attempting to create alias for existing People user - aborting."), -2;
  var r = this;
  return u.isUndefined(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single(qt, e), this.track("$create_alias", {
    alias: e,
    distinct_id: t
  }, {
    skip_hooks: !0
  }, function() {
    r.identify(e);
  })) : (this.report_error("alias matches current distinct_id - skipping api call."), this.identify(e), -1);
};
g.prototype.name_tag = function(e) {
  this._register_single("mp_name_tag", e);
};
g.prototype.set_config = function(e) {
  if (u.isObject(e)) {
    u.extend(this.config, e);
    var t = e.batch_size;
    t && u.each(this.request_batchers, function(r) {
      r.resetBatchSize();
    }), this.get_config("persistence_name") || (this.config.persistence_name = this.config.cookie_name), this.get_config("disable_persistence") || (this.config.disable_persistence = this.config.disable_cookie), this.persistence && this.persistence.update_config(this.config), ve.DEBUG = ve.DEBUG || this.get_config("debug");
  }
};
g.prototype.get_config = function(e) {
  return this.config[e];
};
g.prototype._run_hook = function(e) {
  var t = (this.config.hooks[e] || Go).apply(this, ke.call(arguments, 1));
  return typeof t > "u" && (this.report_error(e + " hook did not return a value"), t = null), t;
};
g.prototype.get_property = function(e) {
  return this.persistence.load_prop([e]);
};
g.prototype.toString = function() {
  var e = this.get_config("name");
  return e !== re && (e = re + "." + e), e;
};
g.prototype._event_is_disabled = function(e) {
  return u.isBlockedUA(pe) || this._flags.disable_all_events || u.include(this.__disabled_events, e);
};
g.prototype._gdpr_init = function() {
  var e = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
  e && u.localStorage.is_supported() && (!this.has_opted_in_tracking() && this.has_opted_in_tracking({ persistence_type: "cookie" }) && this.opt_in_tracking({ enable_persistence: !1 }), !this.has_opted_out_tracking() && this.has_opted_out_tracking({ persistence_type: "cookie" }) && this.opt_out_tracking({ clear_persistence: !1 }), this.clear_opt_in_out_tracking({
    persistence_type: "cookie",
    enable_persistence: !1
  })), this.has_opted_out_tracking() ? this._gdpr_update_persistence({ clear_persistence: !0 }) : !this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || u.cookie.get("mp_optout")) && (u.cookie.remove("mp_optout"), this.opt_out_tracking({
    clear_persistence: this.get_config("opt_out_persistence_by_default")
  }));
};
g.prototype._gdpr_update_persistence = function(e) {
  var t;
  if (e && e.clear_persistence)
    t = !0;
  else if (e && e.enable_persistence)
    t = !1;
  else
    return;
  !this.get_config("disable_persistence") && this.persistence.disabled !== t && this.persistence.set_disabled(t), t ? this.stop_batch_senders() : this._batchers_were_started && this.start_batch_senders();
};
g.prototype._gdpr_call_func = function(e, t) {
  return t = u.extend({
    track: u.bind(this.track, this),
    persistence_type: this.get_config("opt_out_tracking_persistence_type"),
    cookie_prefix: this.get_config("opt_out_tracking_cookie_prefix"),
    cookie_expiration: this.get_config("cookie_expiration"),
    cross_site_cookie: this.get_config("cross_site_cookie"),
    cross_subdomain_cookie: this.get_config("cross_subdomain_cookie"),
    cookie_domain: this.get_config("cookie_domain"),
    secure_cookie: this.get_config("secure_cookie"),
    ignore_dnt: this.get_config("ignore_dnt")
  }, t), u.localStorage.is_supported() || (t.persistence_type = "cookie"), e(this.get_config("token"), {
    track: t.track,
    trackEventName: t.track_event_name,
    trackProperties: t.track_properties,
    persistenceType: t.persistence_type,
    persistencePrefix: t.cookie_prefix,
    cookieDomain: t.cookie_domain,
    cookieExpiration: t.cookie_expiration,
    crossSiteCookie: t.cross_site_cookie,
    crossSubdomainCookie: t.cross_subdomain_cookie,
    secureCookie: t.secure_cookie,
    ignoreDnt: t.ignore_dnt
  });
};
g.prototype.opt_in_tracking = function(e) {
  e = u.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(Ao, e), this._gdpr_update_persistence(e);
};
g.prototype.opt_out_tracking = function(e) {
  e = u.extend({
    clear_persistence: !0,
    delete_user: !0
  }, e), e.delete_user && this.people && this.people._identify_called() && (this.people.delete_user(), this.people.clear_charges()), this._gdpr_call_func(Fo, e), this._gdpr_update_persistence(e);
};
g.prototype.has_opted_in_tracking = function(e) {
  return this._gdpr_call_func(Lo, e);
};
g.prototype.has_opted_out_tracking = function(e) {
  return this._gdpr_call_func(en, e);
};
g.prototype.clear_opt_in_out_tracking = function(e) {
  e = u.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func($o, e), this._gdpr_update_persistence(e);
};
g.prototype.report_error = function(e, t) {
  L.error.apply(L.error, arguments);
  try {
    !t && !(e instanceof Error) && (e = new Error(e)), this.get_config("error_reporter")(e, t);
  } catch (r) {
    L.error(r);
  }
};
g.prototype.init = g.prototype.init;
g.prototype.reset = g.prototype.reset;
g.prototype.disable = g.prototype.disable;
g.prototype.time_event = g.prototype.time_event;
g.prototype.track = g.prototype.track;
g.prototype.track_links = g.prototype.track_links;
g.prototype.track_forms = g.prototype.track_forms;
g.prototype.track_pageview = g.prototype.track_pageview;
g.prototype.register = g.prototype.register;
g.prototype.register_once = g.prototype.register_once;
g.prototype.unregister = g.prototype.unregister;
g.prototype.identify = g.prototype.identify;
g.prototype.alias = g.prototype.alias;
g.prototype.name_tag = g.prototype.name_tag;
g.prototype.set_config = g.prototype.set_config;
g.prototype.get_config = g.prototype.get_config;
g.prototype.get_property = g.prototype.get_property;
g.prototype.get_distinct_id = g.prototype.get_distinct_id;
g.prototype.toString = g.prototype.toString;
g.prototype.opt_out_tracking = g.prototype.opt_out_tracking;
g.prototype.opt_in_tracking = g.prototype.opt_in_tracking;
g.prototype.has_opted_out_tracking = g.prototype.has_opted_out_tracking;
g.prototype.has_opted_in_tracking = g.prototype.has_opted_in_tracking;
g.prototype.clear_opt_in_out_tracking = g.prototype.clear_opt_in_out_tracking;
g.prototype.get_group = g.prototype.get_group;
g.prototype.set_group = g.prototype.set_group;
g.prototype.add_group = g.prototype.add_group;
g.prototype.remove_group = g.prototype.remove_group;
g.prototype.track_with_groups = g.prototype.track_with_groups;
g.prototype.start_batch_senders = g.prototype.start_batch_senders;
g.prototype.stop_batch_senders = g.prototype.stop_batch_senders;
g.prototype.start_session_recording = g.prototype.start_session_recording;
g.prototype.stop_session_recording = g.prototype.stop_session_recording;
g.prototype.get_session_recording_properties = g.prototype.get_session_recording_properties;
g.prototype.DEFAULT_API_ROUTES = fn;
M.prototype.properties = M.prototype.properties;
M.prototype.update_search_keyword = M.prototype.update_search_keyword;
M.prototype.update_referrer_info = M.prototype.update_referrer_info;
M.prototype.get_cross_subdomain = M.prototype.get_cross_subdomain;
M.prototype.clear = M.prototype.clear;
var Ye = {}, Ko = function() {
  u.each(Ye, function(e, t) {
    t !== re && (Y[t] = e);
  }), Y._ = u;
}, Jo = function() {
  Y.init = function(e, t, r) {
    if (r)
      return Y[r] || (Y[r] = Ye[r] = hr(e, t, r), Y[r]._loaded()), Y[r];
    var i = Y;
    Ye[re] ? i = Ye[re] : e && (i = hr(e, t, re), i._loaded(), Ye[re] = i), Y = i, Dr === Vo && (k[re] = Y), Ko();
  };
}, Zo = function() {
  function e() {
    e.done || (e.done = !0, dn = !0, ln = !1, u.each(Ye, function(i) {
      i._dom_loaded();
    }));
  }
  function t() {
    try {
      P.documentElement.doScroll("left");
    } catch {
      setTimeout(t, 1);
      return;
    }
    e();
  }
  if (P.addEventListener)
    P.readyState === "complete" ? e() : P.addEventListener("DOMContentLoaded", e, !1);
  else if (P.attachEvent) {
    P.attachEvent("onreadystatechange", e);
    var r = !1;
    try {
      r = k.frameElement === null;
    } catch {
    }
    P.documentElement.doScroll && r && t();
  }
  u.register_event(k, "load", e, !0);
};
function Qo(e) {
  return an = e, Dr = un, Y = new g(), Jo(), Y.init(), Zo(), Y;
}
function ea(e, t) {
  t();
}
var pn = Qo(ea);
const hn = yn.createContext({}), na = () => vn(hn);
function sa(e) {
  try {
    pn.init(e, {
      track_pageview: !1,
      persistence: "localStorage"
    });
  } catch {
  }
}
const oa = ({
  children: e,
  trackingPipelineSettings: t,
  analyticsSettings: r,
  attributes: i = {},
  meta: n
}) => {
  var f, l;
  const s = cs((t == null ? void 0 : t.apiKey) ?? ""), [o] = bn({
    ll_product_name: n.productName,
    ll_product_version: n.productVersion,
    ll_client_id: n.clientId,
    ll_locale: i.locale,
    ll_location_lat: (f = i.location) == null ? void 0 : f.lat,
    ll_location_lng: (l = i.location) == null ? void 0 : l.lng
  }), c = ({ eventType: d, eventAttributes: p }) => {
    s.postEvent({
      event_type: d,
      event_version: "1.0.0",
      meta: {
        product_version: n.productVersion,
        product_name: n.productName || "",
        client_id: n.clientId
      },
      isTestEvent: process.env.NODE_ENV !== "production",
      attributes: {
        event_attributes: p,
        ...i
      }
    });
  }, a = ({ eventName: d, eventAttributes: p = {} }) => {
    if (!(typeof r > "u" || r.tracker !== "mixpanel") && (r.printDebugMode && console.info("Mixpanel Debug:", {
      event: d,
      projectToken: r.key,
      properties: {
        ...p,
        ...o
      }
    }), !r.isDebugMode))
      try {
        pn.track(d, {
          ...p,
          ...o
        });
      } catch {
      }
  };
  return /* @__PURE__ */ gn(hn.Provider, { value: { postEvent: c, trackAnalyticsEvent: a }, children: e });
}, aa = (e) => e instanceof Oi, ua = (e) => e instanceof Ei, ca = (e) => e instanceof Ot;
export {
  cs as LocalLogicTracking,
  Ii as Methods,
  oa as TrackingProvider,
  is as eventVersion,
  sa as initializeAnalytics,
  ca as isRequestError,
  ua as isUnknownError,
  aa as isValidationError,
  na as useTracking
};
